
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kqbzb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $aeAfU = parcelRequire("aeAfU");


var $d925B = parcelRequire("d925B");





var $1oCLl = parcelRequire("1oCLl");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");




const $a8bbc3dbab143724$export$4b29030e1d9baeba = (node, previousMauiId, localId)=>{
    return node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui' && node.attrs.parameters?.macroParams?.url?.value.endsWith(previousMauiId) && (localId ? node.attrs?.localId === localId : true);
};
const $a8bbc3dbab143724$export$47dfdc23943fef4 = (attrs, previousMauiId, newMauiId)=>{
    /**
   * Some older browsers like chrome 97 doesn't support structuredClone.
   * So using JSON.parse(JSON.stringify()) as a fallback.
   */ const newAttrs = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(attrs) : JSON.parse(JSON.stringify(attrs));
    newAttrs.parameters.macroParams.url.value = newAttrs.parameters.macroParams.url.value.replace(previousMauiId, newMauiId);
    return newAttrs;
};
const $a8bbc3dbab143724$export$ff177b3b8713a3ae = ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId })=>({ tr: tr })=>{
        // Check current selection, if the node is already selected we can skip expensive document traversal
        if ((0, $8m4tT.isNodeSelection)(tr.selection) && $a8bbc3dbab143724$export$4b29030e1d9baeba(tr.selection.node, previousMauiId, localId)) {
            const node = tr.selection.node;
            const pos = tr.selection.$anchor.pos;
            tr.setNodeMarkup(pos, undefined, $a8bbc3dbab143724$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            if ((0, $dh538.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
            return tr;
        }
        // Find the first node that matches the previous MAUI App ID
        let nodeResult;
        tr.doc.descendants((node, pos)=>{
            if (nodeResult) return false;
            if ($a8bbc3dbab143724$export$4b29030e1d9baeba(node, previousMauiId, localId)) nodeResult = {
                node: node,
                pos: pos
            };
            return !nodeResult;
        });
        if (nodeResult) {
            const { node: node, pos: pos } = nodeResult;
            tr.setNodeMarkup(pos, undefined, $a8bbc3dbab143724$export$47dfdc23943fef4(node.attrs, previousMauiId, newMauiId));
            if ((0, $dh538.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
            return tr;
        }
        return null;
    };



var $qJp20 = parcelRequire("qJp20");

function $39a022d008a5be1a$export$4f422ec95246a715({ api: api, config: config }) {
    return async ({ previousMauiId: previousMauiId, newMauiId: newMauiId, localId: localId })=>{
        let idToInsert = newMauiId;
        if (!(0, $c6GJD.default).getExperimentValue('remix_maui_duplicate_stability_improvement', 'value', false)) {
            // TODO: lift these deps out of `config.diagramPaste` to top-level `PluginConfiguration` once both flows share a config surface.
            const duplicateConfig = config?.diagramPaste;
            const duplicateMauiApp = duplicateConfig?.duplicateMauiApp;
            const containerContentId = duplicateConfig?.getCurrentPageId?.();
            const contentType = duplicateConfig?.getCurrentContentType?.();
            if (duplicateMauiApp && containerContentId) {
                const experienceTracker = (0, $hUyPY.ExperienceTrackerHandler).getInstance().experienceTracker;
                const experienceAttributes = {
                    appId: newMauiId,
                    currentPageId: containerContentId,
                    source: 'mauiInlineEdit'
                };
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                    id: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                    attributes: experienceAttributes
                });
                try {
                    const { id: id, attempts: attempts, statusCode: statusCode } = await duplicateMauiApp(newMauiId, containerContentId, contentType);
                    idToInsert = id;
                    const wasNoOp = id === newMauiId;
                    $39a022d008a5be1a$var$fireAnalytics(api, {
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'succeeded',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            newId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                        attributes: {
                            ...experienceAttributes,
                            newAppId: id,
                            attempts: attempts,
                            statusCode: statusCode,
                            wasNoOp: wasNoOp
                        }
                    });
                } catch (error) {
                    const statusCode = error?.statusCode;
                    const errorCode = error?.code;
                    const attempts = error?.attempts;
                    const isPermissionError = statusCode === 403;
                    $39a022d008a5be1a$var$fireAnalytics(api, {
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                        actionSubject: 'mauiAppDuplicate',
                        action: 'failed',
                        actionSubjectId: 'mauiInlineEdit',
                        attributes: {
                            originalId: newMauiId,
                            errorMessage: error?.message,
                            isPermissionError: isPermissionError,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            attempts: attempts
                        }
                    });
                    const duplicateError = error instanceof Error ? error : new Error('Failed to duplicate MAUI app');
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts
                        }
                    });
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                        error: duplicateError,
                        attributes: {
                            ...experienceAttributes,
                            failedDueTo: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                            statusCode: statusCode,
                            errorCode: errorCode,
                            isPermissionError: isPermissionError,
                            attempts: attempts
                        }
                    });
                }
            }
        }
        api?.core?.actions.execute(({ tr: tr })=>{
            const result = (0, $a8bbc3dbab143724$export$ff177b3b8713a3ae)({
                previousMauiId: previousMauiId,
                newMauiId: idToInsert,
                localId: localId
            })({
                tr: tr
            });
            if (result && localId && (0, $1oCLl.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true)) tr.setMeta((0, $qJp20.malleableUiPluginKey), {
                addAiEditReplacementLocalId: localId
            });
            return result;
        });
        return {
            insertedMauiId: idToInsert
        };
    };
}
function $39a022d008a5be1a$var$fireAnalytics(api, payload) {
    api?.analytics?.actions.fireAnalyticsEvent(payload);
}






var $g2PXA = parcelRequire("g2PXA");


var $LSDsY = parcelRequire("LSDsY");

function $c890ce7e9574b9df$export$68002784dcd3d97({ config: config }) {
    return async (args)=>{
        if (args.targetSpace && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $c6GJD.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return;
        const diagramPaste = config?.diagramPaste;
        if (!diagramPaste) return;
        const { originalUrl: originalUrl, conversationContext: conversationContext, mode: mode, targetSpace: targetSpace } = args;
        // Use the view that owns this embed URL.
        const view = (0, $LSDsY.getMauiDiagramPasteView)(originalUrl);
        if (!view) return;
        let contentId = args.contentId;
        if (!contentId) {
            const parsed = (0, $g2PXA.parseMauiDiagramLink)(originalUrl);
            contentId = parsed?.contentId;
        }
        if (!contentId) return;
        const workflowArgs = {
            contentId: contentId,
            originalUrl: originalUrl,
            conversationContext: conversationContext,
            mode: mode,
            targetSpace: targetSpace
        };
        await (0, $LSDsY.executeMauiEmbedFinalize)(view, diagramPaste, workflowArgs);
    };
}



var $1S4f7 = parcelRequire("1S4f7");





var $9S1Tm = parcelRequire("9S1Tm");

function $c36225fce08cc928$export$4509aabcbe267be2(payload) {
    return 'previousMauiId' in payload;
}


function $4b6f0776a18b2b53$var$getMatchingStackIndex(stack, { fieldId: fieldId, url: url }) {
    if (!fieldId && !url) return -1;
    return stack.findIndex((stackEntry)=>url && stackEntry.url === url || fieldId && stackEntry.fieldId === fieldId);
}
/**
 * Find the history entry whose stack contains a step matching the given id
 * (image fieldId or MAUI app id extracted from the stack entry's URL).
 * Returns the conversation key, the entry, and the matched stack index so the
 * caller can trim redo entries above it.
 */ function $4b6f0776a18b2b53$var$findHistoryEntryByStackId(historyMap, id) {
    for (const [key, entry] of Object.entries(historyMap)){
        const stackIndex = entry.stack.findIndex((stackEntry)=>stackEntry.fieldId === id || (0, $9S1Tm.getMauiIdFromUrl)(stackEntry.url) === id);
        if (stackIndex !== -1) return {
            key: key,
            entry: entry,
            stackIndex: stackIndex
        };
    }
    return undefined;
}
function $4b6f0776a18b2b53$var$reducer(state, meta) {
    switch(meta?.type){
        // for image, the fieldId will be updated after the image is uploaded via updateRemixImageHistoryFieldId
        case 'addHistoryEntry':
            {
                const { conversationId: conversationId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, finalMessage: finalMessage, url: url, fieldId: fieldId } = meta.payload;
                const finalMessageId = (0, $9S1Tm.getFinalMessageId)(finalMessage);
                const historyEntry = {
                    conversationId: conversationId,
                    dynamicUiSource: dynamicUiSource,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        {
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: historyEntry
                    }
                };
            }
        case 'updateRemixImageHistoryFieldId':
            {
                const { conversationId: conversationId, fieldId: fieldId } = meta.payload;
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = historyEntry.stack.length - 1;
                if (currentStackIndex < 0) return state;
                const updatedHistoryEntry = {
                    ...historyEntry,
                    stack: historyEntry.stack.map((stackEntry, index)=>index === currentStackIndex ? {
                            ...stackEntry,
                            fieldId: fieldId
                        } : stackEntry)
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        case 'addHistoryStackEntry':
            {
                const { conversationId: conversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, finalMessage: finalMessage, url: url, fieldId: fieldId, previousUrl: previousUrl, previousFieldId: previousFieldId } = meta.payload;
                const finalMessageId = (0, $9S1Tm.getFinalMessageId)(finalMessage);
                const historyEntry = state.historyMap[conversationId];
                if (!historyEntry) return state;
                const currentStackIndex = $4b6f0776a18b2b53$var$getMatchingStackIndex(historyEntry.stack, {
                    url: previousUrl,
                    fieldId: previousFieldId
                });
                const stackEntriesToKeep = currentStackIndex === -1 ? historyEntry.stack : historyEntry.stack.slice(0, currentStackIndex + 1);
                const updatedHistoryEntry = {
                    ...historyEntry,
                    latestFinalMessage: finalMessage,
                    latestFinalMessageId: finalMessageId,
                    stack: [
                        ...stackEntriesToKeep,
                        {
                            dynamicUiType: dynamicUiType,
                            dynamicUiSubtype: dynamicUiSubtype,
                            finalMessage: finalMessage,
                            finalMessageId: finalMessageId,
                            url: url,
                            fieldId: fieldId
                        }
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [conversationId]: updatedHistoryEntry
                    }
                };
            }
        // Append a stack entry for a backend-initiated update (bridge stream).
        // No conversationId / finalMessage in payload — inherit both from the
        // existing entry, located by stack-id search. The payload is a
        // discriminated union: MAUI variant carries previousMauiId + new URL;
        // image variant carries previousFieldId + new fieldId.
        case 'addBackendHistoryStackEntry':
            {
                const { payload: payload } = meta;
                const isMauiPayload = (0, $c36225fce08cc928$export$4509aabcbe267be2)(payload);
                const lookupId = isMauiPayload ? payload.previousMauiId : payload.previousFieldId;
                const found = $4b6f0776a18b2b53$var$findHistoryEntryByStackId(state.historyMap, lookupId);
                if (!found) return state;
                const { key: key, entry: entry, stackIndex: stackIndex } = found;
                const matchedStackEntry = entry.stack[stackIndex];
                const inheritedFinalMessage = entry.latestFinalMessage ?? matchedStackEntry.finalMessage;
                const inheritedFinalMessageId = entry.latestFinalMessageId ?? (0, $9S1Tm.getFinalMessageId)(entry.latestFinalMessage) ?? matchedStackEntry.finalMessageId ?? (0, $9S1Tm.getFinalMessageId)(matchedStackEntry.finalMessage);
                // `dynamicUiSubtype` is always inherited from the matched entry, never
                // taken from the payload: a backend edit ("Ask Rovo") is not told the
                // current subtype, so its echoed value is unreliable (it defaults, e.g.
                // quadrant comes back as 'flip-card'). Such edits never change the
                // subtype, so the existing entry's value is the source of truth.
                const newStackEntry = isMauiPayload ? {
                    dynamicUiType: payload.dynamicUiType ?? matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: payload.url,
                    fieldId: undefined
                } : {
                    dynamicUiType: matchedStackEntry.dynamicUiType,
                    dynamicUiSubtype: matchedStackEntry.dynamicUiSubtype,
                    finalMessage: inheritedFinalMessage,
                    finalMessageId: inheritedFinalMessageId,
                    url: undefined,
                    fieldId: payload.fieldId
                };
                const updatedHistoryEntry = {
                    ...entry,
                    stack: [
                        ...entry.stack.slice(0, stackIndex + 1),
                        newStackEntry
                    ]
                };
                return {
                    historyMap: {
                        ...state.historyMap,
                        [key]: updatedHistoryEntry
                    }
                };
            }
        case 'goBackInHistory':
        case 'goForwardInHistory':
            return state;
        default:
            return state;
    }
}
const $4b6f0776a18b2b53$export$2e13bdf171bca4ae = new (0, $ks2lK.PluginKey)('remixHistoryPlugin');
function $4b6f0776a18b2b53$export$275a1873be81202e({ api: api, dispatch: dispatch }) {
    return new (0, $1S4f7.SafePlugin)({
        key: $4b6f0776a18b2b53$export$2e13bdf171bca4ae,
        state: {
            init () {
                return {
                    historyMap: {}
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($4b6f0776a18b2b53$export$2e13bdf171bca4ae);
                if (meta) newPluginState = $4b6f0776a18b2b53$var$reducer(newPluginState, meta);
                if (newPluginState !== pluginState) dispatch($4b6f0776a18b2b53$export$2e13bdf171bca4ae, newPluginState);
                return newPluginState;
            }
        }
    });
}


function $dc2ec8a485fcd693$export$b509b1134d7bb5c1(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $4b6f0776a18b2b53$export$2e13bdf171bca4ae), {
            type: 'addBackendHistoryStackEntry',
            payload: options
        });
        return tr;
    };
}









var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");








var $aXWIB = parcelRequire("aXWIB");


var $hTKp4 = parcelRequire("hTKp4");











var $7JKd3 = parcelRequire("7JKd3");





const $d462007436924fa2$export$5569fef6b45e570f = ({ reopenModal: reopenModal } = {})=>({ tr: tr })=>{
        const thinkingMeta = {
            isThinking: false,
            preserveSavedSelection: !!reopenModal
        };
        tr.setMeta((0, $dd89be7a43af642f$export$38c8fc373d691b1d), thinkingMeta);
        if (reopenModal) tr.setMeta((0, $qJp20.malleableUiPluginKey), {
            isRemixModalOpen: true
        });
        return tr;
    };






/**
 * WeakMap registry keyed by the editor api object (unique per editor instance).
 * Stores the stopRemixing function so cancelRemixThinking can call it to abort
 * the in-flight AI request and trigger paired aiInteraction analytics via AbortError,
 * without needing stopRemixing to be passed through the component tree.
 */ const $f5c49cf2f2007592$var$abortRequestRegistry = new WeakMap();
function $f5c49cf2f2007592$export$f9cb53c9d12f6f55(api, abortFn) {
    if (!api) return ()=>{};
    $f5c49cf2f2007592$var$abortRequestRegistry.set(api, abortFn);
    return ()=>{
        $f5c49cf2f2007592$var$abortRequestRegistry.delete(api);
    };
}
function $f5c49cf2f2007592$export$e125c3b8c9ddf1a1(api) {
    if (!api) return undefined;
    return $f5c49cf2f2007592$var$abortRequestRegistry.get(api);
}
function $f5c49cf2f2007592$export$e02ace41eac2e13a({ api: api, reopenModal: reopenModal }) {
    // end the inline-Rovo streaming
    api?.aiExperience?.actions?.endInlineRovoStreaming?.();
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    if ((0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
        // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
        // call the onCancel callback instead of reopening the remix modal.
        const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
        const userPrompt = remixModalMetadata?.userPrompt;
        const onCancel = remixModalMetadata?.onCancel;
        if (onCancel && userPrompt) {
            api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)({
                reopenModal: false
            }));
            onCancel();
            return;
        }
    }
    const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
    api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)({
        reopenModal: reopenModal ?? !isUpdate
    }));
}
function $f5c49cf2f2007592$export$ae8cbff5055b0856({ api: api }) {
    api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)());
}


const $97b2a67a46a9d3d6$export$4ea4004ba136efe5 = 'remix-thinking-widget';
const $97b2a67a46a9d3d6$var$THINKING_WIDGET_PLACEHOLDER_KEY = 'remix-thinking-widget-placeholder';
function $97b2a67a46a9d3d6$export$ca6d884735f53b24({ api: api, container: container, contentType: contentType, getIntl: getIntl, isComplete: isComplete, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const intl = getIntl();
    const remixModalMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
    const userPrompt = remixModalMetadata?.userPrompt;
    const onStopThinking = ()=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
            // Abort before cancelling so send-message-action.ts fires the paired
            // aiInteraction initiated + dismissed events via AbortError.
            (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
            (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                api: api
            });
        } else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            if ((0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                const onCancel = remixModalMetadata?.onCancel;
                if (onCancel && userPrompt) {
                    // Abort the AI request so send-message-action.ts fires the paired
                    // aiInteraction initiated + dismissed events automatically via AbortError.
                    (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
                    api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)({
                        reopenModal: false
                    }));
                    onCancel();
                    return;
                }
            }
            const isUpdate = api?.malleableUi?.sharedState.currentState()?.isUpdate ?? false;
            api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)({
                reopenModal: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? !isUpdate : true
            }));
        }
    };
    const onComplete = ()=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) (0, $f5c49cf2f2007592$export$ae8cbff5055b0856)({
            api: api
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute((0, $d462007436924fa2$export$5569fef6b45e570f)());
        }
    };
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            defaultLocale: intl.defaultLocale || 'en-US',
            locale: intl.locale || 'en-US',
            messages: intl.messages,
            formats: intl.formats,
            onError: intl.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7JKd3.RemixThinkingBar), {
            // when userPrompt is not set, it means it is a remix entrance
            // otherwise it is a non-remix entrance
            isRemixEntrance: (0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? !userPrompt : true,
            contentType: contentType,
            isComplete: isComplete,
            isRelative: true,
            onCompleteAnimationFinished: onComplete,
            onStop: onStopThinking,
            showProgressBar: true
        })), container, $97b2a67a46a9d3d6$export$4ea4004ba136efe5, undefined, true);
}
function $97b2a67a46a9d3d6$var$createRemixThinkingWidget({ api: api, contentType: contentType, getIntl: getIntl, isComplete: isComplete, isPlaceholder: isPlaceholder, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const document = (0, $hTKp4.getDocument)();
    if (!document) throw new Error('Document is required to render the remix thinking widget.');
    const container = document.createElement('div');
    container.className = isPlaceholder ? `${$97b2a67a46a9d3d6$export$4ea4004ba136efe5} ${$97b2a67a46a9d3d6$var$THINKING_WIDGET_PLACEHOLDER_KEY}` : $97b2a67a46a9d3d6$export$4ea4004ba136efe5;
    container.dataset.testid = isPlaceholder ? $97b2a67a46a9d3d6$var$THINKING_WIDGET_PLACEHOLDER_KEY : $97b2a67a46a9d3d6$export$4ea4004ba136efe5;
    if (!isPlaceholder) $97b2a67a46a9d3d6$export$ca6d884735f53b24({
        api: api,
        container: container,
        contentType: contentType,
        getIntl: getIntl,
        isComplete: isComplete,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    });
    return container;
}
function $97b2a67a46a9d3d6$export$2f3df55a342cf539(view) {
    return view.dom.querySelector(`.${$97b2a67a46a9d3d6$export$4ea4004ba136efe5}`);
}
function $97b2a67a46a9d3d6$var$getPositionAfterDepthOneParent({ doc: doc, to: to }) {
    const $to = doc.resolve(to);
    return $to.depth >= 1 ? $to.after(1) : to;
}
function $97b2a67a46a9d3d6$export$cce5a0bc4f5e594d({ api: api, contentType: contentType, doc: doc, getIntl: getIntl, isComplete: isComplete, isPlaceholder: isPlaceholder, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, to: to }) {
    const decorationKey = isPlaceholder ? $97b2a67a46a9d3d6$var$THINKING_WIDGET_PLACEHOLDER_KEY : $97b2a67a46a9d3d6$export$4ea4004ba136efe5;
    const widgetPosition = $97b2a67a46a9d3d6$var$getPositionAfterDepthOneParent({
        doc: doc,
        to: to
    });
    return (0, $ftzrq.Decoration).widget(widgetPosition, ()=>$97b2a67a46a9d3d6$var$createRemixThinkingWidget({
            api: api,
            contentType: contentType,
            getIntl: getIntl,
            isComplete: isComplete ?? false,
            isPlaceholder: isPlaceholder,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
        }), {
        key: decorationKey,
        // use a low negative side to ensure the decoration is rendered before all other decorations
        // so other decorations update don't cause this decoration to be re-rendered
        side: -999,
        destroy: ()=>{
            if (!isPlaceholder) nodeViewPortalProviderAPI.remove($97b2a67a46a9d3d6$export$4ea4004ba136efe5);
        }
    });
}


const $dd89be7a43af642f$var$THINKING_HIGHLIGHT_CLASS = 'remix-thinking-highlight';
const $dd89be7a43af642f$export$38c8fc373d691b1d = new (0, $ks2lK.PluginKey)('remixThinkingPlugin');
function $dd89be7a43af642f$var$getInitialState() {
    return {
        isThinking: false,
        isComplete: false,
        isUpdate: false,
        historyEntryForUpdate: undefined,
        dynamicUiSubtypeForUpdate: undefined,
        decorationSet: (0, $ftzrq.DecorationSet).empty
    };
}
/**
 * normal flow:
 * - reset when show modal
 * - isThinking: true
 * - isThinking: true; isComplete: true (after we have final network response)
 * - isThinking: false; isComplete: true; (after onCompleteAnimationFinished)
 * 	 - we can't reset isComplete when stop thinking because we need it to show the ready toast
 *   - if the ready toast is not shown, currently, we're not resetting isComplete at all
 *   - if this become a bigger issue later, we need to properly reset it
 * - optional: isThinking: false; isComplete: false; (after clicking ready toast)
 *
 * update flow:
 * - isThinking: true; isUpdate: true;
 * - rest is same as normal flow
 */ function $dd89be7a43af642f$var$reducePluginState({ api: api, getIntl: getIntl, isViewMode: isViewMode, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, newState: newState, meta: meta, pluginState: pluginState }) {
    if (meta.reset) return $dd89be7a43af642f$var$getInitialState();
    if (meta.isThinking === true && meta.thinkingSelectionFrom !== undefined && meta.thinkingSelectionTo !== undefined) {
        const from = meta.thinkingSelectionFrom;
        const to = meta.thinkingSelectionTo;
        let decorations;
        if (meta.cellSelectionRanges) decorations = meta.cellSelectionRanges.map((range)=>(0, $ftzrq.Decoration).inline(range.from, range.to, {
                class: $dd89be7a43af642f$var$THINKING_HIGHLIGHT_CLASS
            }));
        else if (meta.isNodeSelection) decorations = [
            (0, $ftzrq.Decoration).node(from, to, {
                class: $dd89be7a43af642f$var$THINKING_HIGHLIGHT_CLASS
            })
        ];
        else decorations = [
            (0, $ftzrq.Decoration).inline(from, to, {
                class: $dd89be7a43af642f$var$THINKING_HIGHLIGHT_CLASS
            })
        ];
        if (!isViewMode && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) decorations.push((0, $97b2a67a46a9d3d6$export$cce5a0bc4f5e594d)({
            api: api,
            contentType: meta.contentType,
            doc: newState.doc,
            getIntl: getIntl,
            isComplete: false,
            isPlaceholder: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? meta.isUpdate ?? false : false,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            to: to
        }));
        const decorationSet = (0, $ftzrq.DecorationSet).create(newState.doc, decorations);
        const result = {
            contentType: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? meta.contentType : undefined,
            isThinking: true,
            isUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? meta.isUpdate : undefined,
            dynamicUiSubtypeForUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? meta.dynamicUiSubtypeForUpdate : undefined,
            historyEntryForUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? meta.historyEntryForUpdate : undefined,
            isComplete: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? false : undefined,
            decorationSet: decorationSet,
            savedSelection: {
                from: from,
                to: to,
                isNodeSelection: meta.isNodeSelection ?? false,
                anchorCellPos: meta.anchorCellPos,
                headCellPos: meta.headCellPos
            }
        };
        return result;
    }
    if (meta.clearDecoration && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
        if (!pluginState.isThinking) return pluginState;
        const result = {
            contentType: pluginState.contentType,
            isThinking: true,
            isUpdate: pluginState.isUpdate,
            isComplete: false,
            historyEntryForUpdate: pluginState.historyEntryForUpdate,
            dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
            decorationSet: (0, $ftzrq.DecorationSet).empty,
            savedSelection: pluginState.savedSelection
        };
        return result;
    }
    if (meta.isComplete === true && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
        if (pluginState.isComplete || !pluginState.isThinking) return pluginState;
        const result = {
            contentType: pluginState.contentType,
            isThinking: pluginState.isThinking,
            isUpdate: pluginState.isUpdate,
            isComplete: true,
            historyEntryForUpdate: pluginState.historyEntryForUpdate,
            dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
            decorationSet: pluginState.decorationSet,
            savedSelection: pluginState.savedSelection
        };
        return result;
    }
    if (meta.isThinking === false) {
        const decorations = [];
        if (!isViewMode && pluginState.isComplete && pluginState.savedSelection?.to) decorations.push((0, $97b2a67a46a9d3d6$export$cce5a0bc4f5e594d)({
            api: api,
            contentType: meta.contentType,
            doc: newState.doc,
            getIntl: getIntl,
            isComplete: false,
            isPlaceholder: true,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            to: pluginState.savedSelection.to
        }));
        const result = {
            contentType: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.contentType : undefined,
            isThinking: false,
            isUpdate: pluginState.isUpdate,
            dynamicUiSubtypeForUpdate: pluginState.dynamicUiSubtypeForUpdate,
            historyEntryForUpdate: pluginState.historyEntryForUpdate,
            isComplete: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginState.isComplete : undefined,
            decorationSet: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $ftzrq.DecorationSet).create(newState.doc, decorations) : (0, $ftzrq.DecorationSet).empty,
            savedSelection: meta.preserveSavedSelection ? pluginState.savedSelection : undefined
        };
        return result;
    }
    // this should be replaced by the reset state
    if (meta.isComplete === false && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
        if (pluginState.isComplete === false) return pluginState;
        const result = {
            contentType: undefined,
            isThinking: false,
            isComplete: false,
            isUpdate: false,
            historyEntryForUpdate: undefined,
            dynamicUiSubtypeForUpdate: undefined,
            decorationSet: (0, $ftzrq.DecorationSet).empty,
            savedSelection: undefined
        };
        return result;
    }
}
function $dd89be7a43af642f$export$1c17a47e3daa5065({ api: api, config: config, dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    return new (0, $1S4f7.SafePlugin)({
        key: $dd89be7a43af642f$export$38c8fc373d691b1d,
        state: {
            init () {
                return $dd89be7a43af642f$var$getInitialState();
            },
            apply (tr, pluginState, _oldState, newState) {
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                const meta = tr.getMeta($dd89be7a43af642f$export$38c8fc373d691b1d);
                if (meta) {
                    const result = $dd89be7a43af642f$var$reducePluginState({
                        api: api,
                        getIntl: getIntl,
                        isViewMode: isViewMode,
                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                        newState: newState,
                        meta: meta,
                        pluginState: pluginState
                    });
                    if (result) {
                        dispatch($dd89be7a43af642f$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                if (pluginState.isThinking && pluginState.decorationSet !== (0, $ftzrq.DecorationSet).empty) {
                    let mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                    // re-create the thinking widget decoration if the widget is not in the mapped decoration set while thinking
                    // it can be removed when updating the remix, which will replace the node and delete the decoration
                    if (!isViewMode && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                        const thinkingWidgetDecoration = mappedDecorationSet.find(undefined, undefined, (spec)=>{
                            return spec?.key === (0, $97b2a67a46a9d3d6$export$4ea4004ba136efe5);
                        });
                        if (!thinkingWidgetDecoration.length && pluginState.savedSelection?.to) mappedDecorationSet = mappedDecorationSet.add(newState.doc, [
                            (0, $97b2a67a46a9d3d6$export$cce5a0bc4f5e594d)({
                                api: api,
                                contentType: pluginState.contentType,
                                doc: newState.doc,
                                getIntl: getIntl,
                                isComplete: false,
                                isPlaceholder: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? pluginState.isUpdate ?? false : false,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                                to: tr.mapping.map(pluginState.savedSelection.to)
                            })
                        ]);
                    }
                    if (mappedDecorationSet !== pluginState.decorationSet) {
                        const mappedSavedSelection = pluginState.savedSelection ? {
                            ...pluginState.savedSelection,
                            from: tr.mapping.map(pluginState.savedSelection.from),
                            to: tr.mapping.map(pluginState.savedSelection.to),
                            anchorCellPos: pluginState.savedSelection.anchorCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.anchorCellPos) : undefined,
                            headCellPos: pluginState.savedSelection.headCellPos !== undefined ? tr.mapping.map(pluginState.savedSelection.headCellPos) : undefined
                        } : undefined;
                        const result = {
                            ...pluginState,
                            decorationSet: mappedDecorationSet,
                            savedSelection: mappedSavedSelection
                        };
                        dispatch($dd89be7a43af642f$export$38c8fc373d691b1d, result);
                        return result;
                    }
                }
                return pluginState;
            }
        },
        view () {
            return {
                update (view, previousState) {
                    const previousPluginState = $dd89be7a43af642f$export$38c8fc373d691b1d.getState(previousState);
                    const currentPluginState = $dd89be7a43af642f$export$38c8fc373d691b1d.getState(view.state);
                    const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                    if (!isViewMode && currentPluginState?.isThinking && !previousPluginState?.isComplete && currentPluginState.isComplete && ((0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? !currentPluginState.isUpdate : true) && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
                        const container = (0, $97b2a67a46a9d3d6$export$2f3df55a342cf539)(view);
                        if (!container) return;
                        (0, $97b2a67a46a9d3d6$export$ca6d884735f53b24)({
                            api: api,
                            container: container,
                            contentType: currentPluginState.contentType,
                            getIntl: getIntl,
                            isComplete: currentPluginState.isComplete ?? false,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        });
                    }
                }
            };
        },
        appendTransaction (_transactions, oldState, newState) {
            const oldPluginState = $dd89be7a43af642f$export$38c8fc373d691b1d.getState(oldState);
            const newPluginState = $dd89be7a43af642f$export$38c8fc373d691b1d.getState(newState);
            // only restore selection if the plugin state is not complete
            // which means the remix is cancelled
            // we don't want to restore selection if the remix is complete
            // which will trigger floating toolbar
            if (oldPluginState?.isThinking && !newPluginState?.isThinking && newPluginState?.savedSelection && !(newPluginState?.isComplete && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading'))) {
                const { savedSelection: savedSelection } = newPluginState;
                const tr = newState.tr;
                if (savedSelection.anchorCellPos !== undefined && savedSelection.headCellPos !== undefined) tr.setSelection((0, $7XFGZ.CellSelection).create(tr.doc, savedSelection.anchorCellPos, savedSelection.headCellPos));
                else if (savedSelection.isNodeSelection) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, savedSelection.from));
                else tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, savedSelection.from, savedSelection.to));
                return tr;
            }
            return null;
        },
        props: {
            decorations (state) {
                return $dd89be7a43af642f$export$38c8fc373d691b1d.getState(state)?.decorationSet ?? (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
}


const $2daab9aee767d4c3$export$65f89d2d4741e4b7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $dd89be7a43af642f$export$38c8fc373d691b1d), {
            clearDecoration: true
        });
        return tr;
    };





const $3cbafda77e1252b9$export$8818f9db6e7370f7 = (api)=>()=>({ tr: tr })=>{
            // Clear the block selection so stale ak-editor-selected-node decorations
            // are removed when the modal is dismissed.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $qJp20.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: undefined,
                remixSource: undefined
            });
            return tr;
        };



var $bOew3 = parcelRequire("bOew3");














const $7232f801a732464c$var$HEADING_NODE_TYPE = 'heading';
const $7232f801a732464c$export$e8f38c0ba1044114 = (doc, headingPos)=>{
    let currentPos = 0;
    for(let index = 0; index < doc.childCount; index++){
        const child = doc.child(index);
        if (currentPos !== headingPos) {
            currentPos += child.nodeSize;
            continue;
        }
        if (child.type.name !== $7232f801a732464c$var$HEADING_NODE_TYPE) return null;
        let endPos = headingPos + child.nodeSize;
        let endIndex = index + 1;
        for(let sectionIndex = index + 1; sectionIndex < doc.childCount; sectionIndex++){
            const sectionNode = doc.child(sectionIndex);
            if (sectionNode.type.name === $7232f801a732464c$var$HEADING_NODE_TYPE) break;
            endPos += sectionNode.nodeSize;
            endIndex = sectionIndex + 1;
        }
        return {
            startPos: headingPos,
            endPos: endPos,
            startIndex: index,
            endIndex: endIndex
        };
    }
    return null;
};


const $140c07dc09e2d405$var$BLOCK_NUDGE_SOURCE = 'blockNudge';
const $140c07dc09e2d405$export$f437f2a5f6852f29 = 'pasteMenu';
const $140c07dc09e2d405$var$applyHeadingSectionSelection = ({ nodePos: nodePos, source: source, tr: tr })=>{
    if (source !== $140c07dc09e2d405$var$BLOCK_NUDGE_SOURCE) return false;
    const headingSection = (0, $7232f801a732464c$export$e8f38c0ba1044114)(tr.doc, nodePos);
    if (!headingSection) return false;
    const headingSectionSelection = (0, $ks2lK.TextSelection).create(tr.doc, headingSection.startPos, headingSection.endPos);
    tr.setSelection(headingSectionSelection);
    return true;
};
const $140c07dc09e2d405$export$e01f52b7ef73f07b = (api)=>({ nodePos: nodePos, nodeType: nodeType, metadata: metadata, source: source } = {})=>({ tr: tr })=>{
            // If the remix modal is being opened from the paste menu, set the selection to the pasted content range
            if (source === $140c07dc09e2d405$export$f437f2a5f6852f29 && api && 'pasteOptionsToolbarPlugin' in api && api.pasteOptionsToolbarPlugin && [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $aeAfU.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) {
                const pasteState = api.pasteOptionsToolbarPlugin.sharedState.currentState();
                if (!pasteState) // Exit early if we can't get the paste state, which means we won't be able to set the selection to the pasted content.
                return null;
                const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteState;
                if (pasteStartPos === undefined || pasteEndPos === undefined) // Exit early if the paste state doesn't have valid start or end positions.
                return null;
                const pasteSelection = (0, $ks2lK.TextSelection).create(tr.doc, pasteStartPos, pasteEndPos);
                tr.setSelection(pasteSelection);
                api?.selection?.commands?.setBlockSelection(pasteSelection)({
                    tr: tr
                });
            } else if (nodePos !== undefined && nodeType) {
                if ((0, $dh538.fg)('cc-maui-phase-3')) {
                    const didApplyHeadingSelection = $140c07dc09e2d405$var$applyHeadingSectionSelection({
                        nodePos: nodePos,
                        source: source,
                        tr: tr
                    });
                    if (!didApplyHeadingSelection) (0, $bOew3.selectNodeAtPos)(tr, nodePos, nodeType);
                } else if ((0, $dh538.fg)('platform_editor_maui_jira_updates')) (0, $bOew3.selectNodeAtPos)(tr, nodePos, nodeType);
                else api?.blockControls?.commands.expandAndUpdateSelection({
                    startPos: nodePos,
                    nodeType: nodeType,
                    selection: tr.selection,
                    isShiftPressed: false
                })({
                    tr: tr
                });
                // If a multi-block TextSelection was set, signal to the selection plugin
                // so that ak-editor-selected-node decorations are applied to all selected nodes.
                if (tr.selection instanceof (0, $ks2lK.TextSelection)) api?.selection?.commands?.setBlockSelection(tr.selection)({
                    tr: tr
                });
            }
            tr.setMeta((0, $qJp20.malleableUiPluginKey), {
                isRemixModalOpen: true,
                remixModalMetadata: metadata,
                remixSource: source
            });
            if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) tr.setMeta((0, $dd89be7a43af642f$export$38c8fc373d691b1d), {
                reset: true
            });
            return tr;
        };















// The native-embeds auto-converter wraps a MAUI whiteboard URL
// (`...?isRemixDiagram=true`) into an extension node keyed by the
// `maui-whiteboard` experience id, not the generic `whiteboard` experience.
// See native-embeds-editor-extension `createManifest` autoConvert.
const $0521de7e9ae033e8$var$NATIVE_WHITEBOARD_EXTENSION_KEY = 'native-embed:maui-whiteboard';
const $0521de7e9ae033e8$var$getString = (value)=>typeof value === 'string' ? value : undefined;
// The native-embeds plugin can persist a whiteboard extension in one of two
// shapes depending on how it was created/transformed:
// - Nested macro shape: `attrs.parameters.macroParams.url.value`
// - Flat shape:         `attrs.parameters.url`
const $0521de7e9ae033e8$var$getNativeWhiteboardUrl = (attrs)=>$0521de7e9ae033e8$var$getString(attrs.parameters?.macroParams?.url?.value) ?? $0521de7e9ae033e8$var$getString(attrs.parameters?.url);
const $0521de7e9ae033e8$var$getWhiteboardContentId = (url)=>{
    if (!url) return undefined;
    const match = /\/whiteboard\/([^/?#]+)/.exec(url);
    const encodedContentId = match?.[1];
    if (!encodedContentId) return undefined;
    try {
        return decodeURIComponent(encodedContentId);
    } catch  {
        return encodedContentId;
    }
};
const $0521de7e9ae033e8$var$getWhiteboardEmbedNodeInfo = (node)=>{
    if (node.type.name === 'embedCard') return {
        kind: 'embedCard',
        localId: $0521de7e9ae033e8$var$getString(node.attrs.localId),
        url: $0521de7e9ae033e8$var$getString(node.attrs.url)
    };
    if (node.type.name === 'extension' && node.attrs.extensionKey === $0521de7e9ae033e8$var$NATIVE_WHITEBOARD_EXTENSION_KEY) return {
        kind: 'nativeWhiteboard',
        localId: $0521de7e9ae033e8$var$getString(node.attrs.localId),
        url: $0521de7e9ae033e8$var$getNativeWhiteboardUrl(node.attrs)
    };
    return undefined;
};
const $0521de7e9ae033e8$var$isMatchingWhiteboardContent = (url, contentId)=>$0521de7e9ae033e8$var$getWhiteboardContentId(url) === contentId;
const $0521de7e9ae033e8$var$isMatchingLocalId = (actualLocalId, expectedLocalId)=>expectedLocalId ? actualLocalId === expectedLocalId : true;
const $0521de7e9ae033e8$export$fc1c1f126d7fc18e = (node, contentId, localId)=>{
    const info = $0521de7e9ae033e8$var$getWhiteboardEmbedNodeInfo(node);
    if (!info || !$0521de7e9ae033e8$var$isMatchingWhiteboardContent(info.url, contentId)) return false;
    // Finalize can run during the timing window before or after native-embeds
    // converts Rovo's early embedCard into a maui-whiteboard extension. The
    // embedCard has localId; the converted extension does not, so match it by
    // exact contentId.
    if (info.kind === 'nativeWhiteboard') return true;
    return $0521de7e9ae033e8$var$isMatchingLocalId(info.localId, localId);
};
// Only updates the shapes that actually exist on the node, to avoid inventing
// missing nested objects on a flat node (mirrors `getNativeWhiteboardUrl`).
const $0521de7e9ae033e8$var$updateNativeWhiteboardUrlAttrs = (attrs, finalizedUrl)=>({
        ...attrs,
        parameters: {
            ...attrs.parameters,
            ...typeof attrs.parameters?.url === 'string' ? {
                url: finalizedUrl
            } : {},
            ...attrs.parameters?.macroParams ? {
                macroParams: {
                    ...attrs.parameters.macroParams,
                    url: {
                        ...attrs.parameters.macroParams.url,
                        value: finalizedUrl
                    }
                }
            } : {},
            ...attrs.parameters?.macroMetadata ? {
                macroMetadata: {
                    ...attrs.parameters.macroMetadata,
                    url: finalizedUrl
                }
            } : {}
        }
    });
const $0521de7e9ae033e8$export$f23238abf7f83f7e = (node, finalizedUrl)=>{
    const info = $0521de7e9ae033e8$var$getWhiteboardEmbedNodeInfo(node);
    if (info?.kind === 'nativeWhiteboard') return $0521de7e9ae033e8$var$updateNativeWhiteboardUrlAttrs(node.attrs, finalizedUrl);
    return {
        ...node.attrs,
        url: finalizedUrl
    };
};
const $0521de7e9ae033e8$var$updateWhiteboardNodeUrl = (tr, node, pos, contentId, finalizedUrl)=>{
    tr.setNodeMarkup(pos, undefined, $0521de7e9ae033e8$export$f23238abf7f83f7e(node, finalizedUrl));
    // Tell the maui-diagram paste plugin that this content has been finalized so
    // the `MauiNativeEmbedBanner` stops surfacing the "needs finalize" warning
    // even if the BE move hasn't propagated by the time the probe fires.
    tr.setMeta((0, $LSDsY.mauiDiagramPastePluginKey), {
        type: (0, $LSDsY.ActionType).EMBED_FINALIZE_STATUS_CHANGED,
        contentId: contentId,
        status: (0, $LSDsY.MauiEmbedFinalizeStatus).FINALIZED
    });
    if ((0, $dh538.fg)('platform_remix_fix_node_replacement_selection')) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, pos));
    return tr;
};
const $0521de7e9ae033e8$var$findWhiteboardNode = (doc, contentId, localId)=>{
    let nodeResult;
    doc.descendants((node, pos)=>{
        if (nodeResult) return false;
        if ($0521de7e9ae033e8$export$fc1c1f126d7fc18e(node, contentId, localId)) nodeResult = {
            node: node,
            pos: pos
        };
        return !nodeResult;
    });
    return nodeResult;
};
const $0521de7e9ae033e8$export$1aa62896db449f52 = ({ contentId: contentId, finalizedUrl: finalizedUrl, localId: localId })=>({ tr: tr })=>{
        // Fast path: if the target is already selected, avoid walking the whole document.
        if ((0, $8m4tT.isNodeSelection)(tr.selection) && $0521de7e9ae033e8$export$fc1c1f126d7fc18e(tr.selection.node, contentId, localId)) return $0521de7e9ae033e8$var$updateWhiteboardNodeUrl(tr, tr.selection.node, tr.selection.$anchor.pos, contentId, finalizedUrl);
        const nodeResult = $0521de7e9ae033e8$var$findWhiteboardNode(tr.doc, contentId, localId);
        if (nodeResult) return $0521de7e9ae033e8$var$updateWhiteboardNodeUrl(tr, nodeResult.node, nodeResult.pos, contentId, finalizedUrl);
        return null;
    };



var $adhil = parcelRequire("adhil");

var $9GYNY = parcelRequire("9GYNY");

















const $ccb60ab150962a8e$export$b0011c604093029 = (api)=>({ contentType: contentType, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, remixModalMetadata: remixModalMetadata } = {})=>({ tr: tr })=>{
            const selection = tr.selection;
            const isNodeSelection = selection instanceof (0, $ks2lK.NodeSelection);
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const thinkingMeta = {
                contentType: contentType,
                isThinking: true,
                isUpdate: isUpdate,
                historyEntryForUpdate: historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate,
                thinkingSelectionFrom: selection.from,
                thinkingSelectionTo: isNodeSelection ? selection.from + selection.node.nodeSize : selection.to,
                isNodeSelection: isNodeSelection
            };
            if (isCellSelection) {
                thinkingMeta.cellSelectionRanges = selection.ranges.map((range)=>({
                        from: range.$from.pos,
                        to: range.$to.pos
                    }));
                thinkingMeta.anchorCellPos = selection.$anchorCell.pos;
                thinkingMeta.headCellPos = selection.$headCell.pos;
            }
            // Clear block selection decorations before applying the thinking state.
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            tr.setMeta((0, $dd89be7a43af642f$export$38c8fc373d691b1d), thinkingMeta);
            /**
   * Added this check so that when a userPrompt is pre-supplied in metadata (e.g. from the AI Image Generation flow),
   * we can pass in necessary metadata to the malleable-ui plugin.
   * like the userPrompt
   */ if (remixModalMetadata && remixModalMetadata.userPrompt && (0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) tr.setMeta((0, $qJp20.malleableUiPluginKey), {
                isRemixModalOpen: false,
                remixModalMetadata: remixModalMetadata,
                remixSource: remixModalMetadata.remixSource
            });
            else tr.setMeta((0, $qJp20.malleableUiPluginKey), {
                isRemixModalOpen: false
            });
            // Move the active selection away from the selected node so the user can
            // continue editing while the remix is processing.
            const endPos = isNodeSelection ? selection.from + selection.node.nodeSize : selection.to;
            if (isNodeSelection && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                const $endPos = tr.doc.resolve(endPos);
                tr.setSelection((0, $adhil.GapCursorSelection).valid($endPos) ? new (0, $adhil.GapCursorSelection)($endPos, (0, $9GYNY.Side).RIGHT) : (0, $ks2lK.TextSelection).create(tr.doc, endPos));
            } else tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, endPos));
            return tr;
        };
function $ccb60ab150962a8e$export$fdf82e9851b59bf0({ api: api, options: options }) {
    api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
    api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
}






function $a91b3754946df6af$export$b3219bd5df32333({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $qJp20.malleableUiPluginKey), {
            addInFlightVariantUpdateId: id
        });
        return tr;
    };
}
function $a91b3754946df6af$export$242a1c29a4a1fdc3({ id: id }) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $qJp20.malleableUiPluginKey), {
            removeInFlightVariantUpdateId: id
        });
        return tr;
    };
}



function $233172411ad9fe35$export$de0bdc3bedba2bdf(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $4b6f0776a18b2b53$export$2e13bdf171bca4ae), {
            type: 'updateRemixImageHistoryFieldId',
            payload: {
                conversationId: options.conversationId,
                fieldId: options.fieldId
            }
        });
        return tr;
    };
}














/**
 * Remix block control: positioned at the right edge of the block.
 * Uses anchor(anchorName end) or getRightPositionForRootElement (same coordinate system
 * as left controls). The widget span has no position:relative so position:absolute
 * uses the same containing block as the node.
 */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $fFa3V = parcelRequire("fFa3V");





var $1qfLF = parcelRequire("1qfLF");


var $eiA8Z = parcelRequire("eiA8Z");


var $1zav4 = parcelRequire("1zav4");


var $1iRzx = parcelRequire("1iRzx");

var $8ATx9 = parcelRequire("8ATx9");

var $8RppR = parcelRequire("8RppR");

var $5pTQL = parcelRequire("5pTQL");

var $fBMpm = parcelRequire("fBMpm");

var $hnbpK = parcelRequire("hnbpK");


var $jQW4q = parcelRequire("jQW4q");











var $3gadb = parcelRequire("3gadb");

















const $05b902cb1d2c0384$export$95a12c22f1d400bc = new (0, $ks2lK.PluginKey)('remixHoverHighlightPlugin');
const $05b902cb1d2c0384$export$cb3fa8e98acae648 = 'remix-hover-highlight';
const $05b902cb1d2c0384$var$getHeadingSectionDecorations = ({ doc: doc, headingPos: headingPos, className: className })=>{
    const headingSection = (0, $7232f801a732464c$export$e8f38c0ba1044114)(doc, headingPos);
    if (!headingSection) return [];
    const decorations = [];
    let currentPos = headingSection.startPos;
    for(let index = headingSection.startIndex; index < headingSection.endIndex; index++){
        const child = doc.child(index);
        decorations.push((0, $ftzrq.Decoration).node(currentPos, currentPos + child.nodeSize, {
            class: className
        }));
        currentPos += child.nodeSize;
    }
    return decorations;
};
function $05b902cb1d2c0384$export$1c5a63402318eb67() {
    return new (0, $1S4f7.SafePlugin)({
        key: $05b902cb1d2c0384$export$95a12c22f1d400bc,
        state: {
            init () {
                return {
                    highlightedPos: null,
                    decorationSet: (0, $ftzrq.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta($05b902cb1d2c0384$export$95a12c22f1d400bc);
                if (meta !== undefined) {
                    if (meta.highlightPos === null) // Clear highlight
                    return {
                        highlightedPos: null,
                        decorationSet: (0, $ftzrq.DecorationSet).empty
                    };
                    const pos = meta.highlightPos;
                    const node = newState.doc.nodeAt(pos);
                    if (!node) return pluginState;
                    const decorationClassNames = meta.rootNodeType === 'table' ? [
                        'ak-editor-selected-node'
                    ] : [
                        $05b902cb1d2c0384$export$cb3fa8e98acae648
                    ];
                    const className = decorationClassNames.join(' ');
                    const headingSectionDecorations = $05b902cb1d2c0384$var$getHeadingSectionDecorations({
                        doc: newState.doc,
                        headingPos: pos,
                        className: className
                    });
                    const decorations = headingSectionDecorations.length > 0 ? headingSectionDecorations : [
                        (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                            class: className
                        })
                    ];
                    const decorationSet = (0, $ftzrq.DecorationSet).create(newState.doc, decorations);
                    return {
                        highlightedPos: pos,
                        decorationSet: decorationSet
                    };
                }
                // Map decorations on doc changes
                if (pluginState.highlightedPos !== null && pluginState.decorationSet !== (0, $ftzrq.DecorationSet).empty) {
                    const mappedDecorationSet = pluginState.decorationSet.map(tr.mapping, newState.doc);
                    if (mappedDecorationSet !== pluginState.decorationSet) {
                        const mappedPos = tr.mapping.map(pluginState.highlightedPos);
                        return {
                            ...pluginState,
                            highlightedPos: mappedPos,
                            decorationSet: mappedDecorationSet
                        };
                    }
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return $05b902cb1d2c0384$export$95a12c22f1d400bc.getState(state)?.decorationSet ?? (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
}



var $jpEHf = parcelRequire("jpEHf");

/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 * Use with block-controls activeNode (or a full PM node) and these filters in both edit and view.
 */ 
var $l9G9n = parcelRequire("l9G9n");





var $16hKZ = parcelRequire("16hKZ");

const $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe = [
    'mediaSingle',
    'media'
];
const $9531e9c3be1ec0bb$export$ebd59c3751cfcc95 = (node)=>{
    if (!node) return false;
    // Aya's principle:
    // Empty anything should not have the Remix button shown
    // Once there is text or something in the element, we can show it
    // NOTE: Currently, we are ignoring "something" because Remix can't handle only emoji, status, etc.
    if (node.textContent.trim().length === 0 && (0, $dh538.fg)('platform_editor_remix_improved_emptiness_check')) return true;
    // layoutSection is always remixable (even empty) so users can generate content into it.
    return node.type.name !== 'layoutSection' && (0, $l9G9n.isNodeEmpty)(node);
};
const $9531e9c3be1ec0bb$export$ff7e5ebac3487125 = (context)=>{
    const nodeType = context.node?.type?.name ?? context.nodeType;
    if (nodeType === undefined) return false;
    if ((0, $16hKZ.isRemixRestrictedNodeType)(nodeType)) return false;
    return !$9531e9c3be1ec0bb$export$ebd59c3751cfcc95(context.node);
};





const $273077559a9b876d$export$5626baa73ed0afeb = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage((0, $jpEHf.messages).remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage((0, $jpEHf.messages).remixDisabledTooltipArchived);
    }
};


function $74b1142437cdb6f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $74b1142437cdb6f9$var$REMIX_BUTTON_HEIGHT = 24;
const $74b1142437cdb6f9$var$REMIX_BUTTON_WIDTH = 24;
const $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS = {
    width: $74b1142437cdb6f9$var$REMIX_BUTTON_WIDTH,
    height: $74b1142437cdb6f9$var$REMIX_BUTTON_HEIGHT
};
const $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET = 55;
// Column layout (layoutSection) has breakout resize handles extending to the right; push Remix button further so it doesn't overlap
const $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION = 91;
const $74b1142437cdb6f9$var$INNER_CONTAINER_SELECTORS = {
    embedCard: '.rich-media-item',
    table: '.resizer-item',
    mediaSingle: '.resizer-item',
    extension: '.extension-container[data-layout]',
    bodiedExtension: '.extension-container[data-layout]',
    blockCard: '.datasourceView-content-inner-wrap'
};
const $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase = (dom, rootNodeType)=>{
    const selector = $74b1142437cdb6f9$var$INNER_CONTAINER_SELECTORS[rootNodeType];
    const innerContainer = selector ? dom.querySelector(selector) : null;
    // Edge case: nodes with nested inner containers (resizer, extension, embedCard, blockCard)
    // require offset-based positioning including dom.offsetLeft because anchor-based positioning
    // doesn't correctly account for the nested layout. Occurs when the inner container exists and
    // the block is not aligned to the right edge of the editor content area.
    const isEdgeCase = selector !== undefined && innerContainer !== null;
    return {
        innerContainer: innerContainer,
        isEdgeCase: isEdgeCase
    };
};
const $74b1142437cdb6f9$var$containerBaseStyles = {
    name: "1sgo8pu",
    styles: "position:absolute;z-index:100;display:flex;align-items:flex-start;justify-content:center"
};
const $74b1142437cdb6f9$var$stickyButtonContainerStyles = {
    name: "cdscbk",
    styles: "top:8px;position:sticky;display:block;z-index:100;button{border-radius:var(--ds-radius-full, 9999px);}"
};
const $74b1142437cdb6f9$var$stickyButtonContainerStylesStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    }
});
const $74b1142437cdb6f9$var$stickyButtonContainerStylesImprovedStickyHeader = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-remix-button-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $1zav4.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-remix-button-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $fBMpm.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $74b1142437cdb6f9$export$e420cb1e340b26d1 = ({ view: view, api: api, getPos: getPos, anchorName: anchorName, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, rootPos: rootPos })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { macroInteractionUpdates: macroInteractionUpdates, editorViewMode: editorViewMode, activeNode: activeNode, rightSideControlsEnabled: rightSideControlsEnabled, hoverSide: hoverSide, contentId: contentId, isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'editorViewMode',
        'blockControls',
        'contextIdentifier',
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            editorViewMode: states.editorViewModeState?.mode,
            activeNode: states.blockControlsState?.activeNode,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false,
            hoverSide: states.blockControlsState?.hoverSide,
            contentId: states.contextIdentifierState?.contextIdentifierProvider?.objectId,
            isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    const isViewMode = editorViewMode === 'view';
    // pageMode for analytics: 'editor' = full page editor, 'liveEdit' = live page edit, 'liveView' = live page view (livePage set by Confluence).
    const pageMode = editorViewMode === 'edit' && !livePage ? 'editor' : editorViewMode === 'edit' && livePage ? 'liveEdit' : editorViewMode === 'view' && livePage ? 'liveView' : undefined;
    // Fire experiment exposure only when the user would see the Remix tool (hover over right side of block)
    const hasFiredExposureRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredExposureRef.current) return;
        const isActiveBlock = activeNode?.rootPos === rootPos && activeNode?.rootAnchorName === (rootAnchorName ?? anchorName);
        const isRightSideVisible = rightSideControlsEnabled && (hoverSide === 'right' || isViewMode);
        if (isActiveBlock && isRightSideVisible) {
            (0, $dh538.fg)('confluence_remix_button_right_side_block_fg');
            (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true);
            hasFiredExposureRef.current = true;
        }
    }, [
        activeNode?.rootPos,
        activeNode?.rootAnchorName,
        rootPos,
        rootAnchorName,
        anchorName,
        rightSideControlsEnabled,
        hoverSide,
        isViewMode
    ]);
    const [positionStyles, setPositionStyles] = (0, $42omo.useState)({
        display: 'none'
    });
    // Shared offset-based positioning for view mode and edit-mode fallback.
    // Horizontal (left) uses getRightPositionForRootElement; vertical uses getTopPosition.
    const rightOffset = rootNodeType === 'layoutSection' ? $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET_LAYOUT_SECTION : $74b1142437cdb6f9$var$REMIX_BUTTON_RIGHT_OFFSET;
    const getOffsetBasedPosition = (0, $42omo.useCallback)((dom, safeAnchorName)=>{
        const { innerContainer: innerContainer, isEdgeCase: isEdgeCase } = $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        const isSticky = (0, $8ATx9.shouldBeSticky)(rootNodeType);
        const rightEdgeLeft = (0, $8RppR.getRightPositionForRootElement)(dom, rootNodeType, $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS, innerContainer ?? undefined, isMacroInteractionUpdates);
        const height = (0, $8ATx9.getControlHeightCSSValue)((0, $8ATx9.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.height}`);
        return {
            left: isEdgeCase ? `calc(${dom.offsetLeft}px + (${rightEdgeLeft}) + ${rightOffset}px)` : `calc(${rightEdgeLeft} + ${rightOffset}px)`,
            top: (0, $8ATx9.getTopPosition)(dom, rootNodeType),
            ...height,
            bottom: 'unset'
        };
    }, [
        rootNodeType,
        macroInteractionUpdates,
        rightOffset
    ]);
    // Edit mode: anchor-based when supported, otherwise offset-based (same as view mode).
    const calculatePosition = (0, $42omo.useCallback)(()=>{
        const safeAnchorName = (0, $5pTQL.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName ?? anchorName
        });
        let dom = view.dom.querySelector(`[${(0, $1iRzx.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Fallback: table nodes use data-node-anchor (set by table-anchor-names plugin) rather than
        // data-drag-handler-anchor-name. When getAnchorAttrName() returns the drag-handler attribute
        // (experiment disabled), the primary query above finds nothing. Try data-node-anchor as a
        // fallback so tables work regardless of the platform_editor_native_anchor_with_dnd experiment.
        if (!dom) dom = view.dom.querySelector(`[data-node-anchor="${safeAnchorName}"]`);
        if (!dom) return {
            display: 'none'
        };
        // For layoutSection, the anchor attribute is on the outer ReactNodeView wrapper div which
        // may have a larger offsetWidth than the actual layout section content area.
        // Use the inner [data-layout-section] element for accurate width-based positioning.
        // Keep a reference to the outer wrapper: getTopPosition needs it because the inner
        // [data-layout-section] element's offsetTop is ~0 relative to the wrapper.
        const outerDom = dom;
        if (rootNodeType === 'layoutSection') dom = dom.querySelector('[data-layout-section]') ?? dom;
        const isSticky = (0, $8ATx9.shouldBeSticky)(rootNodeType);
        // View mode always uses offset-based (anchor positioning can differ in view mode).
        if (isViewMode) {
            // layoutSection: the inner element's right edge gives the correct width, but its
            // offsetTop is ~0 (relative to the wrapper). Mirror the table branch — use a single
            // getBoundingClientRect() diff for the right edge and getTopPosition(outerDom) for top.
            if (rootNodeType === 'layoutSection') {
                const gap = (0, $fBMpm.rootElementGap)(rootNodeType);
                const layoutRight = outerDom.offsetLeft + (dom.getBoundingClientRect().right - outerDom.getBoundingClientRect().left) - gap - $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.width;
                const height = (0, $8ATx9.getControlHeightCSSValue)((0, $8ATx9.getNodeHeight)(outerDom, safeAnchorName) || 0, isSticky, true, `${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${layoutRight}px + ${rightOffset}px)`,
                    top: (0, $8ATx9.getTopPosition)(outerDom, rootNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            // In view mode, tables have no .resizer-item so isEdgeCase=false and getOffsetBasedPosition
            // uses dom.offsetWidth (editor width) instead of the actual table width. For wide/max tables
            // this places the button at the editor margin, not the table's right edge.
            // Use the first <tr> as the inner reference (same role as .resizer-item in edit mode):
            // tr.offsetLeft + tr.offsetWidth gives the actual table right edge relative to dom.
            const tableRow = rootNodeType === 'table' || rootNodeType === '' ? dom.querySelector('thead tr, tr') : null;
            if (tableRow) {
                const effectiveNodeType = rootNodeType || 'table';
                const gap = (0, $fBMpm.rootElementGap)(effectiveNodeType);
                // Get the tr's right edge relative to dom's left edge using BoundingClientRect
                // (avoids offset-parent chain issues between tr and the nodeview wrapper).
                const trRight = tableRow.getBoundingClientRect().right - dom.getBoundingClientRect().left;
                const rightEdgeLeft = dom.offsetLeft + trRight - gap - $74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.width;
                const isSticky = (0, $8ATx9.shouldBeSticky)(effectiveNodeType);
                const height = (0, $8ATx9.getControlHeightCSSValue)((0, $8ATx9.getNodeHeight)(dom, safeAnchorName) || 0, isSticky, true, `${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.height}`);
                return {
                    left: `calc(${rightEdgeLeft}px + ${rightOffset}px)`,
                    top: (0, $8ATx9.getTopPosition)(dom, effectiveNodeType),
                    ...height,
                    bottom: 'unset'
                };
            }
            return getOffsetBasedPosition(dom, safeAnchorName);
        }
        const { isEdgeCase: isEdgeCase } = $74b1142437cdb6f9$var$getInnerContainerAndEdgeCase(dom, rootNodeType);
        // Check anchor first (no reflow). Only use offset-based when fallback needed.
        const supportsAnchorRight = CSS.supports('left', `anchor(${safeAnchorName} end)`) && CSS.supports('top', `anchor(${safeAnchorName} start)`);
        if (supportsAnchorRight && !isEdgeCase) return {
            left: `calc(anchor(${safeAnchorName} end) - ${$74b1142437cdb6f9$var$REMIX_BUTTON_DIMENSIONS.width}px - ${(0, $fBMpm.rootElementGap)(rootNodeType)}px + ${rightOffset}px)`,
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $fBMpm.topPositionAdjustment)(rootNodeType)}px)`,
            ...(0, $8ATx9.getControlBottomCSSValue)(safeAnchorName, isSticky, true)
        };
        return getOffsetBasedPosition(dom, safeAnchorName);
    }, [
        view,
        getPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        isViewMode,
        getOffsetBasedPosition,
        rightOffset
    ]);
    // Recompute button position on mount and when extension/embedCard layout changes (e.g. expand/collapse).
    // For extension/embedCard we listen to transitionend so position updates after CSS transitions finish.
    (0, $42omo.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const anchorDom = view.dom.querySelector(`[${(0, $1iRzx.getAnchorAttrName)()}="${rootAnchorName ?? anchorName}"]`);
            if (anchorDom) cleanUpTransitionListener = (0, $fFa3V.bind)(anchorDom, {
                type: 'transitionend',
                listener: ()=>setPositionStyles(calculatePosition())
            });
        }
        const id = requestAnimationFrame(()=>setPositionStyles(calculatePosition()));
        return ()=>{
            cancelAnimationFrame(id);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType,
        anchorName,
        isViewMode
    ]);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (isDisabled) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'blockNudge',
                product: 'confluence'
            }
        });
        // Clear the hover highlight decoration before opening the modal to prevent flashing
        if ((0, $dh538.fg)('cc-maui-phase-3')) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $05b902cb1d2c0384$export$95a12c22f1d400bc), {
                highlightPos: null
            }));
        api?.core.actions.execute(api?.malleableUi.commands.openRemixModal({
            nodePos: getPos(),
            nodeType: rootNodeType,
            metadata: {
                interactionSource: 'remixModalFromNudge'
            },
            source: 'blockNudge'
        }));
    }, [
        api,
        getPos,
        isDisabled,
        experienceTracker,
        rootNodeType
    ]);
    // Re-affirm activeNode when entering the remix button to prevent disappearing when moving
    // from block toward the button. Skip if already active to avoid flickering from re-dispatch.
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        const anchor = rootAnchorName ?? anchorName;
        if (activeNode?.rootAnchorName === anchor && activeNode?.rootPos === rootPos) return;
        api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(rootPos, anchor, rootNodeType, undefined, rootPos, anchor, rootNodeType));
    }, [
        api,
        rootPos,
        anchorName,
        rootAnchorName,
        rootNodeType,
        activeNode?.rootAnchorName,
        activeNode?.rootPos
    ]);
    // Show hover highlight decoration on the content block when hovering the Remix button
    const handleRemixButtonMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $05b902cb1d2c0384$export$95a12c22f1d400bc), {
            highlightPos: rootPos,
            rootNodeType: rootNodeType
        });
        view.dispatch(tr);
    }, [
        view,
        rootPos,
        rootNodeType
    ]);
    const handleRemixButtonMouseLeave = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('cc-maui-phase-3')) return;
        const tr = view.state.tr;
        tr.setMeta((0, $05b902cb1d2c0384$export$95a12c22f1d400bc), {
            highlightPos: null
        });
        view.dispatch(tr);
    }, [
        view
    ]);
    const isRemixAvailable = isRovoLLMEnabled && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    // Use block-controls shared state (activeNode) + reusable filter instead of DOM checks for restricted nodes.
    // When activeNode is null (e.g. on initial render), default to showing the button — the anchor/position
    // logic handles visibility. Only block when we have an explicit restricted node type.
    const activeNodeType = activeNode?.rootNodeType ?? activeNode?.nodeType;
    const showRemixButton = activeNodeType === undefined || (0, $9531e9c3be1ec0bb$export$ff7e5ebac3487125)({
        nodeType: activeNodeType
    });
    if (!isRemixAvailable || !showRemixButton || areAiEntryPointsDisabled) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hnbpK.VisibilityContainer), {
        api: api,
        controlSide: "right"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $74b1142437cdb6f9$var$containerBaseStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning (left, top, height) calculated at runtime
        style: positionStyles,
        "data-testid": "block-ctrl-remix-button",
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            $74b1142437cdb6f9$var$stickyButtonContainerStyles,
            (0, $dh538.fg)('confluence_remix_button_right_side_block_fg') ? $74b1142437cdb6f9$var$stickyButtonContainerStylesImprovedStickyHeader : $74b1142437cdb6f9$var$stickyButtonContainerStylesStickyHeader
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: isRemixing ? formatMessage((0, $jpEHf.messages).remixInProgressTooltip) : isDisabled ? (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason) : formatMessage((0, $jpEHf.messages).remixBlockTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1qfLF.default), {
        spacing: "compact",
        appearance: "subtle",
        shape: "circle",
        label: formatMessage((0, $jpEHf.messages).remixBlockLabel),
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
                label: "",
                size: "small"
            }),
        isDisabled: isDisabled || isRemixing,
        testId: "visible-block-ctrl-remix-button",
        analyticsContext: {
            actionSubjectId: 'remix',
            source: 'remixModalFromNudge',
            attributes: {
                ...pageMode !== undefined && {
                    pageMode: pageMode
                },
                nodeType: rootNodeType,
                ...contentId !== undefined && contentId !== '' && {
                    contentId: contentId
                }
            }
        },
        onMouseEnter: handleRemixButtonMouseEnter,
        onMouseLeave: handleRemixButtonMouseLeave,
        onBlur: handleRemixButtonMouseLeave,
        onMouseDown: (e)=>e.preventDefault(),
        onClick: handleClick
    })))));
};


const $18f19acb0a096c62$var$TYPE_REMIX_BUTTON = 'REMIX_BUTTON';
const $18f19acb0a096c62$export$901fb543799e0108 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $18f19acb0a096c62$var$TYPE_REMIX_BUTTON);
};
const $18f19acb0a096c62$export$d411c8f539cb0edd = ({ api: api, isDisabled: isDisabled, isRovoLLMEnabled: isRovoLLMEnabled, livePage: livePage, remixDisabledReason: remixDisabledReason, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType })=>{
    const key = crypto.randomUUID();
    const widgetSpec = {
        side: -4,
        type: $18f19acb0a096c62$var$TYPE_REMIX_BUTTON,
        destroy: (_)=>{
            if ((0, $dh538.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
        }
    };
    return (0, $ftzrq.Decoration).widget(rootPos, (view, getPos)=>{
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) throw new Error('Document not available');
        const element = doc.createElement('span');
        if ((0, $dh538.fg)('confluence_remix_button_right_side_block_fg')) // display:contents makes the span a "phantom" box - zero layout impact,
        // so it never pushes text down when inserted inline around media/embed wraps.
        // The inner position:absolute div in RemixButtonDecoration still renders correctly.
        element.style.display = 'contents';
        else element.style.display = 'block';
        element.contentEditable = 'false';
        if ((0, $dh538.fg)('confluence_remix_button_right_side_block_fg')) {
            // Generic right-edge control attribute for block-controls hover area (Remix-specific: data-blocks-remix-button-*)
            element.setAttribute('data-blocks-right-edge-button-container', 'true');
            element.setAttribute('data-blocks-right-edge-button-anchor', rootAnchorName ?? anchorName);
            element.setAttribute('data-blocks-remix-button-container', 'true');
            element.setAttribute('data-blocks-remix-button-anchor', rootAnchorName ?? anchorName);
        }
        element.setAttribute('data-testid', 'block-ctrl-remix-button-container');
        nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $74b1142437cdb6f9$export$e420cb1e340b26d1), {
                api: api,
                getPos: getPos,
                view: view,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                rootPos: rootPos,
                livePage: livePage,
                isDisabled: isDisabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                remixDisabledReason: remixDisabledReason
            }), element, key, undefined, true);
        return element;
    }, widgetSpec);
};





function $cb63581b05617359$export$c2f4e91d1c0a0502(onEditorViewInit, onEditorViewDestroy) {
    return new (0, $1S4f7.SafePlugin)({
        view (editorView) {
            onEditorViewInit(editorView);
            return {
                destroy () {
                    onEditorViewDestroy?.();
                }
            };
        }
    });
}












var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");








var $AMCQl = parcelRequire("AMCQl");





var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $2GVu1 = parcelRequire("2GVu1");
















const $5cf0d589d90fbdd2$var$RemixBlockMenuItem = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { api: api } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    (0, $42omo.useEffect)($5cf0d589d90fbdd2$var$_temp, t1);
    let t2;
    if ($[1] !== api.analytics?.actions || $[2] !== api.blockControls?.commands || $[3] !== api.core || $[4] !== api.malleableUi?.commands || $[5] !== api.selection?.commands || $[6] !== experienceTracker) {
        t2 = ()=>{
            api?.core?.actions.execute((t3)=>{
                const { tr: tr } = t3;
                api?.blockControls?.commands?.stopPreservingSelection()({
                    tr: tr
                });
                api?.blockControls?.commands?.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api?.selection?.commands?.clearBlockSelection()({
                    tr: tr
                });
                return tr;
            });
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    entryPoint: "editor",
                    triggeredFrom: "blockMenu"
                }
            });
            const openRemixModal = api.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromBlockMenu"
                },
                source: "remixModalFromBlockMenu"
            });
            if (openRemixModal) {
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    id: (0, $16lEl.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: "editor",
                        remixSource: "blockMenu"
                    }
                });
                api.core.actions.execute(openRemixModal);
            }
        };
        $[1] = api.analytics?.actions;
        $[2] = api.blockControls?.commands;
        $[3] = api.core;
        $[4] = api.malleableUi?.commands;
        $[5] = api.selection?.commands;
        $[6] = experienceTracker;
        $[7] = t2;
    } else t2 = $[7];
    const handleClick = t2;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        });
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $AMCQl.aiConfigItemMessages).remixTitle);
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== handleClick || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
            elemBefore: t3,
            onClick: handleClick
        }, t4);
        $[11] = handleClick;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    // Fire experiment exposure on mount — registration uses expValEqualsNoExposure
    // to avoid over-counting on every editor load. The exposure is recorded here
    // when the Remix button is actually visible to the user.
    (0, $42omo.useEffect)(()=>{
        (0, $1oCLl.expValEquals)('platform_editor_remix_in_block_menu', 'isEnabled', true);
    }, []);
    const handleClick = (0, $42omo.useCallback)(()=>{
        // Close block menu and clear selection highlight
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            return tr;
        });
        // Fire analytics
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_REMIX_BUTTON,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                entryPoint: 'editor',
                triggeredFrom: 'blockMenu'
            }
        });
        // Start experience tracking and open remix modal.
        // malleableUi is guaranteed to exist here — this component is always
        // registered by malleableUiPlugin itself.
        const openRemixModal = api.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromBlockMenu'
            },
            source: 'remixModalFromBlockMenu'
        });
        if (openRemixModal) {
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                id: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: 'editor',
                    remixSource: 'blockMenu'
                }
            });
            api.core.actions.execute(openRemixModal);
        }
    }, [
        api,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        }),
        onClick: handleClick
    }, formatMessage((0, $AMCQl.aiConfigItemMessages).remixTitle));
};
/**
 * Creates block menu registration components for the Remix action.
 *
 * Registered by editor-plugin-malleable-ui (which owns the openRemixModal command)
 * when the platform_editor_remix_in_block_menu experiment is enabled.
 * The AI plugin hides its polish/improve-formatting action when this experiment is on,
 * so the Remix item effectively replaces it.
 */ const $5cf0d589d90fbdd2$var$createRemixBlockMenuItemComponent = (api)=>{
    const RemixBlockMenuItemWrapper = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
        const $ = (0, $frIzR.c)(1);
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cf0d589d90fbdd2$var$RemixBlockMenuItem, {
                api: api
            });
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    } : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cf0d589d90fbdd2$var$RemixBlockMenuItem, {
            api: api
        });
    RemixBlockMenuItemWrapper.displayName = 'RemixBlockMenuItemWrapper';
    return RemixBlockMenuItemWrapper;
};
const $5cf0d589d90fbdd2$export$96499eef52eb1886 = ({ api: api, getEditorView: getEditorView })=>{
    return [
        {
            type: 'block-menu-item',
            key: `ai-${(0, $btNLq.AI_REMIX_MENU_ITEM).key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.AI_MENU_SECTION).key,
                rank: (0, $gEb6G.AI_MENU_SECTION_RANK)[(0, $btNLq.AI_MENU_SECTION).key]
            },
            component: $5cf0d589d90fbdd2$var$createRemixBlockMenuItemComponent(api),
            isHidden: ()=>{
                if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_ai_blockmenu_integration', 'isEnabled', true)) return true;
                const editorView = getEditorView();
                const textLength = editorView ? api?.blockControls?.actions.getTextInfo(editorView)?.textLength ?? null : null;
                // When context is unavailable, default to visible (matches AI plugin behaviour)
                if (textLength === null) return false;
                return textLength < (0, $btNLq.AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD);
            }
        }
    ];
};
function $5cf0d589d90fbdd2$var$_temp() {
    (0, $1oCLl.expValEquals)("platform_editor_remix_in_block_menu", "isEnabled", true);
}















var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $imt6g = parcelRequire("imt6g");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");




const $85200fa1528e91da$export$2a1e596305c92bc7 = ()=>({ tr: tr })=>{
        tr.setMeta((0, $LSDsY.mauiDiagramPastePluginKey), {
            type: (0, $LSDsY.ActionType).DISMISS_FLAG
        });
        return tr;
    };





const $c14e5e6d7f455b31$export$bdca710d02013452 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { api: api } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeFlag = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t1, $c14e5e6d7f455b31$var$_temp);
    let t2;
    if ($[1] !== api?.core.actions) {
        t2 = ()=>{
            api?.core.actions.execute((0, $85200fa1528e91da$export$2a1e596305c92bc7)());
        };
        $[1] = api?.core.actions;
        $[2] = t2;
    } else t2 = $[2];
    const onDismissed = t2;
    if (!activeFlag) return null;
    const title = activeFlag.title ?? "";
    const description = activeFlag.description ?? "";
    let t3;
    bb0: switch(activeFlag.type){
        case (0, $LSDsY.MauiDiagramPasteFlagType).SUCCESS:
            {
                let t4;
                if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                        label: "",
                        color: "var(--ds-icon-success, #6A9A23)"
                    });
                    $[3] = t4;
                } else t4 = $[3];
                t3 = t4;
                break bb0;
            }
        case (0, $LSDsY.MauiDiagramPasteFlagType).INFO:
            {
                let t4;
                if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                        label: "",
                        color: "var(--ds-icon-information, #357DE8)"
                    });
                    $[4] = t4;
                } else t4 = $[4];
                t3 = t4;
                break bb0;
            }
        case (0, $LSDsY.MauiDiagramPasteFlagType).ERROR:
        default:
            {
                let t4;
                if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        label: "",
                        color: "var(--ds-icon-danger, #C9372C)"
                    });
                    $[5] = t4;
                } else t4 = $[5];
                t3 = t4;
            }
    }
    const icon = t3;
    let t4;
    if ($[6] !== activeFlag.id || $[7] !== description || $[8] !== icon || $[9] !== onDismissed || $[10] !== title) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: icon
        }));
        $[6] = activeFlag.id;
        $[7] = description;
        $[8] = icon;
        $[9] = onDismissed;
        $[10] = title;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ api: api })=>{
    const activeFlag = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>states.malleableUiState?.diagramPaste?.activeFlag ?? null);
    const onDismissed = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute((0, $85200fa1528e91da$export$2a1e596305c92bc7)());
    }, [
        api
    ]);
    if (!activeFlag) return null;
    const title = activeFlag.title ?? '';
    const description = activeFlag.description ?? '';
    const icon = (()=>{
        switch(activeFlag.type){
            case (0, $LSDsY.MauiDiagramPasteFlagType).SUCCESS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                    label: "",
                    color: "var(--ds-icon-success, #6A9A23)"
                });
            case (0, $LSDsY.MauiDiagramPasteFlagType).INFO:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    label: "",
                    color: "var(--ds-icon-information, #357DE8)"
                });
            case (0, $LSDsY.MauiDiagramPasteFlagType).ERROR:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                });
        }
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: icon
    }));
};
function $c14e5e6d7f455b31$var$_temp(states) {
    return states.malleableUiState?.diagramPaste?.activeFlag ?? null;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





const $01fa406e6521134b$var$remixHoverHighlightBackground = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $01fa406e6521134b$var$remixHoverHighlightBorder = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $01fa406e6521134b$var$persistedHighlightStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- ProseMirror decoration class
    '.akEditor div.ProseMirror .remix-thinking-highlight': {
        backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)",
        textDecorationSkipInk: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Default remix hover highlight for non-table nodes
    '.akEditor div.ProseMirror .remix-hover-highlight': {
        background: $01fa406e6521134b$var$remixHoverHighlightBackground,
        boxShadow: `0 0 0 2px ${$01fa406e6521134b$var$remixHoverHighlightBorder}`
    }
});
const $01fa406e6521134b$export$3bccfb6f759a17 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: $01fa406e6521134b$var$persistedHighlightStyles
    }));
};


















var $40aJG = parcelRequire("40aJG");













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");




var $1Whri = parcelRequire("1Whri");


var $7YjFd = parcelRequire("7YjFd");





var $hmuev = parcelRequire("hmuev");


var $gdv5Z = parcelRequire("gdv5Z");

const $b100ecee4c7a9dad$var$messages = (0, $aXWIB.defineMessages)({
    remixReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.remixReady",
        defaultMessage: "Your remix is ready"
    },
    updateReady: {
        id: "malleable-ui-components.remix.remix-ready-toast.updateReady",
        defaultMessage: "Your edits are ready"
    },
    viewButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.viewButton",
        defaultMessage: "View"
    },
    closeButton: {
        id: "malleable-ui-components.remix.remix-ready-toast.closeButton",
        defaultMessage: "Close"
    }
});
const $b100ecee4c7a9dad$var$styles = {
    container: "_zulpu2gc _2rkopb1k _kqsw1n9t _94n5pxbi _1ltv1ssb _t9eczr6s _1e0c1txw _4cvr1h6o _1ul91gwv _1tkeckbl _19bvpxbi _u5f3u2gc _bfhkvuon _16qs130s _1pbyni7l",
    absolute: "_kqswstnw",
    readyMessage: "_11c8fhey _16jlkb7n _1o9zidpf _i0dl1wug _19bvu2gc _syazazsu _k48p1wq8"
};
const $b100ecee4c7a9dad$var$AUTO_DISMISS_DELAY_MS = 10000;
const $b100ecee4c7a9dad$var$SHORT_AUTO_DISMISS_DELAY_MS = 1000;
function $b100ecee4c7a9dad$export$c758b087b04ee4fe({ isUpdate: isUpdate = false, onView: onView, onClose: onClose, showActions: showActions = true } = {}) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const wrapperRef = (0, $42omo.useRef)(null);
    const [isAbsolute, setIsAbsolute] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
         // no scrollParent, such as Jira description editor
        // if in the future, they do have scrollParent, then we need to check if offsetParent is in scrollParent
        const scrollParent = (0, $7YjFd.findOverflowScrollParent)(wrapperRef.current);
        if (!scrollParent) {
            // wrapperRef.current.offsetParent is null when it's fixed
            // so we have to check the parentElement's offsetParent
            const offsetParent = wrapperRef.current.parentElement?.offsetParent;
            if (offsetParent) {
                const offsetParentRect = offsetParent.getBoundingClientRect();
                if (offsetParentRect.bottom < window.innerHeight) setIsAbsolute(true);
            }
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        const timeoutId = window.setTimeout(()=>{
            onClose?.({
                auto: true
            });
        }, showActions ? $b100ecee4c7a9dad$var$AUTO_DISMISS_DELAY_MS : $b100ecee4c7a9dad$var$SHORT_AUTO_DISMISS_DELAY_MS);
        return ()=>window.clearTimeout(timeoutId);
    }, [
        onClose,
        showActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: wrapperRef,
        xcss: (0, $1Whri.cx)($b100ecee4c7a9dad$var$styles.container, isAbsolute && $b100ecee4c7a9dad$var$styles.absolute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $b100ecee4c7a9dad$var$styles.readyMessage
    }, formatMessage(isUpdate ? $b100ecee4c7a9dad$var$messages.updateReady : $b100ecee4c7a9dad$var$messages.remixReady)), showActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onView
    }, formatMessage($b100ecee4c7a9dad$var$messages.viewButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        spacing: "compact",
        appearance: "subtle",
        label: formatMessage($b100ecee4c7a9dad$var$messages.closeButton),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: ""
            }),
        onClick: ()=>onClose?.()
    })));
}



function $e0e65902b93c380a$export$81acf0fbb9db54fa(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $4b6f0776a18b2b53$export$2e13bdf171bca4ae), {
            payload: options,
            type: 'addHistoryEntry'
        });
        return tr;
    };
}



function $777fd979867d0ead$export$9f60bd9ee414a7c0(options) {
    return ({ tr: tr })=>{
        tr.setMeta((0, $4b6f0776a18b2b53$export$2e13bdf171bca4ae), {
            type: 'addHistoryStackEntry',
            payload: options
        });
        return tr;
    };
}




const $6f9d04078daabe3a$export$831107003cfefb8 = (isComplete)=>({ tr: tr })=>{
        tr.setMeta((0, $dd89be7a43af642f$export$38c8fc373d691b1d), {
            isComplete: isComplete
        });
        return tr;
    };





const $9e5e2ca4c710d681$export$9c8ccf478e05e6c0 = (showLocationPicker)=>({ tr: tr })=>{
        tr.setMeta((0, $qJp20.malleableUiPluginKey), {
            showLocationPicker: showLocationPicker
        });
        return tr;
    };

















const $10eec674a570be21$var$isElementInViewport = ({ element: element, root: root })=>{
    try {
        const elementRect = element.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        return elementRect.bottom > rootRect.top && elementRect.right > rootRect.left && elementRect.top < rootRect.bottom && elementRect.left < rootRect.right;
    } catch  {
        return true;
    }
};
const $10eec674a570be21$export$7523f6d059999b11 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(4);
    const { editorView: editorView, isComplete: isComplete } = t0;
    const [isThinkingWidgetInViewport, setIsThinkingWidgetInViewport] = (0, $42omo.useState)(true);
    let t1;
    let t2;
    if ($[0] !== editorView || $[1] !== isComplete) {
        t1 = ()=>{
            if (!isComplete) {
                setIsThinkingWidgetInViewport(true);
                return;
            }
            if (!editorView) {
                setIsThinkingWidgetInViewport(true);
                return;
            }
            const container = (0, $97b2a67a46a9d3d6$export$2f3df55a342cf539)(editorView);
            if (!container) {
                setIsThinkingWidgetInViewport(true);
                return;
            }
            const root = (0, $7YjFd.findOverflowScrollParent)(editorView.dom) || document.body;
            if (!root) {
                setIsThinkingWidgetInViewport(true);
                return;
            }
            const isInViewport = $10eec674a570be21$var$isElementInViewport({
                element: container,
                root: root
            });
            setIsThinkingWidgetInViewport(isInViewport);
        };
        t2 = [
            editorView,
            isComplete
        ];
        $[0] = editorView;
        $[1] = isComplete;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    return isThinkingWidgetInViewport;
} : ({ editorView: editorView, isComplete: isComplete })=>{
    const [isThinkingWidgetInViewport, setIsThinkingWidgetInViewport] = (0, $42omo.useState)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isComplete) {
            setIsThinkingWidgetInViewport(true);
            return;
        }
        if (!editorView) {
            setIsThinkingWidgetInViewport(true);
            return;
        }
        const container = (0, $97b2a67a46a9d3d6$export$2f3df55a342cf539)(editorView);
        if (!container) {
            setIsThinkingWidgetInViewport(true);
            return;
        }
        const root = (0, $7YjFd.findOverflowScrollParent)(editorView.dom) || document.body;
        if (!root) {
            setIsThinkingWidgetInViewport(true);
            return;
        }
        const isInViewport = $10eec674a570be21$var$isElementInViewport({
            element: container,
            root: root
        });
        setIsThinkingWidgetInViewport(isInViewport);
    }, [
        editorView,
        isComplete
    ]);
    return isThinkingWidgetInViewport;
};



const $6ab95f584bb8fa39$export$9b636cd211668abd = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(119);
    const { api: api, config: config } = t0;
    const { createRemixContentComponent: createRemixContentComponent } = config;
    const { editorView: editorView } = (0, $42omo.useContext)((0, $40aJG.default));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "editorViewMode"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const isViewMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t1, $6ab95f584bb8fa39$var$_temp);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            "malleableUi"
        ];
        $[1] = t2;
    } else t2 = $[1];
    const isModalOpen = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t2, $6ab95f584bb8fa39$var$_temp2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "malleableUi"
        ];
        $[2] = t3;
    } else t3 = $[2];
    const isThinking = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t3, $6ab95f584bb8fa39$var$_temp3);
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            "malleableUi"
        ];
        $[3] = t4;
    } else t4 = $[3];
    const isComplete = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t4, $6ab95f584bb8fa39$var$_temp4);
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            "malleableUi"
        ];
        $[4] = t5;
    } else t5 = $[4];
    const remixModalMetadata = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t5, $6ab95f584bb8fa39$var$_temp5);
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [
            "malleableUi"
        ];
        $[5] = t6;
    } else t6 = $[5];
    const remixSource = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t6, $6ab95f584bb8fa39$var$_temp6);
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            "malleableUi"
        ];
        $[6] = t7;
    } else t7 = $[6];
    const showLocationPicker = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t7, $6ab95f584bb8fa39$var$_temp7);
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [
            "malleableUi"
        ];
        $[7] = t8;
    } else t8 = $[7];
    const isUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t8, $6ab95f584bb8fa39$var$_temp8);
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            "malleableUi"
        ];
        $[8] = t9;
    } else t9 = $[8];
    const historyEntryForUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t9, $6ab95f584bb8fa39$var$_temp9);
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            "malleableUi"
        ];
        $[9] = t10;
    } else t10 = $[9];
    const dynamicUiSubtypeForUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t10, $6ab95f584bb8fa39$var$_temp0);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const prevIsModalOpen = (0, $42omo.useRef)(false);
    let t11;
    let t12;
    if ($[10] !== experienceTracker || $[11] !== isModalOpen || $[12] !== remixSource) {
        t11 = ()=>{
            if (!prevIsModalOpen.current && isModalOpen && remixSource === "floatingToolbar") experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                id: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "floatingToolbar",
                    product: "confluence"
                }
            });
            prevIsModalOpen.current = isModalOpen;
        };
        t12 = [
            isModalOpen,
            remixSource,
            experienceTracker
        ];
        $[10] = experienceTracker;
        $[11] = isModalOpen;
        $[12] = remixSource;
        $[13] = t11;
        $[14] = t12;
    } else {
        t11 = $[13];
        t12 = $[14];
    }
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[15] !== createRemixContentComponent) {
        t13 = createRemixContentComponent();
        $[15] = createRemixContentComponent;
        $[16] = t13;
    } else t13 = $[16];
    const Component = t13;
    let t14;
    if ($[17] !== api?.core.actions || $[18] !== api?.malleableUi.commands) {
        t14 = ()=>{
            api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
        };
        $[17] = api?.core.actions;
        $[18] = api?.malleableUi.commands;
        $[19] = t14;
    } else t14 = $[19];
    const handleModalClose = t14;
    let t15;
    if ($[20] !== api) {
        t15 = (options)=>{
            if ((0, $dh538.fg)("platform_editor_ai_remix_toolbar")) (0, $ccb60ab150962a8e$export$fdf82e9851b59bf0)({
                api: api,
                options: options
            });
            else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
                api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
            }
        };
        $[20] = api;
        $[21] = t15;
    } else t15 = $[21];
    const onStartThinking = t15;
    let t16;
    if ($[22] !== api) {
        t16 = (options_0)=>{
            if ((0, $dh538.fg)("platform_editor_ai_remix_toolbar")) {
                (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
                (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                    api: api,
                    reopenModal: options_0?.reopenModal
                });
            } else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_0));
            }
        };
        $[22] = api;
        $[23] = t16;
    } else t16 = $[23];
    const onStopThinking = t16;
    let t17;
    if ($[24] !== api) {
        t17 = (options_1)=>{
            if ((0, $dh538.fg)("platform_editor_ai_remix_toolbar")) (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                api: api,
                reopenModal: options_1?.reopenModal
            });
            else {
                api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
                api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_1));
            }
        };
        $[24] = api;
        $[25] = t17;
    } else t17 = $[25];
    const onDismissThinkingUi = t17;
    let t18;
    if ($[26] !== api) {
        t18 = (abortFn)=>(0, $f5c49cf2f2007592$export$f9cb53c9d12f6f55)(api, abortFn);
        $[26] = api;
        $[27] = t18;
    } else t18 = $[27];
    const onRegisterAbortRequest = t18;
    let t19;
    if ($[28] !== api?.core.actions) {
        t19 = ()=>{
            api?.core.actions.execute((0, $2daab9aee767d4c3$export$65f89d2d4741e4b7)());
        };
        $[28] = api?.core.actions;
        $[29] = t19;
    } else t19 = $[29];
    const clearThinkingDecoration = t19;
    let t20;
    if ($[30] !== api?.core.actions || $[31] !== api?.malleableUi.commands) {
        t20 = (options_2)=>{
            api?.core.actions.execute(api?.malleableUi.commands.replaceWhiteboardEmbed(options_2));
        };
        $[30] = api?.core.actions;
        $[31] = api?.malleableUi.commands;
        $[32] = t20;
    } else t20 = $[32];
    const replaceWhiteboardEmbed = t20;
    let t21;
    if ($[33] !== api?.aiExperience?.actions || $[34] !== api?.core.actions) {
        t21 = (isComplete_0)=>{
            if (isComplete_0) api?.aiExperience?.actions?.endInlineRovoStreaming?.();
            api?.core.actions.execute((0, $6f9d04078daabe3a$export$831107003cfefb8)(isComplete_0));
        };
        $[33] = api?.aiExperience?.actions;
        $[34] = api?.core.actions;
        $[35] = t21;
    } else t21 = $[35];
    const setThinkingComplete = t21;
    let t22;
    if ($[36] !== api) {
        t22 = ()=>{
            (0, $f5c49cf2f2007592$export$ae8cbff5055b0856)({
                api: api
            });
        };
        $[36] = api;
        $[37] = t22;
    } else t22 = $[37];
    const finishRemixThinking = t22;
    let t23;
    if ($[38] !== api) {
        t23 = ()=>{
            (0, $f5c49cf2f2007592$export$ae8cbff5055b0856)({
                api: api
            });
        };
        $[38] = api;
        $[39] = t23;
    } else t23 = $[39];
    const _onRemixThinkingCompleteAnimationFinished = t23;
    let t24;
    if ($[40] !== api?.core.actions) {
        t24 = (showLocationPicker_0)=>{
            api?.core.actions.execute((0, $9e5e2ca4c710d681$export$9c8ccf478e05e6c0)(showLocationPicker_0));
        };
        $[40] = api?.core.actions;
        $[41] = t24;
    } else t24 = $[41];
    const setShowLocationPicker = t24;
    let t25;
    if ($[42] !== api?.core.actions) {
        t25 = (options_3)=>{
            api?.core.actions.execute((0, $e0e65902b93c380a$export$81acf0fbb9db54fa)(options_3));
        };
        $[42] = api?.core.actions;
        $[43] = t25;
    } else t25 = $[43];
    const addHistoryEntry = t25;
    let t26;
    if ($[44] !== api?.core.actions) {
        t26 = (options_4)=>{
            api?.core.actions.execute((0, $777fd979867d0ead$export$9f60bd9ee414a7c0)(options_4));
        };
        $[44] = api?.core.actions;
        $[45] = t26;
    } else t26 = $[45];
    const addHistoryStackEntry = t26;
    let t27;
    if ($[46] !== api) {
        t27 = (id)=>{
            if (!api?.malleableUi?.commands.trackVariantUpdateComplete) return;
            api.core.actions.execute(api.malleableUi.commands.trackVariantUpdateComplete({
                id: id
            }));
        };
        $[46] = api;
        $[47] = t27;
    } else t27 = $[47];
    const onVariantUpdateComplete = t27;
    let t28;
    if ($[48] !== editorView || $[49] !== isComplete) {
        t28 = {
            editorView: editorView,
            isComplete: isComplete
        };
        $[48] = editorView;
        $[49] = isComplete;
        $[50] = t28;
    } else t28 = $[50];
    const isThinkingWidgetInViewport = (0, $10eec674a570be21$export$7523f6d059999b11)(t28);
    let t29;
    if ($[51] !== editorView || $[52] !== setThinkingComplete) {
        t29 = ()=>{
            if (editorView) {
                const container = (0, $97b2a67a46a9d3d6$export$2f3df55a342cf539)(editorView);
                if ((0, $dh538.fg)("platform_editor_ai_remix_toolbar")) {
                    const sibling = container?.previousElementSibling;
                    sibling?.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                } else {
                    const nextSibling = container?.nextSibling;
                    if (nextSibling instanceof HTMLElement) nextSibling.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            }
            setThinkingComplete(false);
        };
        $[51] = editorView;
        $[52] = setThinkingComplete;
        $[53] = t29;
    } else t29 = $[53];
    const handleReadyToastView = t29;
    let t30;
    if ($[54] !== setThinkingComplete) {
        t30 = ()=>{
            setThinkingComplete(false);
        };
        $[54] = setThinkingComplete;
        $[55] = t30;
    } else t30 = $[55];
    const handleReadyToastClose = t30;
    let t31;
    if ($[56] !== api || $[57] !== editorView || $[58] !== isThinking || $[59] !== isUpdate || $[60] !== onStopThinking) {
        t31 = ()=>{
            if (!(0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading")) return;
            if (!isThinking || !editorView) return;
            if (!editorView.hasFocus()) editorView.focus();
            return (0, $fFa3V.bind)(editorView.dom, {
                type: "keydown",
                listener: (e)=>{
                    if (e.key === "Escape") {
                        e.stopPropagation();
                        if ((0, $dh538.fg)("platform_editor_ai_remix_toolbar")) {
                            (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
                            (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                                api: api
                            });
                        } else {
                            if ((0, $dZ8uq.expValEqualsNoExposure)("cc_page_experiences_editor_image_generation", "isEnabled", true)) {
                                const currentMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
                                const cancelledPrompt = currentMetadata?.userPrompt;
                                const onCancel = currentMetadata?.onCancel;
                                if (cancelledPrompt && onCancel) {
                                    onStopThinking({
                                        reopenModal: false
                                    });
                                    onCancel();
                                    return;
                                }
                            }
                            onStopThinking({
                                reopenModal: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? !isUpdate : true
                            });
                        }
                    }
                }
            });
        };
        $[56] = api;
        $[57] = editorView;
        $[58] = isThinking;
        $[59] = isUpdate;
        $[60] = onStopThinking;
        $[61] = t31;
    } else t31 = $[61];
    const t32 = api?.malleableUi.sharedState;
    let t33;
    if ($[62] !== api || $[63] !== editorView || $[64] !== isThinking || $[65] !== isUpdate || $[66] !== onStopThinking || $[67] !== t32) {
        t33 = [
            isThinking,
            onStopThinking,
            editorView,
            t32,
            isUpdate,
            api
        ];
        $[62] = api;
        $[63] = editorView;
        $[64] = isThinking;
        $[65] = isUpdate;
        $[66] = onStopThinking;
        $[67] = t32;
        $[68] = t33;
    } else t33 = $[68];
    (0, $42omo.useEffect)(t31, t33);
    let t34;
    if ($[69] !== api?.core?.actions || $[70] !== api?.userIntent?.commands || $[71] !== api?.userIntent?.sharedState || $[72] !== isModalOpen) {
        t34 = ()=>{
            if (!(0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading")) return;
            if (!isModalOpen) {
                if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === "overlayOpen") api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent("default"));
                return;
            }
            api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent("overlayOpen"));
            return ()=>{
                api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent("default"));
            };
        };
        $[69] = api?.core?.actions;
        $[70] = api?.userIntent?.commands;
        $[71] = api?.userIntent?.sharedState;
        $[72] = isModalOpen;
        $[73] = t34;
    } else t34 = $[73];
    let t35;
    if ($[74] !== api || $[75] !== isModalOpen) {
        t35 = [
            isModalOpen,
            api
        ];
        $[74] = api;
        $[75] = isModalOpen;
        $[76] = t35;
    } else t35 = $[76];
    (0, $42omo.useLayoutEffect)(t34, t35);
    if (!api || !Component) return null;
    let t36;
    if ($[77] !== api?.aiExperience?.actions) {
        t36 = api?.aiExperience?.actions.getAISelectionContext();
        $[77] = api?.aiExperience?.actions;
        $[78] = t36;
    } else t36 = $[78];
    const selectedContext = t36;
    if (!selectedContext) return null;
    if (!isViewMode && isComplete && !isThinking && !isModalOpen && (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading")) {
        let t37;
        if ($[79] !== handleReadyToastClose || $[80] !== handleReadyToastView || $[81] !== isThinkingWidgetInViewport || $[82] !== isUpdate) {
            t37 = !isThinkingWidgetInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b100ecee4c7a9dad$export$c758b087b04ee4fe), {
                isUpdate: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? isUpdate : undefined,
                onView: handleReadyToastView,
                onClose: handleReadyToastClose
            }) : null;
            $[79] = handleReadyToastClose;
            $[80] = handleReadyToastView;
            $[81] = isThinkingWidgetInViewport;
            $[82] = isUpdate;
            $[83] = t37;
        } else t37 = $[83];
        return t37;
    }
    const hasPreSuppliedPrompt = !!remixModalMetadata?.userPrompt;
    let t37;
    if ($[84] !== hasPreSuppliedPrompt || $[85] !== isModalOpen || $[86] !== isThinking || $[87] !== showLocationPicker) {
        t37 = isModalOpen || isThinking || showLocationPicker || !(0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") && !hasPreSuppliedPrompt;
        $[84] = hasPreSuppliedPrompt;
        $[85] = isModalOpen;
        $[86] = isThinking;
        $[87] = showLocationPicker;
        $[88] = t37;
    } else t37 = $[88];
    const canShow = t37;
    let t38;
    if ($[89] !== Component || $[90] !== _onRemixThinkingCompleteAnimationFinished || $[91] !== addHistoryEntry || $[92] !== addHistoryStackEntry || $[93] !== api || $[94] !== canShow || $[95] !== clearThinkingDecoration || $[96] !== config.hiddenOptions || $[97] !== dynamicUiSubtypeForUpdate || $[98] !== finishRemixThinking || $[99] !== handleModalClose || $[100] !== historyEntryForUpdate || $[101] !== isComplete || $[102] !== isModalOpen || $[103] !== isThinking || $[104] !== isUpdate || $[105] !== isViewMode || $[106] !== onDismissThinkingUi || $[107] !== onRegisterAbortRequest || $[108] !== onStartThinking || $[109] !== onStopThinking || $[110] !== onVariantUpdateComplete || $[111] !== remixModalMetadata || $[112] !== remixSource || $[113] !== replaceWhiteboardEmbed || $[114] !== selectedContext || $[115] !== setShowLocationPicker || $[116] !== setThinkingComplete || $[117] !== showLocationPicker) {
        t38 = canShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            isViewMode: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? isViewMode : undefined,
            isModalOpen: isModalOpen,
            isThinking: isThinking,
            isUpdate: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? isUpdate : undefined,
            historyEntryForUpdate: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? historyEntryForUpdate : undefined,
            dynamicUiSubtypeForUpdate: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? dynamicUiSubtypeForUpdate : undefined,
            isComplete: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? isComplete : undefined,
            handleModalClose: handleModalClose,
            remixSource: remixSource,
            selectedContext: selectedContext,
            editorApi: api,
            clearThinkingDecoration: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? clearThinkingDecoration : undefined,
            replaceWhiteboardEmbed: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? replaceWhiteboardEmbed : undefined,
            setThinkingComplete: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? setThinkingComplete : undefined,
            finishRemixThinking: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? finishRemixThinking : undefined,
            onStartThinking: onStartThinking,
            onDismissThinkingUi: onDismissThinkingUi,
            onStopThinking: onStopThinking,
            onRegisterAbortRequest: onRegisterAbortRequest,
            onRemixThinkingCompleteAnimationFinished: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? _onRemixThinkingCompleteAnimationFinished : undefined,
            showLocationPicker: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? showLocationPicker : false,
            setShowLocationPicker: (0, $dh538.fg)("platform_editor_ai_remix_in_editor_loading") ? setShowLocationPicker : $6ab95f584bb8fa39$var$_temp1,
            addHistoryEntry: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? addHistoryEntry : $6ab95f584bb8fa39$var$_temp10,
            addHistoryStackEntry: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? addHistoryStackEntry : $6ab95f584bb8fa39$var$_temp11,
            onVariantUpdateComplete: (0, $dh538.fg)("platform_editor_ai_remix_toolbar") ? onVariantUpdateComplete : undefined,
            remixModalMetadata: remixModalMetadata,
            hiddenOptions: config.hiddenOptions
        }) : null;
        $[89] = Component;
        $[90] = _onRemixThinkingCompleteAnimationFinished;
        $[91] = addHistoryEntry;
        $[92] = addHistoryStackEntry;
        $[93] = api;
        $[94] = canShow;
        $[95] = clearThinkingDecoration;
        $[96] = config.hiddenOptions;
        $[97] = dynamicUiSubtypeForUpdate;
        $[98] = finishRemixThinking;
        $[99] = handleModalClose;
        $[100] = historyEntryForUpdate;
        $[101] = isComplete;
        $[102] = isModalOpen;
        $[103] = isThinking;
        $[104] = isUpdate;
        $[105] = isViewMode;
        $[106] = onDismissThinkingUi;
        $[107] = onRegisterAbortRequest;
        $[108] = onStartThinking;
        $[109] = onStopThinking;
        $[110] = onVariantUpdateComplete;
        $[111] = remixModalMetadata;
        $[112] = remixSource;
        $[113] = replaceWhiteboardEmbed;
        $[114] = selectedContext;
        $[115] = setShowLocationPicker;
        $[116] = setThinkingComplete;
        $[117] = showLocationPicker;
        $[118] = t38;
    } else t38 = $[118];
    return t38;
} : ({ api: api, config: config })=>{
    const { createRemixContentComponent: createRemixContentComponent } = config;
    const { editorView: editorView } = (0, $42omo.useContext)((0, $40aJG.default));
    const isViewMode = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode === 'view');
    const isModalOpen = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_0)=>states_0.malleableUiState?.isRemixModalOpen || false);
    const isThinking = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_1)=>states_1.malleableUiState?.isThinking || false);
    const isComplete = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_2)=>states_2.malleableUiState?.isComplete || false);
    const remixModalMetadata = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_3)=>states_3.malleableUiState?.remixModalMetadata);
    const remixSource = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_4)=>states_4.malleableUiState?.remixSource);
    const showLocationPicker = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_5)=>states_5.malleableUiState?.showLocationPicker || false);
    const isUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_6)=>states_6.malleableUiState?.isUpdate || false);
    const historyEntryForUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_7)=>states_7.malleableUiState?.historyEntryForUpdate);
    const dynamicUiSubtypeForUpdate = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states_8)=>states_8.malleableUiState?.dynamicUiSubtypeForUpdate);
    // Start Remix experience for floating toolbar entry point (can't use hooks in toolbar config).
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const prevIsModalOpen = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!prevIsModalOpen.current && isModalOpen && remixSource === 'floatingToolbar') experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'floatingToolbar',
                product: 'confluence'
            }
        });
        prevIsModalOpen.current = isModalOpen;
    }, [
        isModalOpen,
        remixSource,
        experienceTracker
    ]);
    const Component = (0, $42omo.useMemo)(()=>createRemixContentComponent(), [
        createRemixContentComponent
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(api?.malleableUi.commands.closeRemixModal());
    }, [
        api
    ]);
    const onStartThinking = (0, $42omo.useCallback)((options)=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) (0, $ccb60ab150962a8e$export$fdf82e9851b59bf0)({
            api: api,
            options: options
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
            api?.core.actions.execute(api?.malleableUi.commands.startRemixThinking(options));
        }
    }, [
        api
    ]);
    const onStopThinking = (0, $42omo.useCallback)((options_0)=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
            // Abort before cancelling so send-message-action.ts fires the paired
            // aiInteraction initiated + dismissed events via AbortError.
            (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
            (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                api: api,
                reopenModal: options_0?.reopenModal
            });
        } else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_0));
        }
    }, [
        api
    ]);
    const onDismissThinkingUi = (0, $42omo.useCallback)((options_1)=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
            api: api,
            reopenModal: options_1?.reopenModal
        });
        else {
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
            api?.core.actions.execute(api?.malleableUi.commands.stopRemixThinking(options_1));
        }
    }, [
        api
    ]);
    const onRegisterAbortRequest = (0, $42omo.useCallback)((abortFn)=>(0, $f5c49cf2f2007592$export$f9cb53c9d12f6f55)(api, abortFn), [
        api
    ]);
    const clearThinkingDecoration = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute((0, $2daab9aee767d4c3$export$65f89d2d4741e4b7)());
    }, [
        api
    ]);
    const replaceWhiteboardEmbed = (0, $42omo.useCallback)((options_2)=>{
        api?.core.actions.execute(api?.malleableUi.commands.replaceWhiteboardEmbed(options_2));
    }, [
        api
    ]);
    const setThinkingComplete = (0, $42omo.useCallback)((isComplete_0)=>{
        // this is to clear the inline-Rovo streaming target when the remix is complete
        if (isComplete_0) api?.aiExperience?.actions?.endInlineRovoStreaming?.();
        api?.core.actions.execute((0, $6f9d04078daabe3a$export$831107003cfefb8)(isComplete_0));
    }, [
        api
    ]);
    const finishRemixThinking = (0, $42omo.useCallback)(()=>{
        (0, $f5c49cf2f2007592$export$ae8cbff5055b0856)({
            api: api
        });
    }, [
        api
    ]);
    const _onRemixThinkingCompleteAnimationFinished = (0, $42omo.useCallback)(()=>{
        (0, $f5c49cf2f2007592$export$ae8cbff5055b0856)({
            api: api
        });
    }, [
        api
    ]);
    const setShowLocationPicker = (0, $42omo.useCallback)((showLocationPicker_0)=>{
        api?.core.actions.execute((0, $9e5e2ca4c710d681$export$9c8ccf478e05e6c0)(showLocationPicker_0));
    }, [
        api
    ]);
    const addHistoryEntry = (0, $42omo.useCallback)((options_3)=>{
        api?.core.actions.execute((0, $e0e65902b93c380a$export$81acf0fbb9db54fa)(options_3));
    }, [
        api
    ]);
    const addHistoryStackEntry = (0, $42omo.useCallback)((options_4)=>{
        api?.core.actions.execute((0, $777fd979867d0ead$export$9f60bd9ee414a7c0)(options_4));
    }, [
        api
    ]);
    // Bridges the plugin's `trackVariantUpdateComplete` command into the
    // remix flow; `useOnComplete` fires it once the FE insertion settles.
    const onVariantUpdateComplete = (0, $42omo.useCallback)((id)=>{
        if (!api?.malleableUi?.commands.trackVariantUpdateComplete) return;
        api.core.actions.execute(api.malleableUi.commands.trackVariantUpdateComplete({
            id: id
        }));
    }, [
        api
    ]);
    const isThinkingWidgetInViewport = (0, $10eec674a570be21$export$7523f6d059999b11)({
        editorView: editorView,
        isComplete: isComplete
    });
    const handleReadyToastView = (0, $42omo.useCallback)(()=>{
        if (editorView) {
            const container = (0, $97b2a67a46a9d3d6$export$2f3df55a342cf539)(editorView);
            if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                // for insertion, the next sibling should be the inserted content
                // but after insertion, the decoration is re-rendered after the insertion
                // so the inserted content become the previous sibling
                // for update, the previous sibling is the updated content
                const sibling = container?.previousElementSibling;
                sibling?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            } else {
                // the next sibling is the inserted content
                const nextSibling = container?.nextSibling;
                if (nextSibling instanceof HTMLElement) nextSibling.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
        // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        editorView,
        setThinkingComplete
    ]);
    const handleReadyToastClose = (0, $42omo.useCallback)(()=>{
        // setThinkingComplete(false); do the job, but a reset could be more meaningful
        setThinkingComplete(false);
    }, [
        setThinkingComplete
    ]);
    // handle escape key to stop remix thinking
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isThinking || !editorView) return;
        // focus editor first
        if (!editorView.hasFocus()) editorView.focus();
        return (0, $fFa3V.bind)(editorView.dom, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                        // Abort before cancelling so send-message-action.ts fires the paired
                        // aiInteraction initiated + dismissed events via AbortError.
                        (0, $f5c49cf2f2007592$export$e125c3b8c9ddf1a1)(api)?.();
                        (0, $f5c49cf2f2007592$export$e02ace41eac2e13a)({
                            api: api
                        });
                    } else {
                        if ((0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
                            // If a pre-supplied userPrompt was cancelled (e.g. image generation flow),
                            // call the onCancel callback instead of reopening the remix modal.
                            const currentMetadata = api?.malleableUi?.sharedState.currentState()?.remixModalMetadata;
                            const cancelledPrompt = currentMetadata?.userPrompt;
                            const onCancel = currentMetadata?.onCancel;
                            if (cancelledPrompt && onCancel) {
                                onStopThinking({
                                    reopenModal: false
                                });
                                onCancel();
                                return;
                            }
                        }
                        onStopThinking({
                            reopenModal: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? !isUpdate : true
                        });
                    }
                }
            }
        });
    }, [
        isThinking,
        onStopThinking,
        editorView,
        api?.malleableUi.sharedState,
        isUpdate,
        api
    ]);
    // When the remix modal overlay is open (isModalOpen),
    // set the editor user intent to 'overlayOpen' so the floating toolbar is suppressed
    // (it would otherwise appear above the overlay in Jira).
    // We intentionally do NOT suppress during the thinking-only state
    // — the user may still interact with the editor while the AI is thinking.
    // Reset to 'default' when the modal closes or the component unmounts.
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (!isModalOpen) {
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'overlayOpen') api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            return;
        }
        api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('overlayOpen'));
        return ()=>{
            api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
        };
    }, [
        isModalOpen,
        api
    ]);
    if (!api || !Component) return null;
    const selectedContext = api?.aiExperience?.actions.getAISelectionContext();
    if (!selectedContext) return null;
    // when the remix isComplete and
    // - the modal is not open because isComplete may not be reset to false when the modal is open
    // - not thinking because we need to show the thinking bar when isThinking and isComplete
    //   - after onCompleteAnimationFinished, isThinking will be false and only isComplete will be true
    // we need to show the ready toast
    if (!isViewMode && isComplete && !isThinking && !isModalOpen && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return !isThinkingWidgetInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b100ecee4c7a9dad$export$c758b087b04ee4fe), {
        isUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? isUpdate : undefined,
        onView: handleReadyToastView,
        onClose: handleReadyToastClose
    }) : null;
    // When the flag is ON, only show when isModalOpen, isThinking, or showLocationPicker — this
    // is the correct gating behaviour for the new loading path.
    // When the flag is OFF (legacy path), always show — EXCEPT when a pre-supplied userPrompt
    // is present (image-gen flow) and the flow is done (neither isModalOpen nor isThinking),
    // to prevent the option-picker from flashing on cancellation.
    const hasPreSuppliedPrompt = !!remixModalMetadata?.userPrompt;
    const canShow = isModalOpen || isThinking || showLocationPicker || !(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') && !hasPreSuppliedPrompt;
    return canShow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        isViewMode: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? isViewMode : undefined,
        isModalOpen: isModalOpen,
        isThinking: isThinking,
        isUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? isUpdate : undefined,
        historyEntryForUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? historyEntryForUpdate : undefined,
        dynamicUiSubtypeForUpdate: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? dynamicUiSubtypeForUpdate : undefined,
        isComplete: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? isComplete : undefined,
        handleModalClose: handleModalClose,
        remixSource: remixSource,
        selectedContext: selectedContext,
        editorApi: api,
        clearThinkingDecoration: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? clearThinkingDecoration : undefined,
        replaceWhiteboardEmbed: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? replaceWhiteboardEmbed : undefined,
        setThinkingComplete: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? setThinkingComplete : undefined,
        finishRemixThinking: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? finishRemixThinking : undefined,
        onStartThinking: onStartThinking,
        onDismissThinkingUi: onDismissThinkingUi,
        onStopThinking: onStopThinking,
        onRegisterAbortRequest: onRegisterAbortRequest,
        onRemixThinkingCompleteAnimationFinished: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? _onRemixThinkingCompleteAnimationFinished : undefined,
        showLocationPicker: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? showLocationPicker : false,
        setShowLocationPicker: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? setShowLocationPicker : ()=>{},
        addHistoryEntry: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? addHistoryEntry : ()=>{},
        addHistoryStackEntry: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? addHistoryStackEntry : ()=>{},
        onVariantUpdateComplete: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? onVariantUpdateComplete : undefined,
        remixModalMetadata: remixModalMetadata,
        hiddenOptions: config.hiddenOptions
    }) : null;
};
function $6ab95f584bb8fa39$var$_temp(states) {
    return states.editorViewModeState?.mode === "view";
}
function $6ab95f584bb8fa39$var$_temp2(states_0) {
    return states_0.malleableUiState?.isRemixModalOpen || false;
}
function $6ab95f584bb8fa39$var$_temp3(states_1) {
    return states_1.malleableUiState?.isThinking || false;
}
function $6ab95f584bb8fa39$var$_temp4(states_2) {
    return states_2.malleableUiState?.isComplete || false;
}
function $6ab95f584bb8fa39$var$_temp5(states_3) {
    return states_3.malleableUiState?.remixModalMetadata;
}
function $6ab95f584bb8fa39$var$_temp6(states_4) {
    return states_4.malleableUiState?.remixSource;
}
function $6ab95f584bb8fa39$var$_temp7(states_5) {
    return states_5.malleableUiState?.showLocationPicker || false;
}
function $6ab95f584bb8fa39$var$_temp8(states_6) {
    return states_6.malleableUiState?.isUpdate || false;
}
function $6ab95f584bb8fa39$var$_temp9(states_7) {
    return states_7.malleableUiState?.historyEntryForUpdate;
}
function $6ab95f584bb8fa39$var$_temp0(states_8) {
    return states_8.malleableUiState?.dynamicUiSubtypeForUpdate;
}
function $6ab95f584bb8fa39$var$_temp1() {}
function $6ab95f584bb8fa39$var$_temp10() {}
function $6ab95f584bb8fa39$var$_temp11() {}






var $cPCP8 = parcelRequire("cPCP8");


const $7e7b7e0a69a43901$export$385bdd630aa6668b = 'ai-paste-menu-remix';























const $89c5ecec449ace39$export$7619bedffcb929ce = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onClick: onClick } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            size: "small",
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl) {
        t2 = intl.formatMessage((0, $AMCQl.aiConfigItemMessages).remixTitle);
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== onClick || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
            testId: "ai-paste-menu__remix",
            elemBefore: t1,
            onClick: onClick
        }, t2);
        $[3] = onClick;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onClick: onClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        testId: "ai-paste-menu__remix",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            size: "small",
            label: ""
        }),
        onClick: onClick
    }, intl.formatMessage((0, $AMCQl.aiConfigItemMessages).remixTitle));
};


const $40c186967944ec46$export$e79e54e0ad32496e = ({ api: api })=>{
    const rules = api.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
    if (!rules) return [];
    const { allRules: allRules, containsTableRule: containsTableRule, excludedAncestorRule: excludedAncestorRule, hideIfSingleNodeRule: hideIfSingleNodeRule, isSingleLinkRule: isSingleLinkRule, minCharsRule: minCharsRule, notProseRule: notProseRule } = rules;
    const disabled = excludedAncestorRule([
        'codeBlock',
        'heading'
    ]);
    const AI_PASTE_MENU_SECTION_KEY = (0, $cPCP8.AI_PASTE_MENU_SECTION).key;
    return [
        {
            type: 'menu-item',
            key: (0, $7e7b7e0a69a43901$export$385bdd630aa6668b),
            parents: [
                {
                    type: 'menu-section',
                    key: AI_PASTE_MENU_SECTION_KEY,
                    // Rank 6 — shown after Make Longer (rank 5).
                    rank: 6
                }
            ],
            isHidden: allRules(minCharsRule(100), hideIfSingleNodeRule, isSingleLinkRule, disabled, notProseRule, containsTableRule),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $89c5ecec449ace39$export$7619bedffcb929ce), {
                    onClick: ()=>{
                        api?.core?.actions.execute((0, $140c07dc09e2d405$export$e01f52b7ef73f07b)(api)({
                            metadata: {
                                interactionSource: 'remixModalFromPasteMenu'
                            },
                            source: (0, $140c07dc09e2d405$export$f437f2a5f6852f29)
                        }));
                    }
                })
        }
    ];
};










var $gCqjE = parcelRequire("gCqjE");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $56M4r = parcelRequire("56M4r");

var $gBbsI = parcelRequire("gBbsI");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");


var $ks59b = parcelRequire("ks59b");

const $cd6d2882f534ff3b$var$MENU_ITEM_HEIGHT = 32;
const $cd6d2882f534ff3b$var$HEADING_HEIGHT = 32;
const $cd6d2882f534ff3b$var$MENU_WIDTH = 175;
// ── Preview panel styles ────────────────────────────────────────────────────
const $cd6d2882f534ff3b$var$PREVIEW_WIDTH = 224;
const $cd6d2882f534ff3b$var$PREVIEW_HEIGHT = 160;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- internal only
const $cd6d2882f534ff3b$var$previewContentStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    width: `${$cd6d2882f534ff3b$var$PREVIEW_WIDTH}px`,
    height: `${$cd6d2882f534ff3b$var$PREVIEW_HEIGHT}px`,
    padding: "var(--ds-space-150, 12px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
function $cd6d2882f534ff3b$var$TypeSwitcherMenu({ siblingSubTypes: siblingSubTypes, dynamicUiSubtype: dynamicUiSubtype, groupLabelMessage: groupLabelMessage, onSelect: onSelect, intl: intl, hide: hide }) {
    const [hoveredSubType, setHoveredSubType] = (0, $42omo.useState)(null);
    const handleMouseEnter = (0, $42omo.useCallback)((value)=>{
        setHoveredSubType(value);
    }, []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        setHoveredSubType(null);
    }, []);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "remix-type-switcher-menu-wrapper"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2SlZp.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7rvPL.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gBbsI.default), {
        testId: "remix-type-switcher-group-header"
    }, intl.formatMessage(groupLabelMessage)), siblingSubTypes.map((subType)=>{
        const isSelected = subType.value === dynamicUiSubtype;
        const isHovered = hoveredSubType === subType.value;
        const IconComponent = subType.value in (0, $ks59b.SUB_TYPE_ICON_MAP) ? (0, $ks59b.SUB_TYPE_ICON_MAP)[subType.value] : null;
        const showPreview = isHovered && IconComponent !== null;
        const button = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            onMouseEnter: ()=>handleMouseEnter(subType.value),
            onMouseLeave: handleMouseLeave,
            onFocus: ()=>handleMouseEnter(subType.value),
            onBlur: handleMouseLeave
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
            testId: `remix-type-switcher-item-${subType.value}`,
            isSelected: isSelected,
            onClick: ()=>{
                if (isSelected) {
                    hide();
                    return;
                }
                onSelect({
                    subtype: subType.value
                });
                hide();
            }
        }, intl.formatMessage(subType.labelMessage)));
        return showPreview ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lGgRw.default), {
            key: subType.value,
            isOpen: true,
            placement: "right",
            autoFocus: false,
            shouldDisableFocusLock: true,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _ariaExpanded, ...restTriggerProps } = triggerProps;
                return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    ...restTriggerProps,
                    onMouseEnter: ()=>handleMouseEnter(subType.value),
                    onMouseLeave: handleMouseLeave,
                    onFocus: ()=>handleMouseEnter(subType.value),
                    onBlur: handleMouseLeave
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    testId: `remix-type-switcher-item-${subType.value}`,
                    isSelected: isSelected,
                    onClick: ()=>{
                        if (isSelected) {
                            hide();
                            return;
                        }
                        onSelect({
                            subtype: subType.value
                        });
                        hide();
                    }
                }, intl.formatMessage(subType.labelMessage)));
            },
            content: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: $cd6d2882f534ff3b$var$previewContentStyles,
                    "data-testid": "remix-type-switcher-preview"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)(IconComponent, {
                    alt: intl.formatMessage(subType.labelMessage)
                }))
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: subType.value
        }, button);
    }))));
}
function $cd6d2882f534ff3b$export$a9e8c51842dcf4c7({ dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, currentLabel: currentLabel, groupLabelMessage: groupLabelMessage, siblingSubTypes: siblingSubTypes, onSelect: onSelect, intl: intl, disabled: disabled = false }) {
    if (siblingSubTypes.length === 0) return null;
    const height = $cd6d2882f534ff3b$var$HEADING_HEIGHT + siblingSubTypes.length * $cd6d2882f534ff3b$var$MENU_ITEM_HEIGHT;
    return {
        id: 'editor.malleable-ui.remix-type-switcher',
        type: 'dropdown',
        title: currentLabel,
        options: {
            width: $cd6d2882f534ff3b$var$MENU_WIDTH,
            height: height,
            render: ({ hide: hide })=>/*#__PURE__*/ (0, $9K4OG.jsx)($cd6d2882f534ff3b$var$TypeSwitcherMenu, {
                    siblingSubTypes: siblingSubTypes,
                    dynamicUiSubtype: dynamicUiSubtype,
                    groupLabelMessage: groupLabelMessage,
                    onSelect: onSelect,
                    intl: intl,
                    hide: hide
                })
        },
        showSelected: false,
        disabled: disabled,
        testId: 'editor-floating-toolbar__remix-type-switcher'
    };
}







function $0571e129c2304946$export$c976fd9e927eb20d({ state: state, url: url, fieldId: fieldId }) {
    const remixHistoryState = (0, $4b6f0776a18b2b53$export$2e13bdf171bca4ae).getState(state);
    const historyMap = remixHistoryState?.historyMap;
    if (!historyMap) return;
    // The lookup URL is the live URL on the node. The stack entry URL is what
    // was synthesized when the entry was pushed. They may share a MAUI app id
    // but disagree on origin (e.g. BE-driven updates that re-use the node's
    // pre-update origin vs. user-driven inserts that use window.location.origin),
    // so compare by extracted app id rather than full-string equality.
    const targetAppId = (0, $9S1Tm.getMauiIdFromUrl)(url);
    for (const historyEntry of Object.values(historyMap)){
        const currentStackEntry = historyEntry.stack.find((stackEntry)=>fieldId && stackEntry.fieldId === fieldId || url && stackEntry.url === url || targetAppId && (0, $9S1Tm.getMauiIdFromUrl)(stackEntry.url) === targetAppId);
        if (!currentStackEntry) continue;
        const historyEntryForUpdate = {
            conversationId: historyEntry.conversationId,
            dynamicUiSource: historyEntry.dynamicUiSource,
            latestFinalMessage: historyEntry.latestFinalMessage,
            latestFinalMessageId: historyEntry.latestFinalMessageId,
            dynamicUiType: currentStackEntry.dynamicUiType,
            dynamicUiSubtype: currentStackEntry.dynamicUiSubtype,
            finalMessage: currentStackEntry.finalMessage,
            finalMessageId: currentStackEntry.finalMessageId,
            fieldId: currentStackEntry.fieldId,
            url: currentStackEntry.url
        };
        return historyEntryForUpdate;
    }
}


function $bbe751c45852a3ee$export$1683ce4d6dafaa4(node) {
    if (node.type.name === 'media') {
        const id = node.attrs?.id;
        return typeof id === 'string' && id.length > 0 ? id : undefined;
    }
    if (node.type.name === 'mediaSingle') {
        const inner = node.firstChild;
        const id = inner?.attrs?.id;
        return typeof id === 'string' && id.length > 0 ? id : undefined;
    }
    return undefined;
}
function $bbe751c45852a3ee$export$6d88a44c576e4d7a({ node: node, schema: schema, state: state }) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const isMaui = node.attrs.extensionKey === 'native-embed:maui';
    const isWhiteboard = node.attrs.extensionKey === 'native-embed:maui-whiteboard';
    if (isMaui || isWhiteboard) {
        const url = node.attrs.parameters?.macroParams?.url?.value;
        return (0, $0571e129c2304946$export$c976fd9e927eb20d)({
            state: state,
            url: url
        });
    }
    const isMedia = node.type === media || node.type === mediaSingle;
    if (isMedia) {
        const mediaNode = node.type === media ? node : node.firstChild;
        if (mediaNode) {
            const fieldId = mediaNode.attrs.id;
            if (fieldId) return (0, $0571e129c2304946$export$c976fd9e927eb20d)({
                state: state,
                fieldId: fieldId
            });
        }
    }
}
function $bbe751c45852a3ee$export$8997b1d407b19449({ node: node, schema: schema, state: state, intl: intl, disabled: disabled, api: api }) {
    if (!(0, $dh538.fg)('platform_editor_ai_remix_toolbar')) return undefined;
    const historyEntry = $bbe751c45852a3ee$export$6d88a44c576e4d7a({
        node: node,
        schema: schema,
        state: state
    });
    if (!historyEntry) return undefined;
    const switcherInfo = (0, $gCqjE.getRemixSwitcherInfo)(historyEntry.dynamicUiType, historyEntry.dynamicUiSubtype);
    if (!switcherInfo) return undefined;
    const dropdown = (0, $cd6d2882f534ff3b$export$a9e8c51842dcf4c7)({
        dynamicUiType: historyEntry.dynamicUiType,
        dynamicUiSubtype: historyEntry.dynamicUiSubtype,
        currentLabel: switcherInfo.currentLabel,
        groupLabelMessage: switcherInfo.groupLabelMessage,
        siblingSubTypes: switcherInfo.siblingSubTypes,
        intl: intl,
        disabled: disabled,
        onSelect: ({ subtype: subtype })=>{
            const targetId = $bbe751c45852a3ee$export$1683ce4d6dafaa4(node) || node.attrs.localId;
            if (targetId) {
                api?.aiExperience?.actions?.stageInlineRovoStreaming?.(targetId);
                api?.aiExperience?.actions?.commitInlineRovoStreaming?.();
            }
            // Mark in-flight so the rovo-bridge update processors skip their
            // BE-pushed insert; `useUpdateRemix`/`useOnComplete` replaces the node
            // instead. id is `fieldId` (image, matches `mediaNode.attrs.id`) or the
            // MAUI app id from the stack-entry URL (matches `data.previousMauiId`).
            const inFlightId = historyEntry.fieldId ?? (0, $9S1Tm.getMauiIdFromUrl)(historyEntry.url);
            if (inFlightId && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) api?.core?.actions.execute(api?.malleableUi?.commands.trackVariantUpdateStart({
                id: inFlightId
            }));
            (0, $ccb60ab150962a8e$export$fdf82e9851b59bf0)({
                api: api,
                options: {
                    isUpdate: true,
                    historyEntryForUpdate: historyEntry,
                    dynamicUiSubtypeForUpdate: subtype
                }
            });
        }
    });
    return dropdown ?? undefined;
}
function $bbe751c45852a3ee$export$fb69ba203a08f43d({ api: api }) {
    return ({ schema: schema, state: state, node: node, intl: intl })=>{
        if (!node) return;
        const disabled = Boolean(api?.malleableUi?.sharedState.currentState()?.isRemixModalOpen || api?.malleableUi?.sharedState.currentState()?.isThinking || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
        return $bbe751c45852a3ee$export$8997b1d407b19449({
            node: node,
            schema: schema,
            state: state,
            intl: intl,
            disabled: disabled,
            api: api
        });
    };
}















var $hXDaB = parcelRequire("hXDaB");













function $93f48c61ee0bdd1a$export$4acd7d829930a56d(schema) {
    return new Set((0, $16hKZ.REMIX_DENY_LIST_V1).map((name)=>schema.nodes[name]).filter(Boolean));
}
function $93f48c61ee0bdd1a$export$81aefa0141c75da9(schema) {
    return new Set((0, $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe).map((name)=>schema.nodes[name]).filter(Boolean));
}
const $93f48c61ee0bdd1a$var$getMediaNodeForAskRovo = (node)=>{
    if (node.type.name === 'media') return node;
    if (node.type.name === 'mediaSingle') return node.firstChild ?? undefined;
    return undefined;
};
const $93f48c61ee0bdd1a$var$isImageMediaNodeForAskRovo = (node)=>{
    const mediaNode = $93f48c61ee0bdd1a$var$getMediaNodeForAskRovo(node);
    if (!mediaNode || mediaNode.type.name !== 'media') return false;
    if (mediaNode.attrs?.type === 'external') return true;
    const fileMimeType = mediaNode.attrs?.__fileMimeType;
    return typeof fileMimeType === 'string' && fileMimeType.includes('image/');
};
const $93f48c61ee0bdd1a$var$remixFloatingToolbarClickAnalyticsPayload = {
    action: (0, $d925B.ACTION).CLICKED,
    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
    actionSubjectId: 'remixModalFromToolbar',
    eventType: (0, $d925B.EVENT_TYPE).UI,
    source: 'remix'
};
function $93f48c61ee0bdd1a$export$5b679e92b69e94fb(api) {
    if (!api?.toolbar) return ()=>undefined;
    return (state, intl, _providerFactory, activeConfigs)=>{
        if (!activeConfigs?.length) return;
        const unallowedNodes = $93f48c61ee0bdd1a$export$4acd7d829930a56d(state.schema);
        const malleableUiState = (0, $qJp20.malleableUiPluginKey).getState(state);
        const remixThinkingState = (0, $dd89be7a43af642f$export$38c8fc373d691b1d).getState(state);
        const isRemixing = malleableUiState?.isRemixModalOpen || false || remixThinkingState?.isThinking || false;
        const areAiEntryPointsDisabled = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false;
        activeConfigs.forEach((config)=>{
            const configNodeTypes = [].concat(config.nodeType);
            const isTableConfig = !Array.isArray(config.nodeType) && config.nodeType.name === 'table';
            // When an element is being remixed (modal open or thinking bar showing), hide its
            // element/floating toolbar entirely by emptying its items so the floating toolbar plugin
            // won't show it.
            //
            // Behind `cc-maui-phase-3` this applies to every element type. Previously the toolbar
            // was only hidden for tables, which left the element toolbar visible for other nodes
            // (e.g. panels and column layouts) while the thinking bar was showing. We skip the
            // inline-suggestion toolbar so the in-editor remix loading bar itself is not affected.
            // When the gate is off we retain the legacy table-only behaviour below.
            if (isRemixing && config.className !== undefined && config.className !== (0, $hXDaB.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS && (0, $dh538.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            // Legacy behaviour (gate off): hide only the table element toolbar while remixing.
            if (isTableConfig && isRemixing && !(0, $dh538.fg)('cc-maui-phase-3')) {
                config.items = [];
                return;
            }
            if (config.className !== undefined && config.className === (0, $hXDaB.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS || isTableConfig && config.items.length === 0 || configNodeTypes.some((nodeType)=>unallowedNodes.has(nodeType) || nodeType.isInline)) return;
            const toolbarItems = config.items;
            if (Array.isArray(toolbarItems)) {
                const remixButton = {
                    id: 'editor.malleable-ui.remix',
                    type: 'button',
                    title: intl.formatMessage((0, $jpEHf.messages).remixToolbarLabel),
                    tooltipContent: isRemixing ? intl.formatMessage((0, $jpEHf.messages).remixInProgressTooltip) : intl.formatMessage((0, $jpEHf.messages).remixToolbarTooltip),
                    showTitle: true,
                    hideTooltipOnClick: false,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                    onClick: ()=>false,
                    disabled: isRemixing || areAiEntryPointsDisabled,
                    testId: 'editor-floating-toolbar__remix-button'
                };
                const remixToolbarItems = [
                    remixButton,
                    {
                        type: 'separator',
                        fullHeight: true
                    }
                ];
                config.items = (node)=>{
                    remixButton.onClick = (editorState)=>{
                        if (isRemixing) return false;
                        const $pos = editorState.selection.$from;
                        let nodePos;
                        for(let depth = $pos.depth; depth > 0; depth--)if ($pos.node(depth) === node) {
                            nodePos = $pos.before(depth);
                            break;
                        }
                        api.analytics?.actions.fireAnalyticsEvent($93f48c61ee0bdd1a$var$remixFloatingToolbarClickAnalyticsPayload);
                        api.core.actions.execute(api.malleableUi.commands.openRemixModal({
                            nodePos: nodePos,
                            nodeType: node.type.name,
                            metadata: {
                                interactionSource: 'remixModalFromFloatingToolbar'
                            },
                            source: 'floatingToolbar'
                        }));
                        return true;
                    };
                    remixButton.disabled = isRemixing || areAiEntryPointsDisabled || (0, $9531e9c3be1ec0bb$export$ebd59c3751cfcc95)(node);
                    return [
                        ...remixToolbarItems,
                        ...toolbarItems
                    ];
                };
            }
        });
        const mediaNodesForAskRovo = $93f48c61ee0bdd1a$export$81aefa0141c75da9(state.schema);
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const showAskRovoForMedia = (0, $dh538.fg)('cc-maui-phase-2') || isViewMode && (0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true);
        if (!mediaNodesForAskRovo.size || !showAskRovoForMedia) return;
        const askRovoButton = api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
            intl: intl,
            disabled: api?.malleableUi?.actions?.shouldDisableRemix?.() && (0, $dh538.fg)('platform_editor_ai_remix_toolbar'),
            target: 'image'
        });
        if (!askRovoButton) return;
        const shouldShowAskRovoForMediaNode = (node)=>mediaNodesForAskRovo.has(node.type) && !node.type.isInline && $93f48c61ee0bdd1a$var$isImageMediaNodeForAskRovo(node);
        const buildTypeSwitcherItemsForMediaNode = (node)=>{
            return (0, $bbe751c45852a3ee$export$8997b1d407b19449)({
                node: node,
                schema: state.schema,
                state: state,
                intl: intl,
                disabled: Boolean(isRemixing || areAiEntryPointsDisabled),
                api: api
            });
        };
        // Build a per-node wrapped Ask Rovo button whose onClick stages the
        // selected media's `mediaFileId` as the inline-Rovo streaming
        // target.
        const buildAskRovoItemsForMediaNode = (node)=>{
            const wrappedAskRovoButton = {
                ...askRovoButton,
                ...isViewMode ? {
                    supportsViewMode: true
                } : {},
                onClick: (innerState, dispatch, view)=>{
                    if ((0, $dh538.fg)('cc-maui-phase-2')) {
                        const mediaFileId = (0, $bbe751c45852a3ee$export$1683ce4d6dafaa4)(node);
                        if (mediaFileId) api?.aiExperience?.actions?.stageInlineRovoStreaming?.(mediaFileId);
                    }
                    return askRovoButton.onClick ? askRovoButton.onClick(innerState, dispatch, view) : false;
                }
            };
            return [
                wrappedAskRovoButton,
                {
                    type: 'separator',
                    fullHeight: true,
                    ...isViewMode ? {
                        supportsViewMode: true
                    } : {}
                }
            ];
        };
        activeConfigs.forEach((config)=>{
            const nodeTypes = [].concat(config.nodeType);
            const isMediaConfig = nodeTypes.some((nodeType)=>mediaNodesForAskRovo.has(nodeType) && !nodeType.isInline);
            if (!isMediaConfig) return;
            const items = config.items;
            if (Array.isArray(items)) config.items = (node)=>{
                if (!shouldShowAskRovoForMediaNode(node)) return items;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...items
                ];
                if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
            else if (typeof items === 'function') config.items = (node)=>{
                const baseItems = items(node);
                if (!shouldShowAskRovoForMediaNode(node)) return baseItems;
                const withAskRovo = [
                    ...buildAskRovoItemsForMediaNode(node),
                    ...baseItems
                ];
                if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
                    const typeSwitcher = buildTypeSwitcherItemsForMediaNode(node);
                    if (typeSwitcher) withAskRovo.splice(1, 0, typeSwitcher);
                }
                return withAskRovo;
            };
        });
    };
}








var $4Chin = parcelRequire("4Chin");

















var $inPa6 = parcelRequire("inPa6");





var $fseNl = parcelRequire("fseNl");


var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");

















const $bd1036ec2a555773$var$testId = 'editor-toolbar__remix-button';
const $bd1036ec2a555773$export$53a35bc3b2402206 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi",
            "aiExperience"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t1, $bd1036ec2a555773$var$_temp);
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    let t2;
    if ($[1] !== api?.core || $[2] !== api?.malleableUi || $[3] !== createAnalyticsEvent || $[4] !== effectiveDisabled || $[5] !== experienceTracker || $[6] !== isRemixing) {
        t2 = ()=>{
            if (effectiveDisabled || isRemixing) return;
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "remixModalFromToolbar",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "remix",
                    attributes: {
                        entryPoint: "editor"
                    }
                }
            }).fire();
            const openModal = api?.malleableUi.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar"
                },
                source: "selectionToolbar"
            });
            if (!openModal) return;
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                id: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "selectionToolbar",
                    product: "confluence"
                }
            });
            api?.core.actions.execute((t3)=>{
                const { tr: tr } = t3;
                openModal({
                    tr: tr
                });
                tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                    shouldShowToolbar: false
                });
                return tr;
            });
        };
        $[1] = api?.core;
        $[2] = api?.malleableUi;
        $[3] = createAnalyticsEvent;
        $[4] = effectiveDisabled;
        $[5] = experienceTracker;
        $[6] = isRemixing;
        $[7] = t2;
    } else t2 = $[7];
    const handleClick = t2;
    let t3;
    bb0: {
        if (isRemixing) {
            let t4;
            if ($[8] !== formatMessage) {
                t4 = formatMessage((0, $jpEHf.messages).remixInProgressTooltip);
                $[8] = formatMessage;
                $[9] = t4;
            } else t4 = $[9];
            t3 = t4;
            break bb0;
        }
        if (effectiveDisabled) {
            let t4;
            if ($[10] !== formatMessage || $[11] !== remixDisabledReason) {
                t4 = (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
                $[10] = formatMessage;
                $[11] = remixDisabledReason;
                $[12] = t4;
            } else t4 = $[12];
            t3 = t4;
            break bb0;
        }
        let t4;
        if ($[13] !== formatMessage) {
            t4 = formatMessage((0, $jpEHf.messages).remixToolbarTooltip);
            $[13] = formatMessage;
            $[14] = t4;
        } else t4 = $[14];
        t3 = t4;
    }
    const tooltipContent = t3;
    if (isRemixHidden || !(0, $1oCLl.expValEquals)("cc-maui-experiment", "isEnabled", true)) return null;
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        });
        $[15] = t4;
    } else t4 = $[15];
    const t5 = effectiveDisabled || isRemixing;
    let t6;
    if ($[16] !== formatMessage) {
        t6 = formatMessage((0, $jpEHf.messages).remixToolbarLabel);
        $[16] = formatMessage;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== handleClick || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
            iconBefore: t4,
            testId: $bd1036ec2a555773$var$testId,
            onClick: handleClick,
            isDisabled: t5
        }, t6);
        $[18] = handleClick;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== t7 || $[23] !== tooltipContent) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: tooltipContent
        }, t7);
        $[22] = t7;
        $[23] = tooltipContent;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ api: api, isDisabled: isDisabled, isRemixHidden: isRemixHidden, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'remixModalFromToolbar',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                attributes: {
                    entryPoint: 'editor'
                }
            }
        }).fire();
        const openModal = api?.malleableUi.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar'
            },
            source: 'selectionToolbar'
        });
        if (!openModal) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'selectionToolbar',
                product: 'confluence'
            }
        });
        api?.core.actions.execute(({ tr: tr })=>{
            openModal({
                tr: tr
            });
            tr.setMeta((0, $fseNl.editorToolbarPluginKey), {
                shouldShowToolbar: false
            });
            return tr;
        });
    }, [
        api,
        effectiveDisabled,
        isRemixing,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (isRemixing) return formatMessage((0, $jpEHf.messages).remixInProgressTooltip);
        if (effectiveDisabled) return (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
        return formatMessage((0, $jpEHf.messages).remixToolbarTooltip);
    }, [
        isRemixing,
        effectiveDisabled,
        formatMessage,
        remixDisabledReason
    ]);
    if (isRemixHidden || !(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            label: "",
            size: "small"
        }),
        testId: $bd1036ec2a555773$var$testId,
        onClick: handleClick,
        isDisabled: effectiveDisabled || isRemixing
    }, formatMessage((0, $jpEHf.messages).remixToolbarLabel)));
};
function $bd1036ec2a555773$var$_temp(states) {
    return {
        isRemixing: states.malleableUiState?.isRemixModalOpen || false || states.malleableUiState?.isThinking || false,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
    };
}

































const $b4108ca6bf0baaa5$export$6764c57cc6522e0a = (0, $4pOgL.isReactCompilerActivePlatform)() ? function RemixCommentPrimaryMenuItem(t0) {
    const $ = (0, $frIzR.c)(26);
    const { api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "malleableUi",
            "aiExperience"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, t1, $b4108ca6bf0baaa5$var$_temp);
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    let t2;
    if ($[1] !== api?.analytics?.actions || $[2] !== api?.core || $[3] !== api?.malleableUi?.commands || $[4] !== effectiveDisabled || $[5] !== experienceTracker || $[6] !== isRemixing) {
        t2 = ()=>{
            if (effectiveDisabled || isRemixing) return;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "remix",
                eventType: "ui",
                attributes: {
                    remixSource: "commentPrimaryToolbar"
                }
            });
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                id: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    entryPoint: "editor",
                    remixSource: "commentPrimaryToolbar"
                }
            });
            api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
                metadata: {
                    interactionSource: "remixModalFromToolbar"
                },
                source: "commentPrimaryToolbar"
            }));
        };
        $[1] = api?.analytics?.actions;
        $[2] = api?.core;
        $[3] = api?.malleableUi?.commands;
        $[4] = effectiveDisabled;
        $[5] = experienceTracker;
        $[6] = isRemixing;
        $[7] = t2;
    } else t2 = $[7];
    const handleClick = t2;
    let t3;
    if ($[8] !== formatMessage) {
        t3 = formatMessage((0, $jpEHf.messages).remixToolbarLabel);
        $[8] = formatMessage;
        $[9] = t3;
    } else t3 = $[9];
    const label = t3;
    let t4;
    bb0: {
        if (isRemixing) {
            let t5;
            if ($[10] !== formatMessage) {
                t5 = formatMessage((0, $jpEHf.messages).remixInProgressTooltip);
                $[10] = formatMessage;
                $[11] = t5;
            } else t5 = $[11];
            t4 = t5;
            break bb0;
        }
        if (effectiveDisabled) {
            let t5;
            if ($[12] !== formatMessage || $[13] !== remixDisabledReason) {
                t5 = (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
                $[12] = formatMessage;
                $[13] = remixDisabledReason;
                $[14] = t5;
            } else t5 = $[14];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[15] !== formatMessage) {
            t5 = formatMessage((0, $jpEHf.messages).remixToolbarTooltip);
            $[15] = formatMessage;
            $[16] = t5;
        } else t5 = $[16];
        t4 = t5;
    }
    const tooltipContent = t4;
    let t5;
    if ($[17] !== label) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            size: "small",
            label: label
        });
        $[17] = label;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
        $[19] = t6;
    } else t6 = $[19];
    const t7 = effectiveDisabled || isRemixing;
    let t8;
    if ($[20] !== handleClick || $[21] !== label || $[22] !== t5 || $[23] !== t7 || $[24] !== tooltipContent) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
            elemBefore: t5,
            elemAfter: t6,
            testId: "dropdown-item__malleable-ui-remix-comment",
            isDisabled: t7,
            title: tooltipContent,
            onClick: handleClick
        }, label);
        $[20] = handleClick;
        $[21] = label;
        $[22] = t5;
        $[23] = t7;
        $[24] = tooltipContent;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function RemixCommentPrimaryMenuItem({ api: api, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { isRemixing: isRemixing, areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'malleableUi',
        'aiExperience'
    ], (states)=>({
            isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
            areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    const effectiveDisabled = isDisabled || areAiEntryPointsDisabled;
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (effectiveDisabled || isRemixing) return;
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'remix',
            eventType: 'ui',
            attributes: {
                remixSource: 'commentPrimaryToolbar'
            }
        });
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'commentPrimaryToolbar'
            }
        });
        api?.core.actions.execute(api?.malleableUi?.commands.openRemixModal({
            metadata: {
                interactionSource: 'remixModalFromToolbar'
            },
            source: 'commentPrimaryToolbar'
        }));
    }, [
        api,
        effectiveDisabled,
        isRemixing,
        experienceTracker
    ]);
    const label = formatMessage((0, $jpEHf.messages).remixToolbarLabel);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (isRemixing) return formatMessage((0, $jpEHf.messages).remixInProgressTooltip);
        if (effectiveDisabled) return (0, $273077559a9b876d$export$5626baa73ed0afeb)(formatMessage, remixDisabledReason);
        return formatMessage((0, $jpEHf.messages).remixToolbarTooltip);
    }, [
        isRemixing,
        effectiveDisabled,
        formatMessage,
        remixDisabledReason
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null),
        testId: "dropdown-item__malleable-ui-remix-comment",
        isDisabled: effectiveDisabled || isRemixing,
        title: tooltipContent,
        onClick: handleClick
    }, label);
};
function $b4108ca6bf0baaa5$var$_temp(states) {
    return {
        isRemixing: states.malleableUiState?.isRemixModalOpen || states.malleableUiState?.isThinking,
        areAiEntryPointsDisabled: states.aiExperienceState?.areAiEntryPointsDisabled ?? false
    };
}


const $b25601d685dcddfe$var$MAUI_REMIX_GROUP = {
    type: 'group',
    key: 'malleable-ui-remix-group'
};
const $b25601d685dcddfe$var$MAUI_REMIX_BUTTON = {
    type: 'button',
    key: 'malleable-ui-remix-button'
};
const $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM = {
    type: 'menu-item',
    key: 'malleable-ui-remix-comment-menu-item'
};
/**
 * Between {@link ROVO_PROMPT_MENU_SECTION_RANK}[SPELLING_AND_GRAMMAR_MENU_ITEM] (300) and
 * [CHANGE_TONE_NESTED_MENU] (400); see `packages/editor/editor-common/src/toolbar/rank.ts`.
 */ const $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK = 350;
function $b25601d685dcddfe$var$isCommentPrimaryToolbarContext(parents) {
    return parents.some((p)=>p.key === (0, $cPCP8.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key);
}
const $b25601d685dcddfe$export$716af56477a0c29a = (api, options)=>{
    return [
        {
            type: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.type,
            key: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.key,
            parents: [
                {
                    type: (0, $cPCP8.AI_SECTION).type,
                    key: (0, $cPCP8.AI_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key] + 10
                },
                // View mode (Live Page): AI_VIEW_SECTION
                {
                    type: (0, $cPCP8.AI_VIEW_SECTION).type,
                    key: (0, $cPCP8.AI_VIEW_SECTION).key,
                    rank: (0, $4Chin.AI_SECTION_RANK)[(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key] + 10
                }
            ]
        },
        {
            type: $b25601d685dcddfe$var$MAUI_REMIX_BUTTON.type,
            key: $b25601d685dcddfe$var$MAUI_REMIX_BUTTON.key,
            parents: [
                {
                    type: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.type,
                    key: $b25601d685dcddfe$var$MAUI_REMIX_GROUP.key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const onPrimaryToolbar = parents.at(0)?.key === (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR;
                if (onPrimaryToolbar) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd1036ec2a555773$export$53a35bc3b2402206), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    isRemixHidden: options?.isRemixHidden,
                    remixDisabledReason: options?.remixDisabledReason
                });
            }
        },
        {
            type: $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM.type,
            key: $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM.key,
            parents: [
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key,
                    rank: $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                },
                {
                    type: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: $b25601d685dcddfe$var$MAUI_REMIX_COMMENT_MENU_ITEM_RANK
                }
            ],
            component: ({ parents: parents })=>{
                if (!$b25601d685dcddfe$var$isCommentPrimaryToolbarContext(parents) || options?.isRemixHidden || !(0, $dh538.fg)('platform_editor_maui_jira_updates')) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b4108ca6bf0baaa5$export$6764c57cc6522e0a), {
                    api: api,
                    isDisabled: options?.isDisabled,
                    remixDisabledReason: options?.remixDisabledReason
                });
            }
        }
    ];
};


const $042f40d3cc5075b5$var$REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';

const $042f40d3cc5075b5$var$LoadableMauiEmbedSpacePicker = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "TB2JY",
    name: "LoadableMauiEmbedSpacePicker",
    loader: ()=>(parcelRequire("1EW3r")).then((mod)=>mod.MauiEmbedSpacePicker),
    loading: ()=>null
});
const $042f40d3cc5075b5$export$90e174b945ae40c7 = ({ api: api, config: config })=>{
    const isRovoLLMEnabled = config?.__isRovoLLMEnabled ?? false;
    const isRemixEnabled = isRovoLLMEnabled && (0, $dZ8uq.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
    const isRightSideEnabled = isRemixEnabled && (0, $dh538.fg)('confluence_remix_button_right_side_block_fg');
    const remixDisabledReason = config?.__remixDisabledReason;
    const isRemixDisabled = !!remixDisabledReason;
    // Mutable reference to the editor view, set by a PM plugin on init.
    // Used by the Remix block-menu isHidden callback to compute text length.
    let editorView;
    if (api && !config?.__isRemixHidden && isRemixEnabled) {
        api.toolbar?.actions.registerComponents((0, $b25601d685dcddfe$export$716af56477a0c29a)(api, {
            remixDisabledReason: remixDisabledReason,
            isDisabled: isRemixDisabled
        }));
        // Register Remix in the block menu when the experiment is enabled and
        // Remix is not disabled (e.g. restricted-content contexts).
        // Use NoExposure here since this runs on every editor load — exposure is
        // recorded when the block menu item is actually rendered.
        if (!isRemixDisabled && (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_remix_in_block_menu', 'isEnabled', true)) api.blockMenu?.actions.registerBlockMenuComponents((0, $5cf0d589d90fbdd2$export$96499eef52eb1886)({
            api: api,
            getEditorView: ()=>editorView
        }));
        if (!isRemixDisabled && [
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ].includes((0, $aeAfU.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'))) api.uiControlRegistry?.actions.register((0, $40c186967944ec46$export$e79e54e0ad32496e)({
            api: api
        }));
    }
    if (api?.blockControls && !config?.__isRemixHidden && isRightSideEnabled) {
        const livePage = config?.__livePage;
        api.blockControls.actions.registerNodeDecoration({
            type: $042f40d3cc5075b5$var$REMIX_BUTTON_DECORATION_TYPE,
            create: (params)=>(0, $18f19acb0a096c62$export$d411c8f539cb0edd)({
                    ...params,
                    api: api,
                    livePage: livePage,
                    remixDisabledReason: remixDisabledReason,
                    isDisabled: isRemixDisabled,
                    isRovoLLMEnabled: isRovoLLMEnabled
                }),
            showInViewMode: true,
            shouldCreate: (params)=>{
                const { editorState: editorState, rootPos: rootPos } = params;
                if (rootPos === undefined) return false;
                const node = editorState.doc.nodeAt(rootPos);
                return (0, $9531e9c3be1ec0bb$export$ff7e5ebac3487125)({
                    node: node ?? undefined
                });
            }
        });
    }
    return {
        name: 'malleableUi',
        pmPlugins () {
            const plugins = [
                {
                    name: 'malleableUi',
                    plugin: ({ dispatch: dispatch })=>(0, $qJp20.createMalleableUiPmPlugin)(dispatch)
                },
                {
                    name: 'malleableUiEditorViewCapture',
                    plugin: ()=>(0, $cb63581b05617359$export$c2f4e91d1c0a0502)((view)=>{
                            editorView = view;
                        }, ()=>{
                            editorView = undefined;
                        })
                },
                {
                    name: 'malleableUiToolbarSuppression',
                    plugin: ()=>(0, $qJp20.createToolbarSuppressionPlugin)()
                },
                {
                    name: 'remixThinking',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $dd89be7a43af642f$export$1c17a47e3daa5065)({
                            api: api,
                            config: config,
                            dispatch: dispatch,
                            getIntl: getIntl,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                        })
                },
                ...(0, $dh538.fg)('cc-maui-phase-3') ? [
                    {
                        name: 'remixHoverHighlight',
                        plugin: ()=>(0, $05b902cb1d2c0384$export$1c5a63402318eb67)()
                    }
                ] : [],
                ...(0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? [
                    {
                        name: 'remixHistory',
                        plugin: ({ dispatch: dispatch })=>(0, $4b6f0776a18b2b53$export$275a1873be81202e)({
                                api: api,
                                dispatch: dispatch
                            })
                    }
                ] : []
            ];
            if (config?.diagramPaste) {
                const diagramPasteConfig = {
                    ...config.diagramPaste,
                    fireAnalyticsEvent: (payload)=>{
                        api?.analytics?.actions.fireAnalyticsEvent(payload);
                    }
                };
                plugins.push({
                    name: 'mauiDiagramPaste',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $LSDsY.createMauiDiagramPastePmPlugin)(dispatch, diagramPasteConfig, getIntl)
                });
            }
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const malleableUiState = (0, $qJp20.malleableUiPluginKey).getState(editorState);
            const remixThinkingState = (0, $dd89be7a43af642f$export$38c8fc373d691b1d).getState(editorState);
            if (!malleableUiState || !remixThinkingState) return undefined;
            return {
                aiEditReplacementLocalIds: malleableUiState.aiEditReplacementLocalIds,
                inFlightVariantUpdates: malleableUiState.inFlightVariantUpdates,
                isUpdate: remixThinkingState.isUpdate ?? false,
                historyEntryForUpdate: remixThinkingState.historyEntryForUpdate,
                dynamicUiSubtypeForUpdate: remixThinkingState.dynamicUiSubtypeForUpdate,
                isComplete: remixThinkingState.isComplete ?? false,
                isRemixModalOpen: malleableUiState.isRemixModalOpen,
                remixModalMetadata: malleableUiState.remixModalMetadata,
                isThinking: remixThinkingState.isThinking,
                remixSource: malleableUiState.remixSource,
                showLocationPicker: malleableUiState.showLocationPicker,
                diagramPaste: (0, $LSDsY.mauiDiagramPastePluginKey).getState(editorState),
                savedSelection: remixThinkingState.savedSelection
            };
        },
        actions: {
            duplicateAndReplaceMauiApp: (0, $39a022d008a5be1a$export$4f422ec95246a715)({
                api: api,
                config: config
            }),
            finalizeMauiEmbedFromIndicator: (0, $c890ce7e9574b9df$export$68002784dcd3d97)({
                config: config
            }),
            getRemixVariantFloatingToolbarButton: (0, $bbe751c45852a3ee$export$fb69ba203a08f43d)({
                api: api
            }),
            isVariantUpdateInFlight: (id)=>{
                const sharedState = api?.malleableUi?.sharedState?.currentState();
                return sharedState?.inFlightVariantUpdates.has(id) ?? false;
            },
            shouldDisableRemix: ()=>{
                const malleableUiState = api?.malleableUi?.sharedState.currentState();
                return Boolean(malleableUiState?.isRemixModalOpen || malleableUiState?.isThinking || api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled);
            }
        },
        commands: {
            clearRemixThinkingDecoration: $2daab9aee767d4c3$export$65f89d2d4741e4b7,
            addBackendRemixHistoryStackEntry: (0, $dc2ec8a485fcd693$export$b509b1134d7bb5c1),
            openRemixModal: (0, $140c07dc09e2d405$export$e01f52b7ef73f07b)(api),
            closeRemixModal: (0, $3cbafda77e1252b9$export$8818f9db6e7370f7)(api),
            startRemixThinking: (0, $ccb60ab150962a8e$export$b0011c604093029)(api),
            stopRemixThinking: $d462007436924fa2$export$5569fef6b45e570f,
            replaceMauiApp: $a8bbc3dbab143724$export$ff177b3b8713a3ae,
            replaceWhiteboardEmbed: $0521de7e9ae033e8$export$1aa62896db449f52,
            trackVariantUpdateStart: (0, $a91b3754946df6af$export$b3219bd5df32333),
            trackVariantUpdateComplete: (0, $a91b3754946df6af$export$242a1c29a4a1fdc3),
            updateRemixImageHistoryFieldId: (0, $233172411ad9fe35$export$de0bdc3bedba2bdf)
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01fa406e6521134b$export$3bccfb6f759a17), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ab95f584bb8fa39$export$9b636cd211668abd), {
                api: api,
                config: config
            }), config?.diagramPaste && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c14e5e6d7f455b31$export$bdca710d02013452), {
                api: api
            }), config?.diagramPaste && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
            !(0, $c6GJD.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($042f40d3cc5075b5$var$LoadableMauiEmbedSpacePicker, {
                api: api,
                config: config
            }) : null);
        },
        pluginsOptions: !config?.__isRemixHidden && !config?.__remixDisabledReason && isRemixEnabled ? {
            floatingToolbar: (0, $93f48c61ee0bdd1a$export$5b679e92b69e94fb)(api)
        } : {}
    };
};
module.exports["malleableUiPlugin"] = $042f40d3cc5075b5$export$90e174b945ae40c7;

});

parcelRegister("1EW3r", function(module, exports) {

let $13568f500c1c8e38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13568f500c1c8e38$var$load("6wr18"),
    $13568f500c1c8e38$var$load("hhss7"),
    $13568f500c1c8e38$var$load("ffEVr"),
    $13568f500c1c8e38$var$load("jEMel")
]).then(()=>parcelRequire('lTePJ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("d4d2J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $2O3ot = parcelRequire("2O3ot");


var $4iTbK = parcelRequire("4iTbK");


var $aXWtB = parcelRequire("aXWtB");


var $jyA9t = parcelRequire("jyA9t");


var $1AJi3 = parcelRequire("1AJi3");





var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");





var $dTb09 = parcelRequire("dTb09");


var $3vCSA = parcelRequire("3vCSA");


var $cteoa = parcelRequire("cteoa");





var $ffCOo = parcelRequire("ffCOo");


var $dpPtd = parcelRequire("dpPtd");








var $dZ8uq = parcelRequire("dZ8uq");
















const $36a2a4497f062535$export$48102a280783173d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    entryPoint: undefined,
    smartCreationConfig: undefined,
    smartCreationContext: undefined,
    isViewMode: undefined,
    dynamicUiType: undefined,
    setDynamicUiType: (type)=>{},
    dynamicUiSubtype: undefined,
    setDynamicUiSubtype: (subtype)=>{},
    dynamicUiSource: undefined,
    setDynamicUiSource: (source)=>{},
    conversationId: undefined,
    setConversationId: (conversationId)=>{},
    interactionSource: undefined,
    setInteractionSource: (interactionSource)=>{},
    aspectRatio: undefined,
    setAspectRatio: (aspectRatio)=>{},
    finalMessage: undefined,
    setFinalMessage: (message)=>{},
    contentClassification: undefined,
    setContentClassification: (classification)=>{},
    clearThinkingDecoration: ()=>{},
    replaceWhiteboardEmbed: ()=>{},
    setThinkingComplete: (isComplete)=>{},
    finishRemixThinking: ()=>{},
    showLocationPicker: false,
    setShowLocationPicker: (show)=>{},
    addHistoryEntry: (options)=>{},
    addHistoryStackEntry: (options)=>{},
    onVariantUpdateComplete: (id)=>{},
    onRemixInsertSuccess: (payload)=>{},
    isUpdate: undefined,
    historyEntryForUpdate: undefined,
    remixUpdateSentinelRef: {
        current: undefined
    },
    dynamicUiSubtypeForUpdate: undefined,
    onRemixThinkingCompleteAnimationFinished: ()=>{},
    resetContext: ()=>{}
});
const $36a2a4497f062535$export$4ea2348b19df1d27 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($36a2a4497f062535$export$48102a280783173d);
};
const $36a2a4497f062535$export$93604a1decc87c40 = ({ entryPoint: entryPoint, isViewMode: isViewMode, clearThinkingDecoration: clearThinkingDecoration, replaceWhiteboardEmbed: replaceWhiteboardEmbed, setThinkingComplete: setThinkingComplete, finishRemixThinking: finishRemixThinking, showLocationPicker: showLocationPicker = false, setShowLocationPicker: setShowLocationPicker = ()=>{}, smartCreationConfig: smartCreationConfig, smartCreationContext: smartCreationContext, addHistoryEntry: addHistoryEntry, addHistoryStackEntry: addHistoryStackEntry, onVariantUpdateComplete: onVariantUpdateComplete, onRemixInsertSuccess: onRemixInsertSuccess, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished, children: children })=>{
    const [dynamicUiType, setDynamicUiType] = (0, $42omo.useState)(undefined);
    const [dynamicUiSubtype, setDynamicUiSubtype] = (0, $42omo.useState)(undefined);
    const [dynamicUiSource, setDynamicUiSource] = (0, $42omo.useState)(undefined);
    const [conversationId, setConversationId] = (0, $42omo.useState)(undefined);
    const [interactionSource, setInteractionSource] = (0, $42omo.useState)(undefined);
    const [aspectRatio, setAspectRatio] = (0, $42omo.useState)(undefined);
    const [finalMessage, setFinalMessage] = (0, $42omo.useState)(undefined);
    const [contentClassification, setContentClassification] = (0, $42omo.useState)(undefined);
    const remixUpdateSentinelRef = (0, $42omo.useRef)(undefined);
    const resetContext = (0, $42omo.useCallback)(()=>{
        setDynamicUiType(undefined);
        setDynamicUiSubtype(undefined);
        setDynamicUiSource(undefined);
        setConversationId(undefined);
        setInteractionSource(undefined);
        setAspectRatio(undefined);
        setFinalMessage(undefined);
        setContentClassification(undefined);
        remixUpdateSentinelRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36a2a4497f062535$export$48102a280783173d.Provider, {
        value: {
            entryPoint: entryPoint,
            smartCreationConfig: smartCreationConfig,
            smartCreationContext: smartCreationContext,
            isViewMode: isViewMode,
            dynamicUiType: dynamicUiType,
            setDynamicUiType: setDynamicUiType,
            dynamicUiSubtype: dynamicUiSubtype,
            setDynamicUiSubtype: setDynamicUiSubtype,
            dynamicUiSource: dynamicUiSource,
            setDynamicUiSource: setDynamicUiSource,
            conversationId: conversationId,
            setConversationId: setConversationId,
            interactionSource: interactionSource,
            setInteractionSource: setInteractionSource,
            aspectRatio: aspectRatio,
            setAspectRatio: setAspectRatio,
            finalMessage: finalMessage,
            setFinalMessage: setFinalMessage,
            contentClassification: contentClassification,
            setContentClassification: setContentClassification,
            clearThinkingDecoration: clearThinkingDecoration,
            replaceWhiteboardEmbed: replaceWhiteboardEmbed,
            setThinkingComplete: setThinkingComplete,
            finishRemixThinking: finishRemixThinking,
            showLocationPicker: showLocationPicker,
            setShowLocationPicker: setShowLocationPicker,
            addHistoryEntry: addHistoryEntry,
            addHistoryStackEntry: addHistoryStackEntry,
            onVariantUpdateComplete: onVariantUpdateComplete,
            onRemixInsertSuccess: onRemixInsertSuccess,
            isUpdate: isUpdate,
            historyEntryForUpdate: historyEntryForUpdate,
            remixUpdateSentinelRef: remixUpdateSentinelRef,
            dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate,
            onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished,
            resetContext: resetContext
        }
    }, children);
};


/* LocationPickerPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $TfRUG = parcelRequire("TfRUG");


var $lGgRw = parcelRequire("lGgRw");





const $e679d2e2a9ea0771$export$43c58e4c6fdfdd = (0, $42omo.lazy)(()=>(parcelRequire("3KuNi")).then((m)=>({
            default: m.ConfluenceObjectFinalizePopup
        })));










var $ljUdP = parcelRequire("ljUdP");


var $j1TMt = parcelRequire("j1TMt");


var $68ciW = parcelRequire("68ciW");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");


var $hHa70 = parcelRequire("hHa70");


var $2VpjI = parcelRequire("2VpjI");


var $3BJ0q = parcelRequire("3BJ0q");


var $gdg5T = parcelRequire("gdg5T");


var $15h8H = parcelRequire("15h8H");


var $72hrp = parcelRequire("72hrp");

const $70c887fc0ba44598$export$1b93a9a573fc03d0 = (chatMessages)=>{
    const latestAIFCActionMessage = (0, $72hrp.findLastMessageWithAIFCAction)(chatMessages);
    return (0, $72hrp.getAIFCActionStatus)(latestAIFCActionMessage) === 'complete' && latestAIFCActionMessage?.content?.streamingComplete ? latestAIFCActionMessage : undefined;
};
const $70c887fc0ba44598$export$96c1f076bacee3e3 = (message)=>(0, $ljUdP.isStreamActionClassification)(message);
const $70c887fc0ba44598$export$16999efdbe112ac3 = (message)=>$70c887fc0ba44598$export$96c1f076bacee3e3(message) && message.message.action_key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY);
const $70c887fc0ba44598$export$54efbf7cb26887a3 = (message)=>{
    if ($70c887fc0ba44598$export$16999efdbe112ac3(message)) return {
        type: 'whiteboard',
        actionClassification: message
    };
    return undefined;
};
const $70c887fc0ba44598$export$b5c3d4828f4ee170 = (classification, data)=>{
    if (classification?.type === 'whiteboard' && (0, $3vCSA.isConfluenceAIFCWhiteboardCreateActionData)(data)) return {
        ...classification,
        data: data
    };
    return classification;
};
const $70c887fc0ba44598$export$ce5fc05d35f87c7f = (message)=>{
    const action = message?.content?.message?.message?.actions?.[0];
    if (action?.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) && (0, $3vCSA.isConfluenceAIFCWhiteboardCreateActionData)(action.data)) return action.data;
    return undefined;
};
const $70c887fc0ba44598$export$4364bc0cb56ef88f = ({ message: message, actionKey: actionKeyOverride })=>{
    const actionKey = actionKeyOverride || message?.content?.message?.message?.actions?.[0]?.key;
    const actionData = message?.content?.message?.message?.actions?.[0]?.data;
    switch(actionKey){
        case 0, $3vCSA.DYNAMIC_UI_CREATE_KEY:
            return actionData?.id;
        case 0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $3vCSA.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $3vCSA.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return actionData?.contentId;
        default:
            return undefined;
    }
};
const $70c887fc0ba44598$export$4c6fb8272867c7c7 = (appId)=>{
    return `${window.location.origin}/remix/ui/${encodeURIComponent(appId)}`;
};
/**
 * Constructs a whiteboard URL.
 * When `spaceKey` is provided, it is used directly as the URL space segment
 * (this is the only correct format — `/wiki/spaces/{spaceKey}/whiteboard/...`).
 * Otherwise we fall back to `~{spaceId}` (treating the space id as a
 * personal-space key) or `~` placeholder if neither is available.
 * The `isRemixDiagram=true` param signals to the paste plugin and native embed
 * that this whiteboard may need to be moved to the current page's space.
 */ const $70c887fc0ba44598$var$getWhiteboardUrl = (contentId, spaceId, spaceKey)=>{
    const spaceSegment = spaceKey ?? (spaceId ? `~${spaceId}` : '~');
    return `${window.location.origin}/wiki/spaces/${spaceSegment}/whiteboard/${contentId}?isRemixDiagram=true`;
};
const $70c887fc0ba44598$export$8eb2ca3c9f5828b7 = (contentId)=>{
    const url = new URL(`/wiki/spaces/_/whiteboard/${encodeURIComponent(contentId)}`, window.location.origin);
    url.searchParams.set('isRemixDiagram', 'true');
    url.searchParams.set('parentProduct', 'rovo');
    url.searchParams.set('embed', 'true');
    url.searchParams.set('hideBorder', 'true');
    url.searchParams.set('rovoReceiverId', (0, $6nGJw.getConfluenceWhiteboardClientId)(contentId));
    return url.toString();
};
const $70c887fc0ba44598$export$34709c570ec2b0fe = (remixId, actionKey, spaceId, spaceKey)=>{
    if (!remixId) return undefined;
    switch(actionKey){
        case 0, $3vCSA.DYNAMIC_UI_CREATE_KEY:
            return $70c887fc0ba44598$export$4c6fb8272867c7c7(remixId);
        case 0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $3vCSA.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $3vCSA.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return $70c887fc0ba44598$var$getWhiteboardUrl(remixId, spaceId, spaceKey);
        default:
            return undefined;
    }
};
const $70c887fc0ba44598$var$buildEmbedCardContent = (url, localId)=>{
    return [
        {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'center',
                ...localId ? {
                    localId: localId
                } : {}
            }
        }
    ];
};
const $70c887fc0ba44598$export$20a274baad2c5da7 = ({ url: url, insertReceiverId: insertReceiverId, isUpdate: isUpdate, localId: localId })=>{
    if (!insertReceiverId) return;
    (0, $15h8H.getBrowserBridgeAPI)().send((0, $3BJ0q.EditorInsertContentCommand), {
        senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
        receiverId: (0, $eL1ct.getConfluenceEditorClientId)(insertReceiverId),
        mode: 'insert',
        placement: isUpdate && (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? 'replace-selection' : 'after-block',
        useStoredSelection: true,
        data: {
            type: 'text/adf',
            content: $70c887fc0ba44598$var$buildEmbedCardContent(url, localId)
        }
    });
};
const $70c887fc0ba44598$export$46b78d980e0f6822 = ({ data: data, groupId: groupId, singleInstrumentationID: singleInstrumentationID })=>{
    if (!data?.contentId || !groupId) return;
    const receiverId = (0, $6nGJw.getConfluenceWhiteboardClientId)(data.contentId);
    const bridgeAPI = (0, $15h8H.getBrowserBridgeAPI)();
    bridgeAPI.send((0, $2VpjI.ConfluenceWhiteboardCreateCommand), {
        senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
        receiverId: receiverId,
        key: (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY),
        data: data,
        isStreamComplete: true,
        groupId: groupId,
        singleInstrumentationID: singleInstrumentationID
    });
    bridgeAPI.send((0, $gdg5T.RovoStreamCompletedCommand), {
        senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
        receiverId: receiverId,
        streamId: groupId,
        contentId: data.contentId
    });
};
const $70c887fc0ba44598$export$aa4d2a25d60fb7d2 = (source)=>{
    if (!source || typeof source !== 'object') return false;
    const s = source;
    return s.startLocalId === '' && s.endLocalId === '';
};
const $70c887fc0ba44598$export$613faa0f449b767 = (actionKey)=>{
    switch(actionKey){
        case 0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $3vCSA.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $3vCSA.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return true;
        case 0, $3vCSA.DYNAMIC_UI_CREATE_KEY:
        default:
            return false;
    }
};
const $70c887fc0ba44598$export$c5a9419e25b8541c = (actionKey)=>{
    switch(actionKey){
        case 0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY:
        case 0, $3vCSA.AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
        case 0, $3vCSA.LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY:
            return 'whiteboard';
        default:
            return undefined;
    }
};
const $70c887fc0ba44598$export$a4213ba64cef4d03 = new Set([
    ...(0, $3vCSA.PAGE_CREATE_ACTIONS),
    ...(0, $3vCSA.WHITEBOARD_CREATE_ACTIONS),
    ...(0, $3vCSA.DATABASE_CREATE_ACTIONS),
    ...(0, $3vCSA.SLIDES_CREATE_ACTIONS)
]);
async function $70c887fc0ba44598$export$62fb64678f4b5325({ mediaFileId: mediaFileId, clientId: clientId, product: product }) {
    const { token: token, collection: collection } = await (0, $j1TMt.fetchMauiPersonalReadToken)(product);
    const imageUrl = (0, $3vCSA.buildImageUrl)({
        fileId: mediaFileId,
        token: token.split('Bearer ')[1],
        collection: // TODO: Consider moving into fetchMauiPersonalReadToken
        collection,
        clientId: clientId,
        isStaging: (0, $68ciW.isStaging)()
    });
    return imageUrl;
}
const $70c887fc0ba44598$export$ced9470b70691a2b = (message)=>{
    const actionData = message?.content?.message?.message?.actions?.[0]?.data;
    return (0, $3vCSA.isImageCreateData)(actionData) ? actionData.mediaFileId : undefined;
};


const $85a250114ebb5b96$var$triggerStyles = null;
function $85a250114ebb5b96$export$378069e28d21ecbf() {
    const { entryPoint: entryPoint, conversationId: conversationId, showLocationPicker: showLocationPicker, setShowLocationPicker: setShowLocationPicker, smartCreationConfig: smartCreationConfig, smartCreationContext: smartCreationContext, finalMessage: finalMessage, resetContext: resetContext } = (0, $36a2a4497f062535$export$4ea2348b19df1d27)();
    const action = finalMessage?.content?.message?.message?.actions?.[0];
    const actionKey = action?.key;
    const spaceId = smartCreationContext?.confluence?.space?.id;
    const remixId = (0, $70c887fc0ba44598$export$4364bc0cb56ef88f)({
        message: finalMessage
    });
    const remixUrl = (0, $70c887fc0ba44598$export$34709c570ec2b0fe)(remixId, actionKey, spaceId);
    const currentPageId = smartCreationContext?.confluence?.content?.id;
    const insertReceiverId = currentPageId ?? smartCreationContext?.editor?.editorId; /**
                                                                                     * Called by the picker after a successful user-driven finalization.
                                                                                     * We discard the popup's baseUrl/path because the user is already in the
                                                                                     * editor — we just need to insert the embed and dismiss the modal.
                                                                                     */ 
    const handlePopupFinalizeSuccess = (0, $42omo.useCallback)((_params)=>{
        if (remixUrl) (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
            url: remixUrl,
            insertReceiverId: insertReceiverId,
            isUpdate: false
        });
        resetContext();
        setShowLocationPicker(false);
    }, [
        remixUrl,
        insertReceiverId,
        setShowLocationPicker,
        resetContext
    ]);
    if (!entryPoint || !smartCreationConfig || !smartCreationContext || !finalMessage || !remixId || !remixUrl || !conversationId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: true,
        isOpen: showLocationPicker,
        onClose: ()=>{
            // Picker dismissed without finalizing — close the modal, don't insert the embed.
            resetContext();
            setShowLocationPicker(false);
        },
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e679d2e2a9ea0771$export$43c58e4c6fdfdd), {
                config: smartCreationConfig,
                contentId: remixId ?? '',
                closeModal: handlePopupFinalizeSuccess,
                closePopup: ()=>{
                    resetContext();
                    setShowLocationPicker(false);
                },
                conversationId: conversationId,
                entryPoint: entryPoint,
                context: smartCreationContext,
                selectedPreviewMessage: finalMessage
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "data-testid": "remix-location-picker-popup-trigger",
                ...triggerProps,
                className: (0, $gMc0m.default)([
                    "_kqsw1n9t _154i1x1l _1ltv1ssb"
                ])
            }, (0, $TfRUG.ZERO_WIDTH_SPACE))
    });
}












var $Yuf8j = parcelRequire("Yuf8j");





var $kIvLT = parcelRequire("kIvLT");





var $ajfvU = parcelRequire("ajfvU");
















var $9S1Tm = parcelRequire("9S1Tm");

const $e07426db79f6c0dd$var$isFinalizePermissionError = (error)=>error.errorAttributes?.statusCode === 403;
function $e07426db79f6c0dd$export$d70fe66889862a96() {
    const { isViewMode: isViewMode, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtypeFromContext, dynamicUiSource: dynamicUiSource, conversationId: conversationId, interactionSource: interactionSource, aspectRatio: aspectRatio, finalMessage: finalMessage, contentClassification: contentClassification, clearThinkingDecoration: clearThinkingDecoration, replaceWhiteboardEmbed: replaceWhiteboardEmbed, setThinkingComplete: setThinkingComplete, finishRemixThinking: finishRemixThinking, addHistoryEntry: addHistoryEntry, addHistoryStackEntry: addHistoryStackEntry, onRemixInsertSuccess: onRemixInsertSuccess, onVariantUpdateComplete: onVariantUpdateComplete, smartCreationConfig: smartCreationConfig = {
        siteId: '',
        product: '',
        userId: ''
    }, smartCreationContext: smartCreationContext, resetContext: resetContext } = (0, $36a2a4497f062535$export$4ea2348b19df1d27)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent } = (0, $kIvLT.useAnalytics)();
    const { resolveConversationAction: resolveConversationAction } = (0, $ajfvU.useChatStoreActions)();
    const { userId: clientId, siteId: siteId } = smartCreationConfig;
    const action = finalMessage?.content?.message?.message?.actions?.[0];
    const actionData = action?.data;
    const actionKey = action?.key;
    const remixId = (0, $70c887fc0ba44598$export$4364bc0cb56ef88f)({
        message: finalMessage
    });
    const agentMessageId = finalMessage?.content?.message?.message?.id;
    const mediaFileId = (0, $3vCSA.isImageCreateData)(actionData) ? actionData.mediaFileId : undefined;
    const backendDynamicUiSubtype = actionData?.dynamicUiSubtype;
    // Repro: choosing "Pick for me" starts without a subtype in context; use
    // the backend-confirmed subtype from the final action so history reflects it.
    const dynamicUiSubtype = dynamicUiSubtypeFromContext ?? backendDynamicUiSubtype;
    const isLiveDoc = smartCreationContext?.confluence?.content?.subType === 'live';
    const contentType = smartCreationContext?.confluence?.content?.type;
    const currentPageId = smartCreationContext?.confluence?.content?.id;
    const spaceId = smartCreationContext?.confluence?.space?.id;
    const spaceKey = smartCreationContext?.confluence?.space?.key;
    const remixUrl = (0, $70c887fc0ba44598$export$34709c570ec2b0fe)(remixId, actionKey, spaceId, spaceKey);
    const finalWhiteboardCreateActionData = (0, $70c887fc0ba44598$export$ce5fc05d35f87c7f)(finalMessage);
    // For non-Confluence products, `context.editor` provides a pre-formed containerAri
    // for the duplicate remix API call and an editorId for routing the insert command
    // to the correct editor instance.
    const smartCreationEditorContext = smartCreationContext?.editor;
    // The page/editor ID used to route EditorInsertContentCommand via the rovo content bridge.
    // Prefers the Confluence content ID; falls back to the editor UUID for non-Confluence products.
    const insertReceiverId = currentPageId ?? smartCreationEditorContext?.editorId;
    /**
   * Calls the convo-ai action endpoint when `aifc_finalize_convo_ai` is on.
   * `onError` re-throws so callers can detect failure — without it, the chat
   * store's safe-action wrapper would silently swallow the error.
   */ const finalizeAction = (0, $42omo.useCallback)(async ({ contentId: contentId, parentId: parentId, resolvedSpaceId: resolvedSpaceId })=>{
        if (!conversationId) return;
        // Only finalize via convo-ai for Confluence object types (pages, whiteboards,
        // databases). MAUI apps and images don't need this endpoint.
        if (!actionKey || !(0, $70c887fc0ba44598$export$a4213ba64cef4d03).has(actionKey)) return;
        const message = finalMessage?.content?.message?.message;
        const messageAction = message?.actions?.[0];
        if (!message || !messageAction) return;
        const isActionComplete = finalMessage?.content.streamingComplete || messageAction?.status?.toLowerCase() === 'planned' || messageAction?.status?.toLowerCase() === 'finished';
        if (!isActionComplete) return;
        const existingData = messageAction.data ?? {};
        const existingMetadata = existingData.metadata ?? {};
        const payload = {
            context: {
                key: messageAction.key,
                invocationId: messageAction.invocationId,
                actionId: messageAction.actionId,
                displayName: messageAction.displayName,
                status: messageAction.status,
                toolSource: messageAction.toolSource,
                humanMessageId: messageAction.humanMessageId,
                confirmationMessage: messageAction.confirmationMessage,
                executedData: messageAction.executedData,
                messageId: message.id,
                resolution: {
                    type: 'confirm',
                    message: 'finalize'
                },
                data: {
                    ...existingData,
                    metadata: {
                        ...existingMetadata,
                        contentId: contentId,
                        parentId: parentId,
                        spaceId: resolvedSpaceId
                    }
                }
            }
        };
        await resolveConversationAction({
            conversationId: conversationId,
            messageId: message.id,
            payload: payload,
            actionContentProcessor: (msg)=>({
                    message: {
                        message_metadata: msg?.message_metadata
                    }
                }),
            onError: ({ error: error })=>{
                throw error;
            }
        });
    }, [
        finalMessage,
        resolveConversationAction,
        conversationId,
        actionKey
    ]);
    const clearThinkingDecorationRef = (0, $42omo.useRef)(clearThinkingDecoration);
    (0, $42omo.useEffect)(()=>{
        clearThinkingDecorationRef.current = clearThinkingDecoration;
    }, [
        clearThinkingDecoration
    ]);
    const replaceWhiteboardEmbedRef = (0, $42omo.useRef)(replaceWhiteboardEmbed);
    (0, $42omo.useEffect)(()=>{
        replaceWhiteboardEmbedRef.current = replaceWhiteboardEmbed;
    }, [
        replaceWhiteboardEmbed
    ]);
    const setThinkingCompleteRef = (0, $42omo.useRef)(setThinkingComplete);
    (0, $42omo.useEffect)(()=>{
        setThinkingCompleteRef.current = setThinkingComplete;
    }, [
        setThinkingComplete
    ]);
    const finishRemixThinkingRef = (0, $42omo.useRef)(finishRemixThinking);
    (0, $42omo.useEffect)(()=>{
        finishRemixThinkingRef.current = finishRemixThinking;
    }, [
        finishRemixThinking
    ]);
    const hasInsertedRef = (0, $42omo.useRef)(false);
    const hasEarlyInsertedWhiteboardRef = (0, $42omo.useRef)(false);
    const earlyInsertedWhiteboardLocalIdRef = (0, $42omo.useRef)(undefined);
    const earlyInsertedWhiteboardUrlRef = (0, $42omo.useRef)(undefined);
    const insertEarlyStreamingWhiteboard = (0, $42omo.useCallback)((contentId)=>{
        const earlyRemixUrl = (0, $70c887fc0ba44598$export$8eb2ca3c9f5828b7)(contentId);
        const localId = crypto.randomUUID();
        hasEarlyInsertedWhiteboardRef.current = true;
        earlyInsertedWhiteboardLocalIdRef.current = localId;
        earlyInsertedWhiteboardUrlRef.current = earlyRemixUrl;
        (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
            url: earlyRemixUrl,
            insertReceiverId: insertReceiverId,
            isUpdate: isUpdate,
            localId: localId
        });
        // The whiteboard iframe is now the streaming surface. Hide only the editor-owned
        // generating decoration; keep the Remix flow mounted so finalMessage can still
        // trigger finalize/reparent and history recording.
        clearThinkingDecorationRef.current?.();
    }, [
        insertReceiverId,
        isUpdate
    ]);
    const replaceEarlyStreamingWhiteboard = (0, $42omo.useCallback)((contentId, finalizedUrl)=>{
        replaceWhiteboardEmbedRef.current?.({
            contentId: contentId,
            finalizedUrl: finalizedUrl,
            localId: earlyInsertedWhiteboardLocalIdRef.current
        });
    }, []);
    const handleInsertMauiEmbedIntoPage = (0, $42omo.useCallback)(async ()=>{
        let url = '';
        if (!conversationId || !remixId || !remixUrl) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_INSERT,
            id: (0, $16lEl.ExperienceName).REMIX_INSERT,
            attributes: {
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                contentType: (0, $70c887fc0ba44598$export$c5a9419e25b8541c)(actionKey),
                conversationChannelId: conversationId
            }
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'contentFinalized',
            source: 'AIMate',
            invokedFrom: 'remix',
            proactive: false,
            userGenerated: true,
            singleInstrumentationID: agentMessageId,
            pageContext: 'confluence-page-edit',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: (0, $70c887fc0ba44598$export$c5a9419e25b8541c)(actionKey),
                createdContentMetadata: {
                    remixId: remixId,
                    contentId: currentPageId,
                    spaceId: spaceId,
                    isLiveDoc: isLiveDoc
                },
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                userAction: 'insert'
            }
        });
        try {
            // For MAUI apps, duplicate the app first, then insert the duplicated URL.
            // When context.editor is set (gated by platform_editor_maui_jira_updates), use its
            // pre-formed containerAri. Otherwise build a Confluence ARI from the page ID.
            if (actionKey === (0, $3vCSA.DYNAMIC_UI_CREATE_KEY) && (currentPageId || smartCreationEditorContext)) {
                const duplicateExperienceAttributes = {
                    appId: remixId,
                    currentPageId: currentPageId,
                    source: 'mauiEmbedFinalizeButtons'
                };
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                    id: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                    attributes: duplicateExperienceAttributes
                });
                let duplicateFailed = false;
                try {
                    const { id: newAppId } = await (0, $Yuf8j.duplicateMauiApp)(remixId, smartCreationEditorContext ? {
                        containerAri: smartCreationEditorContext.containerAri
                    } : {
                        containerContentId: currentPageId ?? '',
                        cloudId: smartCreationConfig.siteId,
                        contentType: contentType
                    });
                    const duplicatedUrl = (0, $70c887fc0ba44598$export$4c6fb8272867c7c7)(newAppId);
                    (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
                        url: duplicatedUrl,
                        insertReceiverId: insertReceiverId,
                        isUpdate: isUpdate
                    });
                    url = duplicatedUrl;
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'mauiAppDuplicate',
                        action: 'succeeded',
                        actionSubjectId: 'mauiEmbedInsertIntoPage',
                        attributes: {
                            originalId: remixId,
                            newId: newAppId
                        }
                    });
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                        attributes: {
                            ...duplicateExperienceAttributes,
                            newAppId: newAppId
                        }
                    });
                } catch (error) {
                    duplicateFailed = true;
                    sendAnalyticsEvent({
                        eventType: 'operational',
                        actionSubject: 'mauiAppDuplicate',
                        action: 'failed',
                        actionSubjectId: 'mauiEmbedInsertIntoPage',
                        attributes: {
                            originalId: remixId
                        }
                    });
                    const duplicateError = error instanceof Error ? error : new Error('Failed to duplicate MAUI app');
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP,
                        error: duplicateError,
                        attributes: duplicateExperienceAttributes
                    });
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                        error: duplicateError,
                        attributes: {
                            ...duplicateExperienceAttributes,
                            failedDueTo: (0, $16lEl.ExperienceName).REMIX_DUPLICATE_APP
                        }
                    });
                    // Duplication failed — insert the original URL as a fallback
                    // so the user isn't left with nothing.
                    (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
                        url: remixUrl,
                        insertReceiverId: insertReceiverId,
                        isUpdate: isUpdate
                    });
                    url = remixUrl;
                }
                if (!duplicateFailed) experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).REMIX_INSERT
                });
                return url;
            }
            if (!(0, $70c887fc0ba44598$export$613faa0f449b767)(actionKey)) {
                // Fallback for MAUI apps reached without a currentPageId (the
                // duplicate flow above requires one). Insert the original URL
                // as-is.
                (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
                    url: remixUrl,
                    insertReceiverId: insertReceiverId,
                    isUpdate: isUpdate
                });
                url = remixUrl;
                try {
                    await finalizeAction({
                        contentId: remixId,
                        parentId: currentPageId,
                        resolvedSpaceId: spaceId
                    });
                } catch (error) {
                    experienceTracker.fail({
                        name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                        error: error instanceof Error ? error : new Error('finalizeAction failed')
                    });
                    return;
                }
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).REMIX_INSERT
                });
                return url;
            }
            // Whiteboards must be durable before the page keeps a final embed URL. If we
            // inserted a temporary streaming URL on the first chunk, finalization still runs
            // here and then swaps that exact node to the canonical finalized URL by localId.
            let finalizeError;
            try {
                await finalizeAction({
                    contentId: remixId,
                    parentId: currentPageId,
                    resolvedSpaceId: spaceId
                });
            } catch (error) {
                finalizeError = error instanceof Error ? error : new Error('Failed to finalize whiteboard');
            }
            if (!finalizeError) {
                if (hasEarlyInsertedWhiteboardRef.current) replaceEarlyStreamingWhiteboard(remixId, remixUrl);
                else (0, $70c887fc0ba44598$export$20a274baad2c5da7)({
                    url: remixUrl,
                    insertReceiverId: insertReceiverId,
                    isUpdate: isUpdate
                });
                url = remixUrl;
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).REMIX_INSERT
                });
                return url;
            }
            if (hasEarlyInsertedWhiteboardRef.current && $e07426db79f6c0dd$var$isFinalizePermissionError(finalizeError)) experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                attributes: {
                    isFinalizePermissionError: true
                }
            });
            else experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                error: finalizeError
            });
            if (hasEarlyInsertedWhiteboardRef.current) return earlyInsertedWhiteboardUrlRef.current;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                error: error instanceof Error ? error : new Error('Failed to insert into page')
            });
        }
    }, [
        conversationId,
        contentType,
        remixUrl,
        remixId,
        actionKey,
        isLiveDoc,
        spaceId,
        agentMessageId,
        smartCreationEditorContext,
        currentPageId,
        dynamicUiType,
        dynamicUiSubtype,
        insertReceiverId,
        finalizeAction,
        experienceTracker,
        trackAIMAUEvent,
        sendAnalyticsEvent,
        smartCreationConfig.siteId,
        isUpdate,
        replaceEarlyStreamingWhiteboard
    ]);
    const handleInsertInfographicIntoPage = (0, $42omo.useCallback)(async ()=>{
        if (!mediaFileId || !clientId || !insertReceiverId || !siteId) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_INSERT,
            id: (0, $16lEl.ExperienceName).REMIX_INSERT,
            attributes: {
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                contentType: 'image',
                conversationChannelId: conversationId
            }
        });
        trackAIMAUEvent({
            type: 'actioned',
            actionResult: 'contentFinalized',
            source: 'AIMate',
            invokedFrom: 'remix',
            proactive: false,
            userGenerated: true,
            singleInstrumentationID: agentMessageId,
            pageContext: 'confluence-page-edit',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: 'image',
                createdContentMetadata: {
                    mediaFileId: mediaFileId,
                    isLiveDoc: isLiveDoc
                },
                actionKey: actionKey,
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                userAction: 'insert'
            }
        });
        try {
            const mediaUrl = await (0, $70c887fc0ba44598$export$62fb64678f4b5325)({
                mediaFileId: mediaFileId,
                clientId: clientId,
                product: 'confluence'
            });
            (0, $15h8H.getBrowserBridgeAPI)().send((0, $3BJ0q.EditorInsertContentCommand), {
                senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                receiverId: (0, $eL1ct.getConfluenceEditorClientId)(insertReceiverId),
                mode: 'upload-and-insert-media',
                placement: (0, $70c887fc0ba44598$export$aa4d2a25d60fb7d2)(dynamicUiSource) ? 'end-of-doc' : isUpdate && (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? 'replace-selection' : 'after-block',
                useStoredSelection: true,
                conversationChannelId: conversationId,
                interactionSource: interactionSource,
                aspectRatio: aspectRatio,
                remixSubtype: dynamicUiSubtype,
                data: {
                    type: 'image',
                    url: mediaUrl,
                    presentation: undefined
                }
            });
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).REMIX_INSERT
            });
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).REMIX_INSERT,
                error: error instanceof Error ? error : new Error('Failed to insert infographic into page')
            });
            return;
        }
    }, [
        mediaFileId,
        clientId,
        siteId,
        dynamicUiType,
        actionKey,
        experienceTracker,
        conversationId,
        dynamicUiSource,
        trackAIMAUEvent,
        agentMessageId,
        isLiveDoc,
        insertReceiverId,
        dynamicUiSubtype,
        isUpdate,
        interactionSource,
        aspectRatio
    ]);
    const handleInsertMauiEmbedIntoPageRef = (0, $42omo.useRef)(handleInsertMauiEmbedIntoPage);
    (0, $42omo.useEffect)(()=>{
        handleInsertMauiEmbedIntoPageRef.current = handleInsertMauiEmbedIntoPage;
    }, [
        handleInsertMauiEmbedIntoPage
    ]);
    const handleInsertInfographicIntoPageRef = (0, $42omo.useRef)(handleInsertInfographicIntoPage);
    (0, $42omo.useEffect)(()=>{
        handleInsertInfographicIntoPageRef.current = handleInsertInfographicIntoPage;
    }, [
        handleInsertInfographicIntoPage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return;
        if (isViewMode) return;
        if (hasEarlyInsertedWhiteboardRef.current) return;
        if (contentClassification?.type !== 'whiteboard' || !contentClassification.data?.contentId) return;
        // Insert the temporary whiteboard shell when the first real ACTION_PART arrives.
        // This avoids showing an empty whiteboard during long gaps between classification
        // and the first streamed diagram content. The same localId is later used to replace
        // this temporary URL with the finalized canonical URL, even if native-embeds has
        // transformed the Smart Link into a native whiteboard extension in the meantime.
        insertEarlyStreamingWhiteboard(contentClassification.data.contentId);
    }, [
        contentClassification,
        insertEarlyStreamingWhiteboard,
        isViewMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isViewMode) return;
        if (actionKey && finalMessage && !hasInsertedRef.current && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            hasInsertedRef.current = true;
            const insertContent = async ()=>{
                if (actionKey === (0, $3vCSA.IMAGE_CREATE_KEY)) {
                    await handleInsertInfographicIntoPageRef.current();
                    // for image, the real fieldId will be updated after the image is uploaded via updateRemixImageHistoryFieldId
                    return {
                        fieldId: 'fieldId-placeholder'
                    };
                } else {
                    const url = await handleInsertMauiEmbedIntoPageRef.current();
                    if (hasEarlyInsertedWhiteboardRef.current) // The ephemeral preview sends a final whiteboard bridge command with
                    // `isStreamComplete: true`; the whiteboard client uses that final signal
                    // for end-of-stream behaviours such as zoom-to-fit. Since the editor flow
                    // inserts the whiteboard outside the preview, mirror that signal here once
                    // streaming has completed, even when finalization fails and the inserted
                    // diagram remains unfinalized.
                    (0, $70c887fc0ba44598$export$46b78d980e0f6822)({
                        data: finalWhiteboardCreateActionData,
                        groupId: conversationId,
                        singleInstrumentationID: agentMessageId
                    });
                    return {
                        url: url
                    };
                }
            };
            insertContent().then((result)=>{
                if (!result) return;
                const { fieldId: fieldId, url: url } = result;
                if (!isUpdate) onRemixInsertSuccess?.({
                    currentConversationId: conversationId,
                    remixMetadata: (0, $3vCSA.getRemixMetadata)({
                        action: action,
                        selectedRemixMetadata: {
                            selectedDynamicUiType: dynamicUiType,
                            selectedDynamicUiSubtype: dynamicUiSubtype
                        }
                    })
                });
                if (!(0, $dh538.fg)('platform_editor_ai_remix_toolbar')) return;
                if (hasEarlyInsertedWhiteboardRef.current && url) finishRemixThinkingRef.current?.();
                if (isUpdate) {
                    if (conversationId && historyEntryForUpdate?.dynamicUiType) addHistoryStackEntry?.({
                        conversationId: conversationId,
                        dynamicUiType: historyEntryForUpdate.dynamicUiType,
                        dynamicUiSubtype: dynamicUiSubtypeForUpdate,
                        finalMessage: finalMessage,
                        previousFieldId: historyEntryForUpdate.fieldId,
                        previousUrl: historyEntryForUpdate.url,
                        url: url,
                        fieldId: fieldId
                    });
                    // Release the in-flight mark so the bridge processors resume
                    // handling BE pushes for this id. Must match the toolbar's
                    // tracking key: image fieldId, or MAUI app id from the
                    // *pre-update* stack-entry URL.
                    const completionId = historyEntryForUpdate?.fieldId ?? (0, $9S1Tm.getMauiIdFromUrl)(historyEntryForUpdate?.url);
                    if (completionId) onVariantUpdateComplete?.(completionId);
                } else if (conversationId && dynamicUiSource && dynamicUiType) addHistoryEntry?.({
                    conversationId: conversationId,
                    dynamicUiSource: dynamicUiSource,
                    dynamicUiSubtype: dynamicUiSubtype,
                    dynamicUiType: dynamicUiType,
                    finalMessage: finalMessage,
                    contentClassification: contentClassification?.type === 'whiteboard' ? {
                        ...contentClassification,
                        data: finalWhiteboardCreateActionData
                    } : contentClassification,
                    url: url,
                    fieldId: fieldId
                });
            }).finally(()=>{
                resetContext();
                setThinkingCompleteRef.current?.(true);
            });
        }
    }, [
        isViewMode,
        action,
        actionKey,
        finalMessage,
        resetContext,
        conversationId,
        dynamicUiType,
        dynamicUiSource,
        dynamicUiSubtype,
        contentClassification,
        finalWhiteboardCreateActionData,
        agentMessageId,
        addHistoryEntry,
        addHistoryStackEntry,
        onRemixInsertSuccess,
        onVariantUpdateComplete,
        isUpdate,
        historyEntryForUpdate?.dynamicUiType,
        dynamicUiSubtypeForUpdate,
        historyEntryForUpdate
    ]);
    // reset the hasInsertedRef when the final message is cleared
    (0, $42omo.useEffect)(()=>{
        if (!finalMessage && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            hasInsertedRef.current = false;
            hasEarlyInsertedWhiteboardRef.current = false;
            earlyInsertedWhiteboardLocalIdRef.current = undefined;
            earlyInsertedWhiteboardUrlRef.current = undefined;
        }
    }, [
        finalMessage
    ]);
}












var $1oCLl = parcelRequire("1oCLl");











var $jEzab = parcelRequire("jEzab");


var $9WfmN = parcelRequire("9WfmN");


var $aouqA = parcelRequire("aouqA");


var $kTGKU = parcelRequire("kTGKU");









const $8ebc28101921e7ae$export$322153c0a4e9d5f = [
    {
        value: 'corporate-modern',
        label: (0, $kTGKU.default).remixVariantModernStyle,
        updateChatMessage: (0, $kTGKU.default).chatUpdateModernStyle
    },
    {
        value: 'corporate-doodle',
        label: (0, $kTGKU.default).remixVariantSketchStyle,
        updateChatMessage: (0, $kTGKU.default).chatUpdateSketchStyle
    }
];
const $8ebc28101921e7ae$export$535f851b59dd2234 = [
    {
        value: 'charlie',
        label: (0, $kTGKU.default).remixVariantBoldStyle,
        updateChatMessage: (0, $kTGKU.default).chatUpdateBoldStyle
    },
    {
        value: 'minimalist',
        label: (0, $kTGKU.default).remixVariantMinimalistStyle,
        updateChatMessage: (0, $kTGKU.default).chatUpdateMinimalistStyle
    },
    {
        value: 'corporate-doodle',
        label: (0, $kTGKU.default).remixVariantSketchStyle,
        updateChatMessage: (0, $kTGKU.default).chatUpdateSketchStyle
    }
];
function $8ebc28101921e7ae$export$8f231a371a5707c7({ useNewStyles: useNewStyles }) {
    return useNewStyles ? $8ebc28101921e7ae$export$535f851b59dd2234 : $8ebc28101921e7ae$export$322153c0a4e9d5f;
}
const $8ebc28101921e7ae$export$51da310b481fda77 = [
    {
        value: 'flip-cards',
        label: (0, $kTGKU.default).remixVariantFlipCard,
        updateChatMessage: (0, $kTGKU.default).chatUpdateFlipCard
    },
    {
        value: 'quadrant',
        label: (0, $kTGKU.default).remixVariantQuadrant,
        updateChatMessage: (0, $kTGKU.default).chatUpdateQuadrant
    },
    {
        value: 'tree-map',
        label: (0, $kTGKU.default).remixVariantTreeMap,
        updateChatMessage: (0, $kTGKU.default).chatUpdateTreeMap
    },
    {
        value: 'horizontal-timeline',
        label: (0, $kTGKU.default).remixVariantTimeline,
        updateChatMessage: (0, $kTGKU.default).chatUpdateTimeline
    },
    {
        value: 'map',
        label: (0, $kTGKU.default).remixVariantGeographicalMap,
        updateChatMessage: (0, $kTGKU.default).chatUpdateGeographicalMap
    },
    {
        value: 'org-chart',
        label: (0, $kTGKU.default).remixVariantOrgChart,
        updateChatMessage: (0, $kTGKU.default).chatUpdateOrgChart
    },
    {
        value: 'gantt-chart',
        label: (0, $kTGKU.default).remixVariantGanttChart,
        updateChatMessage: (0, $kTGKU.default).chatUpdateGanttChart
    }
];
const $8ebc28101921e7ae$var$imageVariant = {
    value: 'image',
    label: (0, $kTGKU.default).remixVariantImage,
    updateChatMessage: (0, $kTGKU.default).chatUpdateImage,
    emitType: 'image'
};
function $8ebc28101921e7ae$export$2387703d47fba168({ enableImage: enableImage }) {
    return enableImage ? [
        ...$8ebc28101921e7ae$export$51da310b481fda77,
        $8ebc28101921e7ae$var$imageVariant
    ] : $8ebc28101921e7ae$export$51da310b481fda77;
}


const $c31fbf65e12fbf2e$var$staticVariantsByRemixType = {
    chart: [
        {
            value: 'line-chart',
            label: (0, $kTGKU.default).remixVariantLineChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateLineChart
        },
        {
            value: 'area-chart',
            label: (0, $kTGKU.default).remixVariantAreaChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateAreaChart
        },
        {
            value: 'bar-chart',
            label: (0, $kTGKU.default).remixVariantBarChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateBarChart
        },
        {
            value: 'funnel-chart',
            label: (0, $kTGKU.default).remixVariantFunnelChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateFunnelChart
        },
        {
            value: 'pie-chart',
            label: (0, $kTGKU.default).remixVariantPieChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdatePieChart
        },
        {
            value: 'gantt-chart',
            label: (0, $kTGKU.default).remixVariantGanttChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateGanttChart
        }
    ],
    diagram: [
        {
            value: 'mindmap',
            label: (0, $kTGKU.default).remixVariantMindMap,
            updateChatMessage: (0, $kTGKU.default).chatUpdateMindMap
        },
        {
            value: 'flowchart',
            label: (0, $kTGKU.default).remixVariantFlowChart,
            updateChatMessage: (0, $kTGKU.default).chatUpdateFlowChart
        }
    ]
};
/**
 * Build a subtype-to-backend-type map.  Prefers `emitType` when set so
 * that the backend receives the correct type even when a subtype is displayed
 * under a different UI category.
 */ function $c31fbf65e12fbf2e$var$buildEmitTypeBySubtype(variantMap) {
    return Object.entries(variantMap).reduce((acc, [remixType, variants])=>{
        for (const variant of variants)acc[variant.value] = variant.emitType ?? remixType;
        return acc;
    }, {});
}
/**
 * Reverse mapping from subtype to remix type.
 * Each subtype is unique to one remix type, so we can infer the type from the subtype.
 */ function $c31fbf65e12fbf2e$var$buildRemixTypeBySubtype(variantMap) {
    return Object.entries(variantMap).reduce((acc, [remixType, variants])=>{
        for (const variant of variants)acc[variant.value] = remixType;
        return acc;
    }, {});
}
function $c31fbf65e12fbf2e$export$a1c201a4bfffda2a() {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { sendMessage: sendMessage } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { preferences: preferences } = (0, $9WfmN.useUserPreferences)();
    const { isUpdate: isUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, historyEntryForUpdate: historyEntryForUpdate, setFinalMessage: setFinalMessage, setConversationId: setConversationId, remixUpdateSentinelRef: remixUpdateSentinelRef, isViewMode: isViewMode } = (0, $36a2a4497f062535$export$4ea2348b19df1d27)();
    const { getMessages: getMessages } = (0, $jEzab.useChatMessagesActions)();
    const variantsByRemixType = (0, $42omo.useMemo)(()=>({
            ...$c31fbf65e12fbf2e$var$staticVariantsByRemixType,
            infographic: (0, $8ebc28101921e7ae$export$8f231a371a5707c7)({
                useNewStyles: true
            }),
            'visual-aid': (0, $8ebc28101921e7ae$export$2387703d47fba168)({
                enableImage: true
            })
        }), []);
    const remixTypeBySubtype = (0, $42omo.useMemo)(()=>$c31fbf65e12fbf2e$var$buildRemixTypeBySubtype(variantsByRemixType), [
        variantsByRemixType
    ]);
    const emitTypeBySubtype = (0, $42omo.useMemo)(()=>$c31fbf65e12fbf2e$var$buildEmitTypeBySubtype(variantsByRemixType), [
        variantsByRemixType
    ]);
    const updateRemix = (0, $42omo.useCallback)(()=>{
        if (!(0, $dh538.fg)('platform_editor_ai_remix_toolbar')) return;
        if (isViewMode || !isUpdate || !historyEntryForUpdate || !dynamicUiSubtypeForUpdate) return;
        const { conversationId: conversationId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, finalMessage: finalMessage } = historyEntryForUpdate;
        // Capture the id of the result currently on the page (the latest final
        // message of this conversation) before sending the update. The dedup in
        // useRemixToAIFC suppresses this id until the new variant response arrives,
        // so the previously-displayed result is never re-applied as the new one.
        // Read live from the chat store: stored remix-history ids can be stale for
        // BE-driven Ask Rovo edits, which inherit the prior entry's message id.
        remixUpdateSentinelRef.current = (0, $9S1Tm.getFinalMessageId)((0, $70c887fc0ba44598$export$1b93a9a573fc03d0)(getMessages(conversationId)));
        setFinalMessage(undefined);
        setConversationId(conversationId);
        const remixType = (dynamicUiSubtype && remixTypeBySubtype[dynamicUiSubtype]) ?? dynamicUiType ?? 'custom';
        const remixVariants = (variantsByRemixType[remixType] ?? []).map((v)=>{
            const formattedLabel = formatMessage(v.label);
            const formattedChatUpdateMessage = formatMessage(v.updateChatMessage);
            return {
                value: v.value,
                label: formattedLabel,
                chatUpdateMessage: formattedChatUpdateMessage
            };
        });
        const selectedVariant = remixVariants.find((v)=>v.value === dynamicUiSubtypeForUpdate) ?? remixVariants[0];
        // Only extract whiteboardContentId for whiteboard actions — chart actions
        // include contentId that would otherwise wrongly trigger shouldOverrideContentId.
        const currentDisplayActionKey = finalMessage?.content?.message?.message?.actions?.[0]?.key;
        const isWhiteboardAction = currentDisplayActionKey === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || currentDisplayActionKey === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
        // Start remixRegenerate experience — succeed/fail are settled by the staging-area preview components.
        const currentMediaFileId = (0, $70c887fc0ba44598$export$ced9470b70691a2b)(finalMessage);
        const contentMauiId = (0, $9S1Tm.getMauiIdFromUrl)(historyEntryForUpdate.url) ?? (0, $70c887fc0ba44598$export$4364bc0cb56ef88f)({
            message: finalMessage,
            actionKey: (0, $3vCSA.DYNAMIC_UI_CREATE_KEY)
        });
        // CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY has no case in getRemixIdFromPreview, use CREATE key for both.
        const whiteboardContentId = isWhiteboardAction ? (0, $70c887fc0ba44598$export$4364bc0cb56ef88f)({
            message: finalMessage,
            actionKey: (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY)
        }) : undefined;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_REGENERATE,
            id: contentMauiId ?? whiteboardContentId ?? currentMediaFileId ?? 'unknown',
            attributes: {
                contentMauiId: contentMauiId,
                remixType: dynamicUiType,
                remixSubtype: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
                hasSubtypeChange: dynamicUiSubtype !== (dynamicUiSubtypeForUpdate ?? dynamicUiSubtype),
                conversationChannelId: conversationId
            }
        });
        // if there's a whiteboard contentId, we need to override the contentId to be
        // the existing whiteboard contentId to be able to update it.
        // we don't do this though if the subtype is set because for changing subtypes, we
        // want a new whiteboard creation instead of updating existing board
        const shouldOverrideContentId = whiteboardContentId && !dynamicUiSubtypeForUpdate;
        // Omit mediaFileId for infographic style updates (marked by subtype being defined)
        const mediaFileId = dynamicUiSubtypeForUpdate === undefined ? (0, $70c887fc0ba44598$export$ced9470b70691a2b)(finalMessage) : undefined;
        const resolvedUiType = shouldOverrideContentId ? undefined : dynamicUiSubtypeForUpdate ? emitTypeBySubtype[dynamicUiSubtypeForUpdate] : dynamicUiType;
        const isCustom = resolvedUiType === 'custom';
        const experience = resolvedUiType ? isCustom ? 'remix_custom' : 'remix_edit' : undefined;
        const isRemixExperienceContextEnabled = (0, $1oCLl.expValEquals)('rovo_remix_experience_context', 'isEnabled', true);
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: selectedVariant?.chatUpdateMessage
                        }
                    ]
                }
            ]
        };
        const additionalAnalyticAttributes = dynamicUiSubtype ? {
            remixVariantBefore: dynamicUiSubtype,
            remixVariantAfter: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
            remixVariantChanged: dynamicUiSubtype !== (dynamicUiSubtypeForUpdate ?? dynamicUiSubtype)
        } : undefined;
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: conversationId,
            messageSources: {
                interactionSource: 'editor'
            },
            additionalAnalyticAttributes: additionalAnalyticAttributes,
            productKey: 'confluence',
            contentContext: 'global',
            minionAlias: 'remix-content',
            skipEditorContext: true,
            creationContextParams: {
                source: 'remix',
                ...isRemixExperienceContextEnabled && experience ? {
                    experience: experience
                } : {},
                ...isRemixExperienceContextEnabled && !isCustom && resolvedUiType ? {
                    blocks: [
                        resolvedUiType
                    ]
                } : {},
                contentMauiId: contentMauiId,
                dynamicUiType: resolvedUiType,
                dynamicUiSubtype: dynamicUiSubtypeForUpdate ?? dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                mediaFileId: // TODO check if this is correct
                mediaFileId,
                ...shouldOverrideContentId ? {
                    isViewMode: false
                } : isViewMode ? {
                    isViewMode: true
                } : {}
            },
            contentId: shouldOverrideContentId ? whiteboardContentId : undefined
        });
    }, [
        setConversationId,
        variantsByRemixType,
        isViewMode,
        formatMessage,
        emitTypeBySubtype,
        sendMessage,
        preferences.storeUserMessages,
        remixTypeBySubtype,
        experienceTracker,
        setFinalMessage,
        isUpdate,
        historyEntryForUpdate,
        dynamicUiSubtypeForUpdate,
        getMessages,
        remixUpdateSentinelRef
    ]);
    return {
        updateRemix: updateRemix
    };
}






var $6jPem = parcelRequire("6jPem");


var $c6GJD = parcelRequire("c6GJD");

















var $bPHr8 = parcelRequire("bPHr8");




















var $16hKZ = parcelRequire("16hKZ");


var $gCqjE = parcelRequire("gCqjE");






const $60a00ae86ae48300$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $6jPem.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $16hKZ.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
const $60a00ae86ae48300$var$isActionComplete = (chatMessages)=>{
    const hasWhiteboard = (0, $cteoa.findLastAssistantAction)(chatMessages, (action)=>action.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || action.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)) !== undefined;
    if (hasWhiteboard) return true;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return true;
        if (message.type === 'HUMAN') return false;
    }
    return false;
};
const $60a00ae86ae48300$var$isWhiteboardCreateOrUpdateKey = (key)=>key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
const $60a00ae86ae48300$var$shouldUseEphemeralPreviewForAction = (action)=>(0, $3vCSA.isRemixGeneratedFlow)(action);
// When free-text remix produces a whiteboard (isRemixGenerated=true, no dynamicUiSubtype),
// open the full AIFC staging modal rather than inserting a URL into the page.
const $60a00ae86ae48300$var$shouldUseAifcStagingAreaForAction = (action)=>{
    if (!(0, $3vCSA.isRemixGeneratedFlow)(action)) return false;
    // Killswitch: set platform_editor_ai_remix_whiteboard_to_aifc value=true to revert.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).getExperimentValue('platform_editor_ai_remix_whiteboard_to_aifc', 'value', false)) return false;
    return $60a00ae86ae48300$var$isWhiteboardCreateOrUpdateKey(action.key) && !action.data?.dynamicUiSubtype;
};
const $60a00ae86ae48300$var$defaultShouldUseEphemeralPreview = (chatMessages)=>{
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') return message.action ? $60a00ae86ae48300$var$shouldUseEphemeralPreviewForAction(message.action) : false;
    }
    return false;
};
const $60a00ae86ae48300$var$defaultIsActionReady = (chatMessages)=>$60a00ae86ae48300$var$isActionComplete(chatMessages);
const $60a00ae86ae48300$export$cca9e2432f59b3f8 = ({ config: config, onActionReady: onActionReady, productIntegration: productIntegration, onStagingAIFCFlowStarted: onStagingAIFCFlowStarted })=>{
    const { isUpdate: isUpdate, conversationId: conversationId, setConversationId: setConversationId, setFinalMessage: setFinalMessage, setContentClassification: setContentClassification, remixUpdateSentinelRef: remixUpdateSentinelRef } = (0, $36a2a4497f062535$export$4ea2348b19df1d27)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $2O3ot.useStagingAreaActions)();
    const { preferences: preferences } = (0, $9WfmN.useUserPreferences)();
    // remove local state when cleanup platform_editor_ai_remix_in_editor_loading
    const [remixConversationId, setRemixConversationId] = (0, $42omo.useState)(undefined);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const remixConversationById = (0, $ajfvU.useConversationById)({
        conversationId: conversationId ?? ''
    });
    const remixConversation = (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? remixConversationById : activeRemixConversation;
    const remixConversationIdToRead = (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? conversationId : activeRemixConversation?.id;
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: remixConversationIdToRead ?? ''
    });
    let finalMessage = (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? (0, $70c887fc0ba44598$export$1b93a9a573fc03d0)(chatMessages) : undefined;
    // If it's an update, suppress the previously-displayed result until the new
    // variant response arrives. The sentinel is the id of the final message that
    // was on the page when the update was initiated, captured live in
    // useUpdateRemix — stored remix-history ids can be stale (e.g. a BE-driven Ask
    // Rovo edit inherits the prior entry's id rather than its own message id).
    const currentFinalMessageId = (0, $9S1Tm.getFinalMessageId)(finalMessage);
    const previousFinalMessageId = remixUpdateSentinelRef.current;
    if (isUpdate && previousFinalMessageId && previousFinalMessageId === currentFinalMessageId && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) finalMessage = undefined;
    const remixStoreError = chatMessages.find((message)=>(0, $bPHr8.isStoreError)(message)) ?? null;
    const isRemixError = remixConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const isRemixAborted = !isRemixError && remixConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).idle && !$60a00ae86ae48300$var$isActionComplete(chatMessages) && chatMessages.some((0, $bPHr8.isStoreAssistant));
    const actionReadyFired = (0, $42omo.useRef)(false);
    const hasOpenedFullStagingModalRef = (0, $42omo.useRef)(false);
    const recordedFinalMessageId = (0, $42omo.useRef)(undefined);
    const recordedFinalMessage = (0, $42omo.useRef)(undefined);
    const previousConversationId = (0, $42omo.useRef)(remixConversationIdToRead);
    (0, $42omo.useEffect)(()=>{
        if (previousConversationId.current !== remixConversationIdToRead) {
            actionReadyFired.current = false;
            hasOpenedFullStagingModalRef.current = false;
            recordedFinalMessageId.current = undefined;
            recordedFinalMessage.current = undefined;
            previousConversationId.current = remixConversationIdToRead;
            if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) setFinalMessage(undefined);
        }
    }, [
        remixConversationIdToRead,
        setFinalMessage
    ]);
    (0, $42omo.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const isActionReady = config.isActionReady?.(chatMessages) ?? $60a00ae86ae48300$var$defaultIsActionReady(chatMessages);
        if (isActionReady) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        config,
        chatMessages,
        onActionReady
    ]);
    (0, $42omo.useEffect)(()=>{
        const finalMessageId = (0, $9S1Tm.getFinalMessageId)(finalMessage);
        const hasRecordedFinalMessage = finalMessageId !== undefined ? recordedFinalMessageId.current === finalMessageId : recordedFinalMessage.current === finalMessage;
        if (finalMessage && !hasRecordedFinalMessage && !hasOpenedFullStagingModalRef.current && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            recordedFinalMessageId.current = finalMessageId;
            recordedFinalMessage.current = finalMessage;
            setFinalMessage(finalMessage);
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).REMIX_START
            });
        }
    }, [
        finalMessage,
        setFinalMessage,
        experienceTracker
    ]);
    const stopRemixing = (0, $42omo.useCallback)(()=>{
        abortRequests?.({
            conversationId: remixConversationIdToRead
        });
    }, [
        abortRequests,
        remixConversationIdToRead
    ]);
    // Despite the name, this opens the appropriate AIFC surface for the generated output:
    // remix-generated outputs use the floating ephemeral preview, while non-remix AIFC
    // object outputs (page, database, whiteboard, slides, etc.) use the full staging modal.
    const openRemixPreview = (0, $42omo.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        let shouldUseEphemeralPreview;
        if (options?.action) shouldUseEphemeralPreview = !$60a00ae86ae48300$var$shouldUseAifcStagingAreaForAction(options.action) && $60a00ae86ae48300$var$shouldUseEphemeralPreviewForAction(options.action);
        else shouldUseEphemeralPreview = config.shouldUseEphemeralPreview?.(chatMessages) ?? $60a00ae86ae48300$var$defaultShouldUseEphemeralPreview(chatMessages);
        productIntegration.openRemixPreview({
            isFloating: shouldUseEphemeralPreview,
            remixConversationId: options?.remixConversationId ?? remixConversationIdToRead
        });
    }, [
        config,
        chatMessages,
        productIntegration,
        remixConversationIdToRead,
        setForceSkipAutoConversationSelection
    ]);
    const sendAIFCPrompt = (0, $42omo.useCallback)(async ({ userPrompt: userPrompt, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, aspectRatio: aspectRatio, aiFeatureName: aiFeatureName })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $gCqjE.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $gCqjE.getTypeDisplayName)(dynamicUiType);
        const promptText = dynamicUiType === 'custom' || dynamicUiType === 'image' && userPrompt ? userPrompt ?? defaultPromptText : `Remix the selected content as a ${selectedDisplayName}`;
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = crypto.randomUUID();
        setRemixConversationId(newConversationId);
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            setConversationId(newConversationId);
            setFinalMessage(undefined);
            setContentClassification(undefined);
        }
        actionReadyFired.current = false;
        await createConversationOptimistically({
            id: newConversationId
        });
        // 'custom' is a free-form prompt with no block type — maps to REMIX_CUSTOM.
        // Everything else (chart/diagram/visual-aid/infographic/etc.) is REMIX with the
        // block type as `blocks`. The backend ConfluenceExperienceValidator rejects
        // REMIX without `blocks`, and rejects REMIX_CUSTOM with `blocks`.
        const isCustom = dynamicUiType === 'custom';
        const isRemixExperienceContextEnabled = (0, $1oCLl.expValEquals)('rovo_remix_experience_context', 'isEnabled', true);
        const creationContextParamsToSend = {
            dynamicUiType: dynamicUiType,
            dynamicUiSubtype: dynamicUiSubtype,
            dynamicUiSource: dynamicUiSource,
            source: 'remix',
            ...isRemixExperienceContextEnabled && (isCustom || dynamicUiType) ? {
                experience: isCustom ? 'remix_custom' : 'remix'
            } : {},
            ...isRemixExperienceContextEnabled && !isCustom && dynamicUiType ? {
                blocks: [
                    dynamicUiType
                ]
            } : {},
            ...aspectRatio ? {
                additionalContext: {
                    aspectRatio: aspectRatio
                }
            } : {}
        };
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                followUpSource: interactionSource,
                aiFeatureName: aiFeatureName
            },
            promptStreamHook: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? {
                onActionClassification: async (actionClassification)=>{
                    setContentClassification((0, $70c887fc0ba44598$export$54efbf7cb26887a3)(actionClassification));
                },
                onActionPart: async (actionPart)=>{
                    if (actionPart.type === 'ACTION_PREPARE' && !hasOpenedFullStagingModalRef.current) {
                        const useAifcStagingArea = $60a00ae86ae48300$var$shouldUseAifcStagingAreaForAction(actionPart.message);
                        const useEphemeralPreview = !useAifcStagingArea && $60a00ae86ae48300$var$shouldUseEphemeralPreviewForAction(actionPart.message);
                        if (!useEphemeralPreview) {
                            hasOpenedFullStagingModalRef.current = true;
                            openRemixPreview({
                                action: actionPart.message,
                                remixConversationId: newConversationId
                            });
                            onStagingAIFCFlowStarted?.();
                        }
                    }
                    // ACTION_CLASSIFICATION is the semantic source of truth for the stream's
                    // content type. ACTION_PREPARE may carry a contentId, but it does not yet
                    // represent visible whiteboard output. Wait for the first real ACTION_PART
                    // before inserting the whiteboard so users do not see an empty embed.
                    if (actionPart.type === 'ACTION_PART' && actionPart.message.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) && !hasOpenedFullStagingModalRef.current) setContentClassification((classification)=>(0, $70c887fc0ba44598$export$b5c3d4828f4ee170)(classification, actionPart.message.data));
                }
            } : undefined,
            productKey: config.productKey,
            contentContext: 'staging-area',
            creationContextParams: creationContextParamsToSend
        });
        setPrompt('Remix');
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSource);
    }, [
        setConversationId,
        config.productKey,
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        preferences.storeUserMessages,
        setFinalMessage,
        setContentClassification,
        openRemixPreview,
        onStagingAIFCFlowStarted
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        remixStoreError: remixStoreError,
        openRemixPreview: openRemixPreview,
        closeRemixPreview: productIntegration.closeRemixPreview
    };
};


// remove this when cleanup platform_editor_ai_remix_in_editor_loading
function $a7908ce97f85643c$var$useOnCompleteOld() {}
const $a7908ce97f85643c$var$useOnComplete = (0, $dTb09.conditionalHooksFactory)(()=>(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading'), (0, $e07426db79f6c0dd$export$d70fe66889862a96), $a7908ce97f85643c$var$useOnCompleteOld);
const $a7908ce97f85643c$export$f07319916703112a = (historyEntryForUpdate, dynamicUiSubtypeForUpdate, submittedUpdateKey)=>{
    if (!historyEntryForUpdate || !dynamicUiSubtypeForUpdate) return {
        shouldSubmit: false
    };
    const updateKey = [
        historyEntryForUpdate.conversationId,
        historyEntryForUpdate.url ?? historyEntryForUpdate.fieldId ?? '',
        dynamicUiSubtypeForUpdate
    ].join(':');
    return {
        shouldSubmit: submittedUpdateKey !== updateKey,
        updateKey: updateKey
    };
};
/**
 * editor has two modes, editing / viewing
 * - for editing mode, the thinking bar is rendered by the editor plugin
 * - for viewing mode, the thinking bar is rendered by the malleable-ui components
 * so the flow is different in two modes, specifically the onCompleteAnimationFinished callback
 */ const $a7908ce97f85643c$var$RemixContentComponentInner = ({ handleModalClose: handleModalClose, selectedContext: selectedContext, editorApi: editorApi, isComplete: pluginIsComplete, isThinking: isThinking, onStartThinking: onStartThinking, onDismissThinkingUi: onDismissThinkingUi, onStopThinking: onStopThinking, onRegisterAbortRequest: onRegisterAbortRequest, finishRemixThinking: finishRemixThinking, remixModalMetadata: remixModalMetadata, remixSource: remixSource, productIntegration: productIntegration, productConfig: productConfig, hiddenOptions: hiddenOptions })=>{
    const { isViewMode: isViewMode, setDynamicUiType: setDynamicUiType, setDynamicUiSubtype: setDynamicUiSubtype, setDynamicUiSource: setDynamicUiSource, setInteractionSource: setInteractionSource, setAspectRatio: setAspectRatio, showLocationPicker: showLocationPicker, setThinkingComplete: setThinkingComplete, clearThinkingDecoration: clearThinkingDecoration, isUpdate: isUpdate, historyEntryForUpdate: historyEntryForUpdate, dynamicUiSubtypeForUpdate: dynamicUiSubtypeForUpdate, onRemixThinkingCompleteAnimationFinished: onRemixThinkingCompleteAnimationFinished, resetContext: resetContext } = (0, $36a2a4497f062535$export$4ea2348b19df1d27)();
    const isRemixCancelled = (0, $42omo.useRef)(false);
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const openRemixPreviewRef = (0, $42omo.useRef)(()=>{});
    const selectedSubTypeRef = (0, $42omo.useRef)(undefined);
    const hasAutoSubmittedRef = (0, $42omo.useRef)(false);
    const remixModalMetadataRef = (0, $42omo.useRef)(remixModalMetadata);
    remixModalMetadataRef.current = remixModalMetadata;
    const isThinkingRef = (0, $42omo.useRef)(isThinking);
    isThinkingRef.current = isThinking;
    const updateRemixRef = (0, $42omo.useRef)(undefined);
    const { dynamicUiType: dynamicUiType } = (0, $2O3ot.useStagingAreaState)();
    // remove legacy local state when cleanup platform_editor_ai_remix_in_editor_loading
    const [isComplete, setIsComplete] = (0, $42omo.useState)(false);
    const resetCompletion = (0, $42omo.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    const openPreviewAndTrack = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).REMIX_START
        });
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $16lEl.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: productConfig.analyticsProductName ?? productConfig.productKey,
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: 'editor'
            }
        });
        openRemixPreviewRef.current();
        // stop thinking when showing the preview modal, otherwise,
        // the thinking bar will flash when the preview modal close
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            if (isViewMode && !(0, $dh538.fg)('cc-maui-fix-live-doc-previews')) onDismissThinkingUi?.({
                reopenModal: false
            });
            else onStopThinking({
                reopenModal: false
            });
        }
    }, [
        dynamicUiType,
        experienceTracker,
        isViewMode,
        onDismissThinkingUi,
        onStopThinking,
        productConfig.analyticsProductName,
        productConfig.productKey
    ]);
    // when updating in editing mode, will call this callback when the thinking bar is complete
    // when in viewing mode, we need to open the preview modal when the thinking bar is complete
    const onCompleteAnimationFinished = (0, $42omo.useCallback)(()=>{
        if (!isViewMode && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) onRemixThinkingCompleteAnimationFinished?.();
        else openPreviewAndTrack();
    }, [
        openPreviewAndTrack,
        onRemixThinkingCompleteAnimationFinished,
        isViewMode
    ]);
    const onActionReady = (0, $42omo.useCallback)(()=>{
        if (!isRemixCancelled.current) {
            (0, $16lEl.remixGeneratePreviewExperience).mark((0, $16lEl.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true) {
                // When we use the "showProgressBar"
                if ((0, $dh538.fg)('platform_editor_maui_jira_updates')) {
                    // Defer opening the preview until the progress bar fills to 100%.
                    if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) setThinkingComplete?.(true);
                    else setIsComplete(true);
                } else openPreviewAndTrack();
            }
        }
    }, [
        openPreviewAndTrack,
        setThinkingComplete,
        isViewMode
    ]);
    const onStagingAIFCFlowStarted = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).REMIX_START
        });
        isRemixCancelled.current = true;
        clearThinkingDecoration?.();
        finishRemixThinking?.();
        handleModalClose();
    }, [
        clearThinkingDecoration,
        experienceTracker,
        finishRemixThinking,
        handleModalClose
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, remixStoreError: remixStoreError, openRemixPreview: openRemixPreview, closeRemixPreview: closeRemixPreview } = (0, $60a00ae86ae48300$export$cca9e2432f59b3f8)({
        config: productConfig,
        onActionReady: onActionReady,
        productIntegration: productIntegration,
        onStagingAIFCFlowStarted: onStagingAIFCFlowStarted
    });
    openRemixPreviewRef.current = openRemixPreview;
    // Register stopRemixing so that cancelRemixThinking (called from the decoration or
    // RemixContent.tsx's onStopThinking for the toolbar ON path) can abort the in-flight
    // AI request and trigger the paired aiInteraction initiated + dismissed analytics.
    (0, $42omo.useEffect)(()=>{
        return onRegisterAbortRequest?.(stopRemixing);
    }, [
        onRegisterAbortRequest,
        stopRemixing
    ]);
    const { updateRemix: updateRemix } = (0, $c31fbf65e12fbf2e$export$a1c201a4bfffda2a)();
    updateRemixRef.current = updateRemix;
    const experienceTrackerRef = (0, $42omo.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (isRemixCancelled.current) return;
            experienceTrackerRef.current.abort({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
        };
    }, []);
    const onRemixFlowActiveChange = (0, $42omo.useCallback)((active)=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) // when start/cancel, reset the context
        resetContext();
        if (active) {
            isRemixCancelled.current = false;
            // Clear stale completion state from any previous flow.
            if (!(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) resetCompletion();
            // When isThinking is already true (e.g. pre-supplied userPrompt flow from
            // startRemixThinking), skip calling onStartThinking again — it would wipe
            // remixModalMetadata from plugin state by dispatching a new startRemixThinking
            // without the metadata. Use ref to avoid stale closure.
            if (!isThinkingRef.current) onStartThinking((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? {
                contentType: productIntegration.contentType
            } : undefined);
            return;
        }
        isRemixCancelled.current = true;
        experienceTracker.abort({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            reason: 'User cancelled remix thinking',
            attributes: {
                reason: 'User cancelled remix thinking'
            }
        });
        (0, $16lEl.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: 'User cancelled remix thinking'
            }
        });
        if ((0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) {
            const userPrompt = remixModalMetadataRef.current?.userPrompt;
            const onCancel = remixModalMetadataRef.current?.onCancel;
            if (onCancel && userPrompt) {
                // Abort the AI request so send-message-action.ts fires the paired
                // aiInteraction initiated + dismissed events automatically via AbortError.
                stopRemixing();
                onStopThinking({
                    reopenModal: false
                });
                onCancel();
                return;
            }
        }
        stopRemixing();
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            id: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: 'editor',
                remixSource: 'cancelledRemixThinking',
                originalRemixSource: remixSource,
                product: productConfig.analyticsProductName ?? productConfig.productKey
            }
        });
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true) onStopThinking({
            reopenModal: true
        });
    }, [
        isViewMode,
        experienceTracker,
        onStartThinking,
        onStopThinking,
        productConfig.analyticsProductName,
        productConfig.productKey,
        productIntegration.contentType,
        remixSource,
        resetCompletion,
        stopRemixing,
        resetContext
    ]);
    const onRemixFlowActiveChangeRef = (0, $42omo.useRef)(onRemixFlowActiveChange);
    (0, $42omo.useEffect)(()=>{
        onRemixFlowActiveChangeRef.current = onRemixFlowActiveChange;
    }, [
        onRemixFlowActiveChange
    ]);
    // When thinking stops without completing, treat it as cancellation.
    const previousIsThinking = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        const isImageGenFlow = (0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && !!remixModalMetadataRef.current?.userPrompt;
        const shouldFire = !isImageGenFlow && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') || isImageGenFlow && (0, $dh538.fg)('platform_editor_ai_remix_toolbar');
        if (!isViewMode && previousIsThinking.current && !isThinking && pluginIsComplete !== true && showLocationPicker !== true && !isRemixCancelled.current && shouldFire) onRemixFlowActiveChangeRef.current(false);
        previousIsThinking.current = isThinking;
    }, [
        isThinking,
        pluginIsComplete,
        showLocationPicker,
        isViewMode
    ]);
    // Dismiss the thinking bar when the user stops the remix from the Rovo side chat.
    (0, $42omo.useEffect)(()=>{
        if (isRemixAborted && !isRemixCancelled.current) {
            experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                reason: 'User stopped from Rovo side chat'
            });
            onStopThinking();
        }
    }, [
        isRemixAborted,
        onStopThinking,
        experienceTracker
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error.
    const previousIsRemixError = (0, $42omo.useRef)(isRemixError);
    (0, $42omo.useEffect)(()=>{
        if (!previousIsRemixError.current && isRemixError && !isRemixCancelled.current) {
            const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                error: new Error(errorMessage),
                attributes: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            (0, $16lEl.remixGeneratePreviewExperience).failure({
                metadata: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            onStopThinking({
                reopenModal: true
            });
        }
        previousIsRemixError.current = isRemixError;
    }, [
        experienceTracker,
        isRemixError,
        onStopThinking,
        remixStoreError
    ]);
    // When an error occurs, close the ephemeral preview if open, dismiss the
    // remix UI entirely, and open the sidebar so the user can see the error.
    (0, $42omo.useEffect)(()=>{
        if (!isRemixCancelled.current && isRemixError) {
            if (productIntegration.isRemixPreviewVisible && ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? isViewMode : true)) closeRemixPreview();
            // Use handleModalClose (not onStopThinking) to fully unmount the component
            // and clear isModalOpen. The first error effect already sets reopenModal:true
            // via onStopThinking; using it here alone would leave the progress bar visible.
            handleModalClose();
            productIntegration.toggleConversationAssistant?.('sidebar');
        }
    }, [
        closeRemixPreview,
        handleModalClose,
        isRemixError,
        productIntegration,
        isViewMode
    ]);
    const constructDynamicUiSource = (0, $42omo.useCallback)(async ()=>{
        const localIds = selectedContext?.localIds ?? [];
        const startLocalId = localIds[0] ?? '';
        const endLocalId = localIds[localIds.length - 1] ?? '';
        const fragmentAdf = (0, $60a00ae86ae48300$export$cee0b7c2921c06e1)(selectedContext?.selectionFragment ?? null);
        let fullAdf = {
            type: 'doc',
            version: 1,
            content: []
        };
        if (editorApi) fullAdf = await new Promise((resolve)=>{
            try {
                editorApi.core?.actions?.requestDocument?.((doc)=>{
                    resolve(doc ?? {
                        type: 'doc',
                        version: 1,
                        content: []
                    });
                }, {
                    alwaysFire: true
                });
            } catch  {
                resolve({
                    type: 'doc',
                    version: 1,
                    content: []
                });
            }
        });
        // When the entire page is selected (e.g. cmd+a), selectionFragment is null
        // because ProseMirror's AllSelection does not produce a fragment. Fall back
        // to the full document content so Remix still receives the source it needs.
        const resolvedFragmentAdf = fragmentAdf ?? fullAdf.content;
        return {
            contentType: productIntegration.contentType,
            startLocalId: startLocalId,
            endLocalId: endLocalId,
            startIndex: selectedContext?.startIndex ?? 0,
            endIndex: selectedContext?.endIndex ?? -1,
            fragmentAdf: resolvedFragmentAdf,
            fullAdf: fullAdf
        };
    }, [
        editorApi,
        productIntegration.contentType,
        selectedContext
    ]);
    const onOptionSelect = (0, $42omo.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) {
            setDynamicUiType(type);
            setDynamicUiSubtype(subType);
            setInteractionSource(remixModalMetadata?.interactionSource);
            setAspectRatio(remixModalMetadata?.aspectRatio);
        }
        selectedSubTypeRef.current = subType;
        experienceTracker.updateAttributes({
            name: (0, $16lEl.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType
            }
        });
        (0, $16lEl.remixGeneratePreviewExperience).start();
        (0, $16lEl.remixGeneratePreviewExperience).mark((0, $16lEl.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $16lEl.remixGeneratePreviewExperience).addMetadata({
            product: productConfig.analyticsProductName ?? productConfig.productKey,
            interactionSource: remixModalMetadata?.interactionSource,
            remixType: type,
            remixSubtype: subType,
            entryPoint: 'editor'
        });
        let dynamicUiSource = await constructDynamicUiSource();
        // When the AI Image Generation media-insert tab is the entry point there is
        // no editor selection - the user's typed prompt IS the "highlighted text".
        // Mirror the shape the existing "click Image in Visual aid accordion" flow
        // produces (a doc-ADF with the source content) so the backend image-generation
        // path receives the prompt via dynamicUiSource.fragmentAdf / fullAdf the same
        // way it normally receives selected text.
        if (type === 'image' && userPrompt) {
            const promptDoc = {
                type: 'doc',
                version: 1,
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: userPrompt
                            }
                        ]
                    }
                ]
            };
            dynamicUiSource = {
                contentType: dynamicUiSource?.contentType ?? productIntegration.contentType,
                startLocalId: dynamicUiSource?.startLocalId ?? '',
                endLocalId: dynamicUiSource?.endLocalId ?? '',
                startIndex: dynamicUiSource?.startIndex ?? 0,
                endIndex: dynamicUiSource?.endIndex ?? -1,
                fragmentAdf: promptDoc.content,
                fullAdf: promptDoc
            };
        }
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) setDynamicUiSource(dynamicUiSource);
        sendAIFCPrompt({
            userPrompt: userPrompt,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            dynamicUiSource: dynamicUiSource,
            interactionSource: remixModalMetadata?.interactionSource,
            aspectRatio: remixModalMetadata?.aspectRatio,
            aiFeatureName: remixModalMetadata?.aiFeatureName
        });
    }, [
        setDynamicUiType,
        setDynamicUiSubtype,
        setInteractionSource,
        setAspectRatio,
        constructDynamicUiSource,
        experienceTracker,
        productConfig.analyticsProductName,
        productConfig.productKey,
        productIntegration.contentType,
        remixModalMetadata,
        sendAIFCPrompt,
        setDynamicUiSource
    ]);
    // When a userPrompt is pre-supplied in remixModalMetadata (e.g. from the AI Image Generation
    // submit flow), skip the option-picker modal UI and go straight to processing.
    // The ref guard prevents double-firing if the component re-renders.
    // Must be placed before any early returns to satisfy React hooks rules.
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true)) return;
        if (hasAutoSubmittedRef.current) return;
        const userPrompt = remixModalMetadata?.userPrompt;
        if (!userPrompt) return;
        hasAutoSubmittedRef.current = true;
        onRemixFlowActiveChange(true);
        const autoSubmitType = remixModalMetadata?.dynamicUiType ?? 'custom';
        // When an upstream caller (currently the AI Image Generation media-insert tab)
        // supplies an `imageStyle` (e.g. "watercolors", "photorealistic"), pass it
        // through as the dynamicUiSubtype so the Remix backend can produce images in
        // the requested style. Falls back to "image" when no specific style was picked
        // so the backend always receives an explicit subtype signal.
        const autoSubmitSubType = remixModalMetadata?.imageStyle ?? 'image';
        onOptionSelect({
            type: autoSubmitType,
            subType: autoSubmitSubType,
            userPrompt: userPrompt
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        remixModalMetadata?.userPrompt
    ]);
    $a7908ce97f85643c$var$useOnComplete();
    const submittedUpdateKeyRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (!isViewMode && (0, $dh538.fg)('platform_editor_ai_remix_toolbar')) {
            if (!isThinking || !isUpdate) {
                submittedUpdateKeyRef.current = undefined;
                return;
            }
            const { shouldSubmit: shouldSubmit, updateKey: updateKey } = $a7908ce97f85643c$export$f07319916703112a(historyEntryForUpdate, dynamicUiSubtypeForUpdate, submittedUpdateKeyRef.current);
            if (shouldSubmit) {
                submittedUpdateKeyRef.current = updateKey;
                updateRemixRef.current?.();
            }
        }
    }, [
        isThinking,
        isUpdate,
        historyEntryForUpdate,
        dynamicUiSubtypeForUpdate,
        isViewMode
    ]);
    if (!isViewMode && showLocationPicker && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85a250114ebb5b96$export$378069e28d21ecbf), null);
    // hide the thinking bar when creating the remix in editing mode
    const hideThinkingBar = !isViewMode && isThinking && !isUpdate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iTbK.RemixContainer), {
        hideThinkingBar: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? hideThinkingBar : undefined,
        showProgressBar: (0, $dh538.fg)('platform_editor_maui_jira_updates') && (!(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') || isViewMode),
        isComplete: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? pluginIsComplete : isComplete,
        isThinking: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? isThinking : undefined,
        onCompleteAnimationFinished: (0, $dh538.fg)('platform_editor_ai_remix_toolbar') ? !hideThinkingBar ? onCompleteAnimationFinished : undefined : onCompleteAnimationFinished,
        onClose: handleModalClose,
        onOptionSelect: onOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: productIntegration.isRemixPreviewVisible,
        hiddenOptions: hiddenOptions,
        contentType: productIntegration.contentType,
        autoSubmitUserPrompt: remixModalMetadata?.userPrompt ?? undefined,
        onStopThinking: onStopThinking,
        isRemixEntrance: (0, $dZ8uq.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? !remixModalMetadata?.userPrompt : true
    });
};
const $a7908ce97f85643c$export$9d4c73ad3f5edcd5 = (props)=>{
    // `startRemixThinking` closes the options modal (`isRemixModalOpen` false) while remix
    // is still active. We must keep rendering `RemixContainer` (thinking bar / ephemeral)
    // whenever the editor reports `isThinking`, not only when the modal is open.
    if (!(props.isModalOpen || props.isThinking || props.showLocationPicker && (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading'))) return null;
    const inner = (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36a2a4497f062535$export$93604a1decc87c40), {
        isViewMode: props.isViewMode,
        clearThinkingDecoration: props.clearThinkingDecoration,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        entryPoint: props.entryPoint,
        smartCreationConfig: props.smartCreationConfig,
        smartCreationContext: props.smartCreationContext,
        setThinkingComplete: props.setThinkingComplete,
        finishRemixThinking: props.finishRemixThinking,
        onRemixThinkingCompleteAnimationFinished: props.onRemixThinkingCompleteAnimationFinished,
        showLocationPicker: props.showLocationPicker,
        setShowLocationPicker: props.setShowLocationPicker,
        addHistoryEntry: props.addHistoryEntry,
        addHistoryStackEntry: props.addHistoryStackEntry,
        onVariantUpdateComplete: props.onVariantUpdateComplete,
        onRemixInsertSuccess: props.productIntegration.onRemixInsertSuccess,
        isUpdate: props.isUpdate,
        historyEntryForUpdate: props.historyEntryForUpdate,
        dynamicUiSubtypeForUpdate: props.dynamicUiSubtypeForUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7908ce97f85643c$var$RemixContentComponentInner, {
        clearThinkingDecoration: props.clearThinkingDecoration,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        handleModalClose: props.handleModalClose,
        isModalOpen: props.isModalOpen,
        isComplete: props.isComplete,
        selectedContext: props.selectedContext,
        editorApi: props.editorApi,
        setThinkingComplete: props.setThinkingComplete,
        finishRemixThinking: props.finishRemixThinking,
        onStartThinking: props.onStartThinking,
        onDismissThinkingUi: props.onDismissThinkingUi,
        onStopThinking: props.onStopThinking,
        onRegisterAbortRequest: props.onRegisterAbortRequest,
        remixModalMetadata: props.remixModalMetadata,
        remixSource: props.remixSource,
        isThinking: props.isThinking,
        productIntegration: props.productIntegration,
        productConfig: props.productConfig,
        hiddenOptions: props.hiddenOptions
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a7908ce97f85643c$var$RemixContentComponentInner, {
        clearThinkingDecoration: props.clearThinkingDecoration,
        replaceWhiteboardEmbed: props.replaceWhiteboardEmbed,
        handleModalClose: props.handleModalClose,
        isModalOpen: props.isModalOpen,
        isComplete: props.isComplete,
        selectedContext: props.selectedContext,
        editorApi: props.editorApi,
        setThinkingComplete: props.setThinkingComplete,
        finishRemixThinking: props.finishRemixThinking,
        onStartThinking: props.onStartThinking,
        onDismissThinkingUi: props.onDismissThinkingUi,
        onStopThinking: props.onStopThinking,
        onRegisterAbortRequest: props.onRegisterAbortRequest,
        remixModalMetadata: props.remixModalMetadata,
        remixSource: props.remixSource,
        isThinking: props.isThinking,
        productIntegration: props.productIntegration,
        productConfig: props.productConfig,
        hiddenOptions: props.hiddenOptions
    });
    if (props.remixModalMetadata?.aiFeatureName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.AIMateAnalyticsContext), {
        data: {
            attributes: {
                aiFeatureName: props.remixModalMetadata.aiFeatureName
            }
        }
    }, inner);
    return inner;
};






var $8aF6s = parcelRequire("8aF6s");


var $7aRa9 = parcelRequire("7aRa9");








var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $zCcSI = parcelRequire("zCcSI");


var $cJeDc = parcelRequire("cJeDc");


var $9cZ1w = parcelRequire("9cZ1w");


var $kqIWy = parcelRequire("kqIWy");


var $aSsfA = parcelRequire("aSsfA");

const $cb26a2afd8038e71$var$confluenceProductConfig = {
    productKey: 'confluence',
    analyticsProductName: 'confluence',
    shouldUseEphemeralPreview: (chatMessages)=>{
        for(let i = chatMessages.length - 1; i >= 0; i--){
            const message = chatMessages[i];
            if (message.type === 'ACTION_PREPARE') return message.action ? (0, $3vCSA.isRemixGeneratedFlow)(message.action) : false;
        }
        return false;
    },
    isActionReady: (chatMessages)=>{
        const hasWhiteboard = (0, $cteoa.findLastAssistantAction)(chatMessages, (action)=>action.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || action.key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY)) !== undefined;
        if (hasWhiteboard) return true;
        for(let i = chatMessages.length - 1; i >= 0; i--){
            const message = chatMessages[i];
            if (message.type === 'ACTION_COMPLETE') return true;
            if (message.type === 'HUMAN') return false;
        }
        return false;
    }
};
const $cb26a2afd8038e71$var$useConfluenceProductIntegration = ({ flags: flags })=>{
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { toggleConversationAssistant: toggleAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const onRemixInsertSuccess = (0, $42omo.useCallback)(({ currentConversationId: currentConversationId, remixMetadata: remixMetadata })=>{
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: (0, $cJeDc.FeedbackVariant).AFTER_REMIX_INSERT,
            contentType: contentType,
            contentMode: contentType === 'page' ? pageMode : undefined,
            cloudId: cloudId,
            currentConversationId: currentConversationId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        contentType,
        pageMode,
        cloudId
    ]);
    return (0, $42omo.useMemo)(()=>({
            contentType: contentType ?? 'page',
            isRemixPreviewVisible: showSmartCreationModal,
            onRemixInsertSuccess: onRemixInsertSuccess,
            openRemixPreview: ({ isFloating: isFloating, remixConversationId: remixConversationId })=>{
                openModal({
                    entryPoint: 'dynamicUi',
                    spaceKey: spaceKey ?? undefined,
                    stagingAreaActive: true,
                    isFloating: isFloating,
                    shouldShowBackButton: false,
                    ...remixConversationId && (0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? {
                        remixConversationId: remixConversationId
                    } : {},
                    content: contentId ? {
                        id: contentId,
                        type: contentType ?? 'page',
                        subType: isLivePage ? 'live' : null
                    } : undefined,
                    ...isFloating ? {
                        submitCallback: async ()=>{}
                    } : {}
                });
            },
            closeRemixPreview: closeModal,
            toggleConversationAssistant: (location)=>{
                toggleAssistant(location);
            }
        }), [
        showSmartCreationModal,
        openModal,
        closeModal,
        toggleAssistant,
        spaceKey,
        contentId,
        contentType,
        isLivePage,
        onRemixInsertSuccess
    ]);
};
const $cb26a2afd8038e71$var$useConfig = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $zCcSI.useConversationAssistantConfig)({
        assistanceServiceConfigHeaders: {
            'X-Cloudid': cloudId
        },
        preventAbortRequestsOnStagingModalClose: true
    });
};
// remove this when cleanup platform_editor_ai_remix_in_editor_loading
function $cb26a2afd8038e71$var$useConfigOld() {
    return undefined;
}
const $cb26a2afd8038e71$var$useConfigSafe = (0, $dTb09.conditionalHooksFactory)(()=>(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading'), $cb26a2afd8038e71$var$useConfig, $cb26a2afd8038e71$var$useConfigOld);
const $cb26a2afd8038e71$var$useSmartCreationContext = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: spaceDetail } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        includeSpaceTypeSettings: true
    });
    const context = {
        confluence: {
            space: spaceDetail ? {
                id: spaceDetail.spaceId,
                name: spaceDetail.name,
                // `key` is needed to construct correct whiteboard URLs
                // (`/wiki/spaces/{spaceKey}/whiteboard/...`). Without it,
                // `useOnComplete` falls back to `~{numericSpaceId}`, which
                // the page-level URL routing treats as a personal-space key
                // and resolves to the wrong space.
                key: spaceKey ?? undefined,
                iconPath: spaceDetail.iconPath,
                typeSettings: spaceDetail.typeSettings
            } : undefined,
            parentContent: spaceDetail ? {
                id: spaceDetail.homepage?.id ?? '',
                title: spaceDetail.homepage?.title ?? '',
                contentType: spaceDetail.homepage?.type ?? ''
            } : undefined,
            content: contentId ? {
                id: contentId,
                type: contentType ?? 'page',
                subType: isLivePage ? 'live' : null
            } : undefined
        }
    };
    return context;
};
// remove this when cleanup platform_editor_ai_remix_in_editor_loading
function $cb26a2afd8038e71$var$useSmartCreationContextOld() {
    return undefined;
}
const $cb26a2afd8038e71$var$useSmartCreationContextSafe = (0, $dTb09.conditionalHooksFactory)(()=>(0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading'), $cb26a2afd8038e71$var$useSmartCreationContext, $cb26a2afd8038e71$var$useSmartCreationContextOld);
const $cb26a2afd8038e71$var$PlatformComponentInner = ({ flags: flags, ...props })=>{
    const productIntegration = $cb26a2afd8038e71$var$useConfluenceProductIntegration({
        flags: flags
    });
    const smartCreationConfig = $cb26a2afd8038e71$var$useConfigSafe();
    const smartCreationContext = $cb26a2afd8038e71$var$useSmartCreationContextSafe();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a7908ce97f85643c$export$9d4c73ad3f5edcd5), {
        ...props,
        entryPoint: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? 'dynamicUi' : undefined,
        smartCreationConfig: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? smartCreationConfig : undefined,
        smartCreationContext: (0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading') ? smartCreationContext : undefined,
        productConfig: $cb26a2afd8038e71$var$confluenceProductConfig,
        productIntegration: productIntegration
    });
};
const $cb26a2afd8038e71$var$PlatformComponent = (0, $7aRa9.withFlags)($cb26a2afd8038e71$var$PlatformComponentInner);
const $cb26a2afd8038e71$export$d5658636dc6cb88 = ()=>{
    const Wrapper = (props)=>{
        const { onStopThinking: onStopThinking, isThinking: isThinking, isModalOpen: isModalOpen } = props;
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const isSmartCreationModalOpen = (0, $42omo.useRef)(false);
        (0, $42omo.useLayoutEffect)(()=>{
            if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        }, [
            showSmartCreationModal,
            isThinking,
            onStopThinking
        ]);
        if ((0, $dh538.fg)('platform_editor_ai_remix_in_editor_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb26a2afd8038e71$var$PlatformComponent, props));
        return isModalOpen || isThinking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb26a2afd8038e71$var$PlatformComponent, props)) : null;
    };
    return Wrapper;
};



var $3rRes = parcelRequire("3rRes");


var $koSDQ = parcelRequire("koSDQ");


var $7eOZ4 = parcelRequire("7eOZ4");

const $3c7fc3da09b0bf1b$export$b0964dba0fad52a4 = ()=>{
    if ((0, $dh538.fg)('confluence_malleable_ui_platform_remix')) return (0, $cb26a2afd8038e71$export$d5658636dc6cb88)();
    const Component = ({ handleModalClose: handleModalClose, selectedContext: selectedContext, editorApi: editorApi, onStartThinking: onStartThinking, onStopThinking: onStopThinking, remixModalMetadata: remixModalMetadata, remixSource: remixSource })=>{
        const isRemixCancelled = (0, $42omo.useRef)(false);
        const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
        const openAIFCStagingModalRef = (0, $42omo.useRef)(()=>{});
        const selectedSubTypeRef = (0, $42omo.useRef)(undefined);
        const conversationIdRef = (0, $42omo.useRef)(undefined);
        const { dynamicUiType: dynamicUiType } = (0, $2O3ot.useStagingAreaState)();
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
        const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: onActionReady, resetCompletion: resetCompletion } = (0, $koSDQ.useRemixPreviewFlow)({
            entryPoint: 'editor',
            experienceTracker: experienceTracker,
            dynamicUiType: dynamicUiType,
            selectedSubTypeRef: selectedSubTypeRef,
            openAIFCStagingModalRef: openAIFCStagingModalRef,
            isRemixCancelledRef: isRemixCancelled,
            conversationIdRef: conversationIdRef
        });
        const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, remixStoreError: remixStoreError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
            onActionReady: onActionReady
        });
        openAIFCStagingModalRef.current = openAIFCStagingModal;
        // Abort experience on unmount (overlay closed without selecting an option).
        // Uses a ref so the cleanup always calls the latest tracker reference.
        const experienceTrackerRef = (0, $42omo.useRef)(experienceTracker);
        experienceTrackerRef.current = experienceTracker;
        (0, $42omo.useEffect)(()=>{
            return ()=>{
                experienceTrackerRef.current.abort({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    reason: 'User closed remix overlay',
                    attributes: {
                        reason: 'User closed remix overlay'
                    }
                });
            };
        }, []);
        const onRemixFlowActiveChange = (0, $42omo.useCallback)((active)=>{
            if (active) {
                isRemixCancelled.current = false;
                // Clear stale completion state from any previous flow.
                resetCompletion();
                onStartThinking();
            } else {
                isRemixCancelled.current = true;
                // Abort the current experience before stopping
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    reason: 'User cancelled remix thinking',
                    attributes: {
                        reason: 'User cancelled remix thinking'
                    }
                });
                (0, $16lEl.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: 'User cancelled remix thinking'
                    }
                });
                stopRemixing();
                // Start a new experience for the reopened overlay
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    id: (0, $16lEl.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: 'editor',
                        remixSource: 'cancelledRemixThinking',
                        originalRemixSource: remixSource,
                        product: 'confluence'
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
        }, [
            onStartThinking,
            stopRemixing,
            onStopThinking,
            experienceTracker,
            remixSource,
            resetCompletion
        ]);
        // Fail experience and clean up thinking UI when Rovo encounters an error
        const prevIsRemixError = (0, $42omo.useRef)(isRemixError);
        (0, $42omo.useEffect)(()=>{
            if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
                const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    error: new Error(errorMessage),
                    attributes: {
                        errorType: remixStoreError?.errorType,
                        traceId: remixStoreError?.traceId,
                        errorStatusCode: remixStoreError?.status_code
                    }
                });
                (0, $16lEl.remixGeneratePreviewExperience).failure({
                    metadata: {
                        errorType: remixStoreError?.errorType,
                        traceId: remixStoreError?.traceId
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
            prevIsRemixError.current = isRemixError;
        }, [
            isRemixError,
            remixStoreError,
            onStopThinking,
            experienceTracker
        ]);
        // Dismiss the thinking bar when the user stops the remix from the Rovo side chat.
        (0, $42omo.useEffect)(()=>{
            if (isRemixAborted && !isRemixCancelled.current) {
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).REMIX_START,
                    reason: 'User stopped from Rovo side chat'
                });
                onStopThinking();
            }
        }, [
            isRemixAborted,
            onStopThinking,
            experienceTracker
        ]);
        // When an error occurs during remix, close the thinking bar and ephemeral
        // preview, then open the Rovo chat sidebar so the user can see the error.
        (0, $42omo.useEffect)(()=>{
            if (!isRemixCancelled.current && isRemixError) {
                // Close the ephemeral preview (staging modal) if it is open
                if (showSmartCreationModal) closeAIFCStagingModal();
                // Close the thinking bar and dismiss the remix UI entirely.
                // This mirrors the renderer's onClose() call which unmounts
                // the component and clears isModalOpen. Using handleModalClose
                // instead of onStopThinking because the first error effect
                // sets isModalOpen=true (via reopenModal), and onStopThinking
                // alone only clears isThinking — leaving the component mounted
                // and the progress bar visible.
                handleModalClose();
                // Open the Rovo chat sidebar to display the error information.
                // `openConversationAssistant` is idempotent (no-op if already
                // open), so it is safe to call on every render where
                // `isRemixError` is true — no infinite toggle loop.
                openConversationAssistant('sidebar');
                resetRemixConversationId();
            }
        }, [
            isRemixError,
            showSmartCreationModal,
            closeAIFCStagingModal,
            handleModalClose,
            openConversationAssistant,
            resetRemixConversationId
        ]);
        const constructDynamicUiSource = (0, $42omo.useCallback)(async ()=>{
            const localIds = selectedContext?.localIds ?? [];
            const startLocalId = localIds[0] ?? '';
            const endLocalId = localIds[localIds.length - 1] ?? '';
            const fragmentAdf = (0, $3rRes.filterRemixFragmentNodes)(selectedContext?.selectionFragment ?? null);
            let fullAdf = {
                type: 'doc',
                version: 1,
                content: []
            };
            if (editorApi) fullAdf = await new Promise((resolve)=>{
                try {
                    editorApi.core?.actions?.requestDocument?.((doc)=>{
                        resolve(doc);
                    }, {
                        alwaysFire: true
                    });
                } catch  {
                    resolve({
                        type: 'doc',
                        version: 1,
                        content: []
                    });
                }
            });
            // When the entire page is selected (e.g. cmd+a), selectionFragment is null
            // because ProseMirror's AllSelection does not produce a fragment in the
            // selection context. In that case fall back to the full document content
            // so that Remix still receives the source content it needs.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resolvedFragmentAdf = fragmentAdf ?? fullAdf.content;
            return {
                contentType: 'page',
                startLocalId: startLocalId,
                endLocalId: endLocalId,
                startIndex: selectedContext?.startIndex ?? 0,
                endIndex: selectedContext?.endIndex ?? -1,
                fragmentAdf: resolvedFragmentAdf,
                fullAdf: fullAdf
            };
        }, [
            editorApi,
            selectedContext
        ]);
        const onOptionSelect = (0, $42omo.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
            selectedSubTypeRef.current = subType;
            experienceTracker.updateAttributes({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    remixType: type,
                    remixSubtype: subType
                }
            });
            (0, $16lEl.remixGeneratePreviewExperience).start();
            (0, $16lEl.remixGeneratePreviewExperience).mark((0, $16lEl.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
            (0, $16lEl.remixGeneratePreviewExperience).addMetadata({
                product: 'confluence',
                interactionSource: remixModalMetadata?.interactionSource,
                remixType: type,
                remixSubtype: subType,
                entryPoint: 'editor'
            });
            const dynamicUiSource = await constructDynamicUiSource();
            const conversationChannelId = await sendAIFCPrompt({
                userPrompt: userPrompt,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: remixModalMetadata?.interactionSource
            });
            // Store the conversationId so `useRemixPreviewFlow` can include it as
            // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
            // once `onActionReady` fires.
            conversationIdRef.current = conversationChannelId;
            experienceTracker.updateAttributes({
                name: (0, $16lEl.ExperienceName).REMIX_START,
                attributes: {
                    conversationChannelId: conversationChannelId
                }
            });
        }, [
            constructDynamicUiSource,
            sendAIFCPrompt,
            remixModalMetadata,
            experienceTracker
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iTbK.RemixContainer), {
            onClose: handleModalClose,
            onOptionSelect: onOptionSelect,
            onRemixFlowActiveChange: onRemixFlowActiveChange,
            isEphemeralViewVisible: showSmartCreationModal,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished
        });
    };
    const Wrapper = (props)=>{
        const { onStopThinking: onStopThinking, isThinking: isThinking, isModalOpen: isModalOpen } = props;
        const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
        const isSmartCreationModalOpen = (0, $42omo.useRef)(false);
        (0, $42omo.useLayoutEffect)(()=>{
            // Selected content should remain highlighted throughout the entire flow even when ephemeral modal is open
            // We deselect the content when the ephemeral modal is closed
            if (isSmartCreationModalOpen.current && !showSmartCreationModal && isThinking) onStopThinking();
            isSmartCreationModalOpen.current = showSmartCreationModal;
        }, [
            showSmartCreationModal,
            isThinking,
            onStopThinking
        ]);
        return isModalOpen || isThinking ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : null;
    };
    return Wrapper;
};
module.exports["createRemixContentComponent"] = $3c7fc3da09b0bf1b$export$b0964dba0fad52a4;

});

parcelRegister("3KuNi", function(module, exports) {

let $2bad8e0508ea8946$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2bad8e0508ea8946$var$load("6wr18"),
    $2bad8e0508ea8946$var$load("hhss7"),
    $2bad8e0508ea8946$var$load("ffEVr"),
    $2bad8e0508ea8946$var$load("f0c8J")
]).then(()=>parcelRequire('cZRbu'));

});

parcelRegister("9S1Tm", function(module, exports) {
const $c75bdc33c41f0079$export$e8769618d4e0ed4c = (message)=>message?.content?.message?.message?.id;
// Matches a MAUI app URL of the form `/remix/ui/{appId}` and captures the id.
// The `u` flag is unavailable at the package build target (TS1501).
// eslint-disable-next-line require-unicode-regexp
const $c75bdc33c41f0079$var$MAUI_APP_PATH_REGEX = /\/remix\/ui\/([\w-]+)/;
const $c75bdc33c41f0079$export$43c90c26f1d91120 = (url)=>url ? $c75bdc33c41f0079$var$MAUI_APP_PATH_REGEX.exec(url)?.[1] : undefined;
module.exports["getFinalMessageId"] = $c75bdc33c41f0079$export$e8769618d4e0ed4c;
module.exports["getMauiIdFromUrl"] = $c75bdc33c41f0079$export$43c90c26f1d91120;

});


//# sourceMappingURL=FullPageEditorComponent.e3236753.js.map
